"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expenseData = exports.categoryExpenseData = exports.categoryIncomeData = exports.userInfo = exports.endDate1 = exports.startDate1 = exports.symmetricData = exports.mindMap = exports.data = exports.radialTree = exports.dataBindingTreeView = exports.hierarchicalTreewithmultipleroots = exports.hierarchicalTree = exports.organizationTree = exports.pertChartData = exports.multiParentData = exports.localBindData = exports.keyBoardData = exports.artificialIntelligence = exports.familyData = exports.virtualizationData = exports.species = void 0;
/**
 * Local data for diagram layouts
 */
exports.species = [
    { Name: "Species", fillColor: "#3DD94A" },
    { Name: "Plants", Category: "Species" },
    { Name: "Fungi", Category: "Species" },
    { Name: "Lichens", Category: "Species" },
    { Name: "Animals", Category: "Species" },
    { Name: "Mosses", Category: "Plants" },
    { Name: "Ferns", Category: "Plants" },
    { Name: "Gymnosperms", Category: "Plants" },
    { Name: "Dicotyledens", Category: "Plants" },
    { Name: "Monocotyledens", Category: "Plants" },
    { Name: "Invertebrates", Category: "Animals" },
    { Name: "Vertebrates", Category: "Animals" },
    { Name: "Insects", Category: "Invertebrates" },
    { Name: "Molluscs", Category: "Invertebrates" },
    { Name: "Crustaceans", Category: "Invertebrates" },
    { Name: "Others", Category: "Invertebrates" },
    { Name: "Fish", Category: "Vertebrates" },
    { Name: "Amphibians", Category: "Vertebrates" },
    { Name: "Reptiles", Category: "Vertebrates" },
    { Name: "Birds", Category: "Vertebrates" },
    { Name: "Mammals", Category: "Vertebrates" }
];
exports.virtualizationData = [
    { "Name": "Isiahi Witcomb" },
    { "Name": "Viola Yorkston" },
    { "Name": "Revkah Ebbett" },
    { "Name": "Jakob Pywell" },
    { "Name": "Hank Fice" },
    { "Name": "Tally Bloxsum" },
    { "Name": "Yardley Beasley" },
    { "Name": "Helaina Ludovico" },
    { "Name": "Leroi Tinn" },
    { "Name": "Flory Cordaroy" },
    { "Name": "Vanya Shorland" },
    { "Name": "Micheal Ronnay" },
    { "Name": "Donetta Doore" },
    { "Name": "Alphard Casazza" },
    { "Name": "Chucho Odcroft" },
    { "Name": "Meridith Kalf" },
    { "Name": "Elizabeth Birrane" },
    { "Name": "Cathrin Gerardet" },
    { "Name": "Mimi Molyneaux" },
    { "Name": "Diego Eborn" },
    { "Name": "Shea Mynett" },
    { "Name": "Pincus Glanfield" },
    { "Name": "Kurtis Crawley" },
    { "Name": "Hermina Giovannacci" },
    { "Name": "Alberta Olpin" },
    { "Name": "Derron Wolpert" },
    { "Name": "Zorine Coatts" },
    { "Name": "Gilli McCanny" },
    { "Name": "Keely Braunds" },
    { "Name": "Sula Hartfleet" },
    { "Name": "Sam Bolderoe" },
    { "Name": "Celle Blei" },
    { "Name": "Bertine Bridgwater" },
    { "Name": "Garfield Hickford" },
    { "Name": "Dom Halle" },
    { "Name": "Fidole Willetts" },
    { "Name": "Izaak Densell" },
    { "Name": "Angelica Ricciardello" },
    { "Name": "Bax Roskam" },
    { "Name": "Gilbertine Peddowe" },
    { "Name": "Dagny Chaundy" },
    { "Name": "Donelle Huxton" },
    { "Name": "Edithe Statefield" },
    { "Name": "Harlene Gravener" },
    { "Name": "Davidde Acton" },
    { "Name": "Jakob Pearsey" },
    { "Name": "Gratia Badham" },
    { "Name": "Bili Puffett" },
    { "Name": "Amelita Chastand" },
    { "Name": "Miner Melding" },
    { "Name": "Tades Stagg" },
    { "Name": "Niels Devas" },
    { "Name": "Cairistiona Mulcock" },
    { "Name": "Kayle Withey" },
    { "Name": "Ashil Caldero" },
    { "Name": "Leesa Okill" },
    { "Name": "Lorant Avrahamof" },
    { "Name": "Staci MacKessock" },
    { "Name": "Darline Goodoune" },
    { "Name": "Theadora Gaitley" },
    { "Name": "Pepe Redhole" },
    { "Name": "Katya Jenckes" },
    { "Name": "Toby Whapham" },
    { "Name": "Cherin Tilly" },
    { "Name": "Merrel Attlee" },
    { "Name": "Hallsy Skalls" },
    { "Name": "Felecia Blythe" },
    { "Name": "Maxy Mirfield" },
    { "Name": "Zebedee Atrill" },
    { "Name": "Mead Monkleigh" },
    { "Name": "Tracy McAuslene" },
    { "Name": "Emyle Olenikov" },
    { "Name": "Sharlene Dell Casa" },
    { "Name": "Jens Rathke" },
    { "Name": "Oliy Riddlesden" },
    { "Name": "Taddeusz Palethorpe" },
    { "Name": "Kermit Emblow" },
    { "Name": "Tammara Naptin" },
    { "Name": "Neall Borghese" },
    { "Name": "Dar Topley" },
    { "Name": "Alex Doodson" },
    { "Name": "Lilith Nowakowska" },
    { "Name": "Dean Adao" },
    { "Name": "Sigfrid O'Corr" },
    { "Name": "Kerry Dinneen" },
    { "Name": "Micky Dane" },
    { "Name": "Christie Kelso" },
    { "Name": "Ceil Tomik" },
    { "Name": "Urbanus Froude" },
    { "Name": "Blaire Adshede" },
    { "Name": "Bobbye Forri" },
    { "Name": "Kory Seedull" },
    { "Name": "Esdras Sarsons" },
    { "Name": "Garret Wozencraft" },
    { "Name": "Lorita Tomasi" },
    { "Name": "Hobey Duckerin" },
    { "Name": "Rolph Chalcot" },
    { "Name": "Emera Phythien" },
    { "Name": "Madeline Reisen" },
    { "Name": "Harald Waterhowse" },
    { "Name": "Kirbee Piwall" },
    { "Name": "Tish Roston" },
    { "Name": "Trenna Spofforth" },
    { "Name": "Basia Crispe" },
    { "Name": "Brandie Thurlbourne" },
    { "Name": "Antoine Chang" },
    { "Name": "Orson Stannus" },
    { "Name": "Benson Perrelle" },
    { "Name": "Nannette Ebbetts" },
    { "Name": "Loreen Petley" },
    { "Name": "Sianna McPharlain" },
    { "Name": "Kaylil Gossan" },
    { "Name": "Kendra Godthaab" },
    { "Name": "Keeley Weerdenburg" },
    { "Name": "Gearard Boulsher" },
    { "Name": "Johnna McDonagh" },
    { "Name": "Dolorita Tugwell" },
    { "Name": "Billy Semmence" },
    { "Name": "Joyann Swatton" },
    { "Name": "Zacharie Mesnard" },
    { "Name": "Terri-jo Cranny" },
    { "Name": "Alaine Lewington" },
    { "Name": "Loralyn Dick" },
    { "Name": "Morton Penella" },
    { "Name": "Yurik Friel" },
    { "Name": "Claudian Rentalll" },
    { "Name": "Maribel Hubery" },
    { "Name": "Enrika Connolly" },
    { "Name": "Marina Garmons" },
    { "Name": "Ariel Ege" },
    { "Name": "Denni Georghiou" },
    { "Name": "Humphrey Grinham" },
    { "Name": "Stanley Kolodziej" },
    { "Name": "Malva Aylett" },
    { "Name": "Mair Wolfinger" },
    { "Name": "Tim Kelberer" },
    { "Name": "Fayette Brocket" },
    { "Name": "Neill Cottrill" },
    { "Name": "Louella Tordoff" },
    { "Name": "Sib Winnister" },
    { "Name": "Patrick Megarry" },
    { "Name": "Shelley Rangle" },
    { "Name": "Andonis Napier" },
    { "Name": "Georgia Tatum" },
    { "Name": "Arlena Lebourn" },
    { "Name": "Gannon Pickworth" },
    { "Name": "Kayle Usherwood" },
    { "Name": "Alaine Lenoir" },
    { "Name": "Bambi Tresler" },
    { "Name": "Austina Braddick" },
    { "Name": "Hester Torrent" },
    { "Name": "Dedie Hobson" },
    { "Name": "Linn Caulier" },
    { "Name": "Dulci Enrico" },
    { "Name": "Jeni Rogge" },
    { "Name": "Hyacinthie Caplis" },
    { "Name": "Marielle Limbourne" },
    { "Name": "Kaia Gamil" },
    { "Name": "Lindon Ganforth" },
    { "Name": "Cyndia Possek" },
    { "Name": "Melisande Maxweell" },
    { "Name": "Cornela Dacks" },
    { "Name": "Chick Heale" },
    { "Name": "Worden Vick" },
    { "Name": "Craggy Nower" },
    { "Name": "Minni Gammel" },
    { "Name": "Hanni Danneil" },
    { "Name": "Agathe Earengey" },
    { "Name": "Roddie Samper" },
    { "Name": "Geneva Parratt" },
    { "Name": "Tandie Weatherup" },
    { "Name": "Emmi Reany" },
    { "Name": "Allissa Kleinplac" },
    { "Name": "Kelsey Vaggs" },
    { "Name": "Chad Knobell" },
    { "Name": "Sibelle Wooller" },
    { "Name": "Chic Sirrell" },
    { "Name": "Griswold Kayes" },
    { "Name": "Shirlee Stackbridge" },
    { "Name": "Ashley Ugo" },
    { "Name": "Henriette Lampens" },
    { "Name": "Zaneta Roussell" },
    { "Name": "Celestia Newvell" },
    { "Name": "Morgana Jervoise" },
    { "Name": "Rhodie Pylkynyton" },
    { "Name": "Fonzie Swiers" },
    { "Name": "Bethanne Sainz" },
    { "Name": "Althea Divill" },
    { "Name": "Lucie Syalvester" },
    { "Name": "Gigi Ciani" },
    { "Name": "Joellen Falconbridge" },
    { "Name": "Hollis Vassall" },
    { "Name": "Lindon Glassborow" },
    { "Name": "Lynde Vivers" },
    { "Name": "Gar Scrigmour" },
    { "Name": "Fredek Sporton" },
    { "Name": "Ardath Schottli" },
    { "Name": "Sol Dwane" },
    { "Name": "Gardner Lownsbrough" },
    { "Name": "Lynna Gorstidge" },
    { "Name": "Antonina Berston" },
    { "Name": "Binny Kingsnode" },
    { "Name": "Janeta Noar" },
    { "Name": "Adorne Emett" },
    { "Name": "Jephthah Montfort" },
    { "Name": "Francisco Patillo" },
    { "Name": "Elle Heyball" },
    { "Name": "Gypsy Picott" },
    { "Name": "Karissa Lownie" },
    { "Name": "Nonie Conry" },
    { "Name": "Aurlie Cordrey" },
    { "Name": "Pru Di Maria" },
    { "Name": "Carling Houldin" },
    { "Name": "Leland Hickin" },
    { "Name": "Ediva Wingfield" },
    { "Name": "Stefano Westcot" },
    { "Name": "Marie-jeanne Davidsson" },
    { "Name": "Liv Davydzenko" },
    { "Name": "Bartlett Hartzenberg" },
    { "Name": "Ashia Diplock" },
    { "Name": "Merilee Clapham" },
    { "Name": "Dugald Baszkiewicz" },
    { "Name": "Xerxes Cutford" },
    { "Name": "Marshall Braunton" },
    { "Name": "Sheilah Vannikov" },
    { "Name": "Grazia Tuiller" },
    { "Name": "Tadeo Stonehewer" },
    { "Name": "Tori Hurdman" },
    { "Name": "Susann Schutte" },
    { "Name": "Brendis Aitken" },
    { "Name": "Malvin Stockford" },
    { "Name": "Callie Poulter" },
    { "Name": "Percival Cornillot" },
    { "Name": "Lezlie Rowley" },
    { "Name": "Lilli Rouchy" },
    { "Name": "Rinaldo Goodredge" },
    { "Name": "Pat Gillio" },
    { "Name": "Raynell Rouge" },
    { "Name": "Adelheid Heatley" },
    { "Name": "Kirstin Ayshford" },
    { "Name": "Lotta Gosland" },
    { "Name": "Hope Watchorn" },
    { "Name": "Lissa Corr" },
    { "Name": "Yehudit Grzelewski" },
    { "Name": "Consalve Goburn" },
    { "Name": "Rolland Brewett" },
    { "Name": "Marcelia Musselwhite" },
    { "Name": "Jaquenetta Gillian" },
    { "Name": "Millie Torri" },
    { "Name": "Collie Whetland" },
    { "Name": "Neil Toppin" },
    { "Name": "Brier McKimmey" },
    { "Name": "Rogers Rannigan" },
    { "Name": "Krista Coldrick" },
    { "Name": "Kathe Turnpenny" },
    { "Name": "Shayne Mapstone" },
    { "Name": "Candida Janicki" },
    { "Name": "Patty Klausen" },
    { "Name": "Tuck Brantzen" },
    { "Name": "Kiah Ilieve" },
    { "Name": "Ronni Gibke" },
    { "Name": "Brok Mansford" },
    { "Name": "Kinny Crasford" },
    { "Name": "Adora Martijn" },
    { "Name": "Tamiko Pavier" },
    { "Name": "Billi Mahon" },
    { "Name": "Arlen Smythe" },
    { "Name": "Arvin Lorkins" },
    { "Name": "Fanechka Ruston" },
    { "Name": "Thelma Halms" },
    { "Name": "Bjorn Koopman" },
    { "Name": "Luella Kleiner" },
    { "Name": "Ester Vedishchev" },
    { "Name": "Daveta Chasney" },
    { "Name": "Elsworth Hobell" },
    { "Name": "Brice Moxsom" },
    { "Name": "Jeannie Danelutti" },
    { "Name": "Akim Kohneke" },
    { "Name": "Sanson Cirlos" },
    { "Name": "Court Egger" },
    { "Name": "Evvy Goodfield" },
    { "Name": "Abey Lamport" },
    { "Name": "Melina Lardeur" },
    { "Name": "Flynn Marchant" },
    { "Name": "Karola Vedenyapin" },
    { "Name": "Demetre Masic" },
    { "Name": "Liane Collimore" },
    { "Name": "Vanda Navarre" },
    { "Name": "Alys Ollivier" },
    { "Name": "Dannye Kilday" },
    { "Name": "Bettine Handforth" },
    { "Name": "Shell Lesurf" },
    { "Name": "Raquela Pargetter" },
    { "Name": "Angeline Childers" },
    { "Name": "Allyn Powell" },
    { "Name": "Caz Hyslop" },
    { "Name": "Jesselyn Andriveaux" },
    { "Name": "Ruggiero Isley" },
    { "Name": "Faustine Trillow" },
    { "Name": "Cecil Dudney" },
    { "Name": "Consolata Taggart" }
];
exports.familyData = [
    { Name: "Andrew", branch: "root", spouse: "Maria Anders" },
    { Name: "Janet", spouse: "Nancy Cruz", Category: "Andrew" },
    { Name: "Brian", spouse: "Donald Watt", Category: "Andrew" },
    { Name: "Kathleen", spouse: "Starr Barnette", Category: "Andrew" },
    { Name: "Thomas Hardy", spouse: "Patricia Joe", Category: "Janet" },
    { Name: "Melanie", spouse: "Anne Barnette", Category: "Janet" },
    { Name: "Francisco Yangi", spouse: "Christina kaff", Category: "Brian" },
    {
        Name: "Janine Labrune",
        spouse: "Elizabeth Roel",
        Category: "Thomas Hardy"
    },
    { Name: "Mario Pontes", spouse: "Yoshi Latimer", Category: "Thomas Hardy" },
    { Name: "Peter Citeaux", spouse: "Ann Devoon", Category: "Francisco Yangi" },
    {
        Name: "Martine Rancé",
        spouse: "Elizabeth Mary",
        Category: "Francisco Yangi"
    },
    { Name: "Yang Wang", spouse: "Lino Rodri", Category: "Martine Rancé" },
    { Name: "Philip Cramer", spouse: "Pedro Afonso", Category: "Philip Cramer" }
];
exports.artificialIntelligence = [
    { Name: "Artificial Intelligence", fillColor: "#916DAF", branch: "root" },
    { Name: "Machine Learning", Category: "Artificial Intelligence" },
    {
        Name: "Natural Language Processing (NLP)",
        Category: "Artificial Intelligence"
    },
    { Name: "Speech", Category: "Artificial Intelligence" },
    {
        Name: "Planning, Scheduling and Optimization",
        Category: "Artificial Intelligence"
    },
    { Name: "Robotics", Category: "Artificial Intelligence" },
    { Name: "Vision", Category: "Artificial Intelligence" },
    { Name: " Deep Learning ", Category: "Machine Learning" },
    { Name: "Predictive Analytics ", Category: "Machine Learning" },
    { Name: "Translation ", Category: "Natural Language Processing (NLP)" },
    { Name: "Classification", Category: "Natural Language Processing (NLP)" },
    {
        Name: "Information Extraction",
        Category: "Natural Language Processing (NLP)"
    },
    { Name: "Speech to Text", Category: "Speech" },
    { Name: "Text to Speech", Category: "Speech" },
    { Name: "Image Recognition ", Category: "Vision" },
    { Name: "Machine Vision", Category: "Vision" }
];
exports.keyBoardData = [
    { id: "A", fill: "#3498DB" },
    { id: "B", ancestor: "A", fill: "#E74C3C" },
    { id: "C", ancestor: "A", fill: "#E74C3C" },
    { id: "D", ancestor: "A", fill: "#E74C3C" },
    { id: "E", ancestor: "B", fill: "#F39C12" },
    { id: "F", ancestor: "B", fill: "#F39C12" },
    { id: "G", ancestor: "F", fill: "#8E44AD" },
    { id: "H", ancestor: "F", fill: "#8E44AD" },
    { id: "I", ancestor: "G", fill: "#1E8449" },
    { id: "J", ancestor: "G", fill: "#1E8449" }
];
exports.localBindData = [
    { Id: "parent", Role: "Board", color: "#71AF17" },
    {
        Id: "1",
        Role: "General Manager",
        Manager: "parent",
        ChartType: "right",
        color: "#71AF17"
    },
    {
        Id: "11",
        Role: "Assistant General Manager",
        Manager: "1",
        color: "#71AF17"
    },
    {
        Id: "2",
        Role: "Human Resource Manager",
        Manager: "1",
        ChartType: "right",
        color: "#1859B7"
    },
    { Id: "3", Role: "Trainers", Manager: "2", color: "#2E95D8" },
    { Id: "4", Role: "Recruiting Team", Manager: "2", color: "#2E95D8" },
    { Id: "5", Role: "Finance Asst. Manager", Manager: "2", color: "#2E95D8" },
    {
        Id: "6",
        Role: "Design Manager",
        Manager: "1",
        ChartType: "right",
        color: "#1859B7"
    },
    { Id: "7", Role: "Design Supervisor", Manager: "6", color: "#2E95D8" },
    { Id: "8", Role: "Development Supervisor", Manager: "6", color: "#2E95D8" },
    { Id: "9", Role: "Drafting Supervisor", Manager: "6", color: "#2E95D8" },
    {
        Id: "10",
        Role: "Operations Manager",
        Manager: "1",
        ChartType: "right",
        color: "#1859B7"
    },
    { Id: "11", Role: "Statistics Department", Manager: "10", color: "#2E95D8" },
    { Id: "12", Role: "Logistics Department", Manager: "10", color: "#2E95D8" },
    {
        Id: "16",
        Role: "Marketing Manager",
        Manager: "1",
        ChartType: "right",
        color: "#1859B7"
    },
    { Id: "17", Role: "Overseas Sales Manager", Manager: "16", color: "#2E95D8" },
    { Id: "18", Role: "Petroleum Manager", Manager: "16", color: "#2E95D8" },
    {
        Id: "20",
        Role: "Service Department Manager",
        Manager: "16",
        color: "#2E95D8"
    },
    {
        Id: "21",
        Role: "Quality Control Department",
        Manager: "16",
        color: "#2E95D8"
    }
];
exports.multiParentData = [
    { "Name": "node11", "fillColor": "#e7704c", "border": "#c15433" },
    { "Name": "node12", "ReportingPerson": ["node114"], "fillColor": "#efd46e", "border": "#d6b123" },
    { "Name": "node13", "ReportingPerson": ["node12"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node14", "ReportingPerson": ["node12"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node15", "ReportingPerson": ["node12"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node116", "ReportingPerson": ["node22", "node12"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node16", "ReportingPerson": [], "fillColor": "#14ad85" },
    { "Name": "node17", "ReportingPerson": ["node13", "node14", "node15"], "fillColor": "#659be5", "border": "#3a6eb5" },
    { "Name": "node18", "ReportingPerson": [], "fillColor": "#14ad85" },
    { "Name": "node19", "ReportingPerson": ["node16", "node17", "node18"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node110", "ReportingPerson": ["node16", "node17", "node18"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node111", "ReportingPerson": ["node16", "node17", "node18", "node116"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node21", "fillColor": "#e7704c", "border": "#c15433" },
    { "Name": "node22", "ReportingPerson": ["node114"], "fillColor": "#efd46e", "border": "#d6b123" },
    { "Name": "node23", "ReportingPerson": ["node22"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node24", "ReportingPerson": ["node22"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node25", "ReportingPerson": ["node22"], "fillColor": "#58b087", "border": "#16955e" },
    { "Name": "node26", "ReportingPerson": [], "fillColor": "#14ad85" },
    { "Name": "node27", "ReportingPerson": ["node23", "node24", "node25"], "fillColor": "#659be5", "border": "#3a6eb5" },
    { "Name": "node28", "ReportingPerson": [], "fillColor": "#14ad85" },
    { "Name": "node29", "ReportingPerson": ["node26", "node27", "node28", "node116"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node210", "ReportingPerson": ["node26", "node27", "node28"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node211", "ReportingPerson": ["node26", "node27", "node28"], "fillColor": "#8dbe6c", "border": "#489911" },
    { "Name": "node31", "fillColor": "#e7704c", "border": "#c15433" },
    { "Name": "node114", "ReportingPerson": ["node11", "node21", "node31"], "fillColor": "#f3904a", "border": "#d3722e" }
];
exports.pertChartData = [
    {
        id: "Start Project",
        branch: "root",
        duration: "4",
        startDate: "04/19/2018",
        endDate: " 08/19/2018"
    },
    {
        id: "Design",
        Category: "Start Project",
        duration: "2",
        startDate: "08/20/2018",
        endDate: "10/20/2018"
    },
    {
        id: "Formalize Specification",
        Category: "Start Project",
        duration: "2",
        startDate: "10/21/2018",
        endDate: "12/22/2018"
    },
    {
        id: "Write Documentation",
        Category: "Start Project",
        duration: "1",
        startDate: "12/23/2018",
        endDate: "01/22/2019"
    },
    {
        id: "Release Prototype",
        Category: "Design",
        duration: "1",
        startDate: "01/23/2019",
        endDate: " 02/23/2019"
    },
    {
        id: "Testing",
        Category: ["Formalize Specification", "Release Prototype"],
        duration: "2",
        startDate: "02/24/2019",
        endDate: "04/22/2019"
    },
    {
        id: "Release Project",
        Category: "Release Prototype",
        duration: "1",
        startDate: "04/23/2019",
        endDate: "05/24/2019"
    },
    {
        id: "Review Changes",
        Category: "Write Documentation",
        duration: "1",
        startDate: "05/25/2019",
        endDate: "06/26/2019"
    },
    {
        id: "Publish Documentation",
        Category: "Review Changes",
        duration: "1",
        startDate: "06/21/2019",
        endDate: "07/22/2019"
    },
    {
        id: "Finish",
        Category: ["Publish Documentation", "Release Project"],
        duration: "1",
        startDate: "07/23/2019",
        endDate: "08/24/2019"
    }
];
exports.organizationTree = [
    { Id: "parent", Role: "University President", color: "#822B86" },
    { Id: "1", Role: "Chancellor", Supervision: "parent", color: "#3c418B" },
    { Id: "2", Role: "Vice President", Supervision: "parent", color: "#3c418B" },
    {
        Id: "3",
        Role: "Student Affairs",
        Supervision: "2",
        ChartType: "left",
        color: "#3c418B"
    },
    { Id: "4", Role: "Admin & Finance", Supervision: "2", color: "#3c418B" },
    { Id: "5", Role: "Academics", Supervision: "2", color: "#3c418B" },
    {
        Id: "6",
        Role: "External Relations",
        Supervision: "2",
        ChartType: "right",
        color: "#3c418B"
    },
    {
        Id: "7",
        Role: "Activities and Special events",
        Supervision: "3",
        color: "#267011"
    },
    {
        Id: "8",
        Role: "Educational Service Center",
        Supervision: "3",
        color: "#267011"
    },
    { Id: "9", Role: "Health Care", Supervision: "3", color: "#267011" },
    {
        Id: "10",
        Role: "Housing and Food Service Center",
        Supervision: "3",
        color: "#267011"
    },
    {
        Id: "11",
        Role: "Students Development",
        Supervision: "3",
        color: "#267011"
    },
    { Id: "13", Role: "General Maintenance", Supervision: "4", color: "#267011" },
    { Id: "14", Role: "Budget and Audit", Supervision: "4", color: "#71AF17" },
    { Id: "15", Role: "Human Resources", Supervision: "4", color: "#267011" },
    {
        Id: "16",
        Role: "Information Technology",
        Supervision: "4",
        color: "#71AF17"
    },
    {
        Id: "17",
        Role: "Facilities Management",
        Supervision: "4",
        color: "#267011"
    },
    {
        Id: "117",
        Role: "Environment Maintenance",
        Supervision: "4",
        color: "#71AF17"
    },
    { Id: "217", Role: "Custodial Service", Supervision: "4", color: "#267011" },
    { Id: "18", Role: "Faculties", Supervision: "5", color: "#267011" },
    { Id: "19", Role: "Educational Service", Supervision: "5", color: "#71AF17" },
    { Id: "20", Role: "University Library", Supervision: "5", color: "#267011" },
    { Id: "21", Role: "Center for Planning", Supervision: "5", color: "#71AF17" },
    { Id: "22", Role: "Summer Session", Supervision: "5", color: "#267011" },
    { Id: "23", Role: "Fund Development", Supervision: "6", color: "#71AF17" },
    { Id: "24", Role: "Admission", Supervision: "6", color: "#71AF17" },
    { Id: "25", Role: "Alumini Relations", Supervision: "6", color: "#71AF17" },
    {
        Id: "12",
        Role: "Recruitment & Promotion",
        Supervision: "6",
        color: "#71AF17"
    }
];
exports.hierarchicalTree = [
    { Name: "Diagram", fillColor: "#916DAF" },
    { Name: "Layout", Category: "Diagram" },
    { Name: "Tree Layout", Category: "Layout" },
    { Name: "Organizational Chart", Category: "Layout" },
    { Name: "Hierarchical Tree", Category: "Tree Layout" },
    { Name: "Radial Tree", Category: "Tree Layout" },
    { Name: "Mind Map", Category: "Hierarchical Tree" },
    { Name: "Family Tree", Category: "Hierarchical Tree" },
    { Name: "Management", Category: "Organizational Chart" },
    { Name: "Human Resource", Category: "Management" },
    { Name: "University", Category: "Management" },
    { Name: "Business", Category: "Management" }
];
exports.hierarchicalTreewithmultipleroots = [
    { id: "1", Label: 'Production Manager' },
    { id: "2", Label: 'Control Room', parentId: "1" },
    { id: "3", Label: 'Plant Operator', parentId: "1" },
    { id: "4", Label: 'Foreman', parentId: "2" },
    { id: "5", Label: 'Foreman', parentId: "3" },
    { id: "6", Label: 'Craft Personnel', parentId: "4" },
    { id: "7", Label: 'Craft Personnel', parentId: "4" },
    { id: "8", Label: 'Craft Personnel', parentId: "5" },
    { id: "9", Label: 'Craft Personnel', parentId: "5" },
    { id: "10", Label: 'Administrative Officer' },
    { id: "11", Label: 'Security Supervisor', parentId: "10" },
    { id: "12", Label: 'HR Supervisor', parentId: "10" },
    { id: "13", Label: 'Reception Supervisor', parentId: "10" },
    { id: "14", Label: 'Securities', parentId: "11" },
    { id: "15", Label: 'HR Officer', parentId: "12" },
    { id: "16", Label: 'Receptionist', parentId: "13" },
    { id: "17", Label: 'Maintainence Manager' },
    { id: "18", Label: 'Electrical Supervisor', parentId: "17" },
    { id: "19", Label: 'Mechanical Supervisor', parentId: "17" },
    { id: "20", Label: 'Craft Personnel', parentId: "18" },
    { id: "21", Label: 'Craft Personnel', parentId: "19" },
];
exports.dataBindingTreeView = [
    { Name: "Plant Manager", Id: "1", hasChild: true, expanded: true },
    { Name: "Production Manager", Id: "2", ParentId: "1", hasChild: true, expanded: true },
    { Name: "Control Room", Id: "3", ParentId: "2", hasChild: true, expanded: true },
    { Name: "Foreman1", Id: "4", ParentId: "3", hasChild: true, expanded: true },
    { Name: "Craft Personnel5", Id: "5", ParentId: "4" },
    { Name: "Craft Personnel6", Id: "6", ParentId: "4" },
    { Name: "Plant Operator", Id: "7", ParentId: "2", hasChild: true, expanded: true },
    { Name: "Foreman2", Id: "8", ParentId: "7", hasChild: true, expanded: true },
    { Name: "Craft Personnel7", Id: "9", ParentId: "8" },
    { Name: "Administrative Officer", Id: "10", ParentId: "1" },
    { Name: "Maintenance Manager", Id: "11", ParentId: "1", hasChild: true, expanded: true },
    { Name: "Electrical Supervisor", Id: "12", ParentId: "11", hasChild: true, expanded: true },
    { Name: "Craft Personnel1", Id: "13", ParentId: "12" },
    { Name: "Craft Personnel2", Id: "14", ParentId: "12" },
    { Name: "Mechanical Supervisor", Id: "15", ParentId: "11", hasChild: true, expanded: true },
    { Name: "Craft Personnel3", Id: "16", ParentId: "15" },
    { Name: "Craft Personnel4", Id: "17", ParentId: "15" }
];
exports.radialTree = [
    {
        Id: "parent",
        Name: "Maria Anders",
        Designation: "Managing Director"
    },
    {
        Id: 1,
        Name: "Ana Trujillo",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 2,
        Name: "Lino Rodri",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 3,
        Name: "Philip Cramer",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 4,
        Name: "Pedro Afonso",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 5,
        Name: "Anto Moreno",
        Designation: "Project Lead",
        ReportingPerson: 1
    },
    {
        Id: 6,
        Name: "Elizabeth Roel",
        Designation: "Project Lead",
        ReportingPerson: 1
    },
    {
        Id: 7,
        Name: "Aria Cruz",
        Designation: "Project Lead",
        ReportingPerson: 1
    },
    {
        Id: 8,
        Name: "Eduardo Roel",
        Designation: "Project Lead",
        ReportingPerson: 1
    },
    {
        Id: 9,
        Name: "Howard Snyd",
        Designation: "Project Lead",
        ReportingPerson: 2
    },
    {
        Id: 10,
        Name: "Daniel Tonini",
        Designation: "Project Lead",
        ReportingPerson: 2
    },
    {
        Id: 11,
        Name: "Nardo Batista",
        Designation: "Project Lead",
        ReportingPerson: 89
    },
    {
        Id: 12,
        Name: "Michael Holz",
        Designation: "Project Lead",
        ReportingPerson: 89
    },
    {
        Id: 13,
        Name: "Kloss Perrier",
        Designation: "Project Lead",
        ReportingPerson: 90
    },
    {
        Id: 14,
        Name: "Liz Nixon",
        Designation: "Project Lead",
        ReportingPerson: 3
    },
    {
        Id: 15,
        Name: "Paul Henriot",
        Designation: "Project Lead",
        ReportingPerson: 3
    },
    {
        Id: 16,
        Name: "Paula Parente",
        Designation: "Project Lead",
        ReportingPerson: 90
    },
    {
        Id: 17,
        Name: "Matti Kenna",
        Designation: "Project Lead",
        ReportingPerson: 4
    },
    {
        Id: 18,
        Name: "Laura Callahan",
        Designation: "Project Lead",
        ReportingPerson: 4
    },
    {
        Id: 19,
        Name: "Simon Roel",
        Designation: "Project Lead",
        ReportingPerson: 4
    },
    {
        Id: 20,
        Name: "Thomas Hardy",
        Designation: "Senior S/w Engg",
        ReportingPerson: 12
    },
    {
        Id: 21,
        Name: "Martín Kloss",
        Designation: "Senior S/w Engg",
        ReportingPerson: 5
    },
    {
        Id: 23,
        Name: "Diego Roel",
        Designation: "Senior S/w Engg",
        ReportingPerson: 7
    },
    {
        Id: 24,
        Name: "José Pedro ",
        Designation: "Senior S/w Engg",
        ReportingPerson: 8
    },
    {
        Id: 25,
        Name: "Manu Pereira",
        Designation: "Senior S/w Engg",
        ReportingPerson: 8
    },
    {
        Id: 26,
        Name: "Annette Roel",
        Designation: "Senior S/w Engg",
        ReportingPerson: 25
    },
    {
        Id: 27,
        Name: "Catherine Kaff",
        Designation: "Senior S/w Engg",
        ReportingPerson: 8
    },
    {
        Id: 28,
        Name: "Lúcia Carvalho",
        Designation: "Senior S/w Engg",
        ReportingPerson: 12
    },
    {
        Id: 29,
        Name: "Alej Camino",
        Designation: "Senior S/w Engg",
        ReportingPerson: 13
    },
    {
        Id: 30,
        Name: "Liu Wong",
        Designation: "Senior S/w Engg",
        ReportingPerson: 14
    },
    {
        Id: 31,
        Name: "Karin Josephs",
        Designation: "Senior S/w Engg",
        ReportingPerson: 14
    },
    {
        Id: 33,
        Name: "Pirkko King",
        Designation: "Senior S/w Engg",
        ReportingPerson: 17
    },
    {
        Id: 34,
        Name: "Karl Jablonski",
        Designation: "Senior S/w Engg",
        ReportingPerson: 18
    },
    {
        Id: 35,
        Name: "Zbyszek Yang",
        Designation: "Senior S/w Engg",
        ReportingPerson: 19
    },
    {
        Id: 36,
        Name: "Nancy",
        Designation: "Senior S/w Engg",
        ReportingPerson: 5
    },
    {
        Id: 37,
        Name: "Anne",
        Designation: "Senior S/w Engg",
        ReportingPerson: 6
    },
    {
        Id: 38,
        Name: "Isabel Castro",
        Designation: "Senior S/w Engg",
        ReportingPerson: 7
    },
    {
        Id: 39,
        Name: "Nardo Batista",
        Designation: "Senior S/w Engg",
        ReportingPerson: 9
    },
    {
        Id: 40,
        Name: "Rene Phillips",
        Designation: "Senior S/w Engg",
        ReportingPerson: 16
    },
    {
        Id: 41,
        Name: "Rita Pfalzheim",
        Designation: "Senior S/w Engg",
        ReportingPerson: 9
    },
    {
        Id: 42,
        Name: "Janete Limeira",
        Designation: "Senior S/w Engg",
        ReportingPerson: 11
    },
    {
        Id: 43,
        Name: "Christina kaff",
        Designation: "S/w Engg",
        ReportingPerson: 20
    },
    {
        Id: 44,
        Name: "Peter Franken",
        Designation: "S/w Engg",
        ReportingPerson: 21
    },
    {
        Id: 45,
        Name: "Carlos Schmitt",
        Designation: "S/w Engg",
        ReportingPerson: 23
    },
    {
        Id: 46,
        Name: "Yoshi Wilson",
        Designation: "S/w Engg",
        ReportingPerson: 23
    },
    {
        Id: 47,
        Name: "Jean Fresnière",
        Designation: "S/w Engg",
        ReportingPerson: 24
    },
    {
        Id: 48,
        Name: "Simon Roel",
        Designation: "S/w Engg",
        ReportingPerson: 25
    },
    {
        Id: 52,
        Name: "Palle Ibsen",
        Designation: "S/w Engg",
        ReportingPerson: 29
    },
    {
        Id: 53,
        Name: "Lúcia Carvalho",
        Designation: "S/w Engg",
        ReportingPerson: 30
    },
    {
        Id: 54,
        Name: "Hanna Moos",
        Designation: "Project Trainee",
        ReportingPerson: 30
    },
    {
        Id: 55,
        Name: "Peter Citeaux",
        Designation: "Project Trainee",
        ReportingPerson: 33
    },
    {
        Id: 56,
        Name: "Elizabeth Mary",
        Designation: "Project Trainee",
        ReportingPerson: 33
    },
    {
        Id: 57,
        Name: "Victoria Ash",
        Designation: "Project Trainee",
        ReportingPerson: 34
    },
    {
        Id: 58,
        Name: "Janine Labrune",
        Designation: "Project Trainee",
        ReportingPerson: 35
    },
    {
        Id: 60,
        Name: "Carine Schmitt",
        Designation: "Project Trainee",
        ReportingPerson: 11
    },
    {
        Id: 61,
        Name: "Paolo Accorti",
        Designation: "Project Trainee",
        ReportingPerson: 38
    },
    {
        Id: 62,
        Name: "André Fonseca",
        Designation: "Project Trainee",
        ReportingPerson: 41
    },
    {
        Id: 63,
        Name: "Mario Pontes",
        Designation: "Project Trainee",
        ReportingPerson: 6
    },
    {
        Id: 64,
        Name: "John Steel",
        Designation: "Project Trainee",
        ReportingPerson: 7
    },
    {
        Id: 65,
        Name: "Renate Jose",
        Designation: "Project Trainee",
        ReportingPerson: 42
    },
    {
        Id: 66,
        Name: "Jaime Yorres",
        Designation: "Project Trainee",
        ReportingPerson: 20
    },
    {
        Id: 67,
        Name: "Alex Feuer",
        Designation: "Project Trainee",
        ReportingPerson: 21
    },
    {
        Id: 70,
        Name: "Helen Marie",
        Designation: "Project Trainee",
        ReportingPerson: 24
    },
    {
        Id: 73,
        Name: "Sergio roel",
        Designation: "Project Trainee",
        ReportingPerson: 37
    },
    {
        Id: 75,
        Name: "Janete Limeira",
        Designation: "Project Trainee",
        ReportingPerson: 29
    },
    {
        Id: 76,
        Name: "Jonas Bergsen",
        Designation: "Project Trainee",
        ReportingPerson: 18
    },
    {
        Id: 77,
        Name: "Miguel Angel",
        Designation: "Project Trainee",
        ReportingPerson: 18
    },
    {
        Id: 80,
        Name: "Helvetis Nagy",
        Designation: "Project Trainee",
        ReportingPerson: 34
    },
    {
        Id: 81,
        Name: "Rita Müller",
        Designation: "Project Trainee",
        ReportingPerson: 35
    },
    {
        Id: 82,
        Name: "Georg Pipps",
        Designation: "Project Trainee",
        ReportingPerson: 36
    },
    {
        Id: 83,
        Name: "Horst Kloss",
        Designation: "Project Trainee",
        ReportingPerson: 37
    },
    {
        Id: 84,
        Name: "Paula Wilson",
        Designation: "Project Trainee",
        ReportingPerson: 38
    },
    {
        Id: 85,
        Name: " Jose Michael",
        Designation: "Project Trainee",
        ReportingPerson: 37
    },
    {
        Id: 86,
        Name: "Mauri Moroni",
        Designation: "Project Trainee",
        ReportingPerson: 40
    },
    {
        Id: 87,
        Name: "Michael Holz",
        Designation: "Project Trainee",
        ReportingPerson: 41
    },
    {
        Id: 88,
        Name: "Alej Camino",
        Designation: "Project Trainee",
        ReportingPerson: 42
    },
    {
        Id: 89,
        Name: "Jytte Petersen",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 90,
        Name: "Mary Saveley",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 91,
        Name: "Robert King",
        Designation: "Project Manager",
        ReportingPerson: "parent"
    },
    {
        Id: 95,
        Name: "Roland Mendel",
        Designation: "CSR",
        ReportingPerson: 19
    },
    {
        Id: 98,
        Name: "Helen Bennett",
        Designation: "SR",
        ReportingPerson: 42
    },
    {
        Id: 99,
        Name: "Carlos Nagy",
        Designation: "SR",
        ReportingPerson: 42
    },
    {
        Id: 100,
        Name: "Felipe Kloss",
        Designation: "SR",
        ReportingPerson: 77
    }
];
/**
 * Local data for diagram layouts
 */
exports.data = [
    {
        Id: "parent",
        Name: "Maria Anders",
        Designation: "Managing Director",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "true",
        RatingColor: "#C34444"
    },
    {
        Id: 1,
        Name: "Ana Trujillo",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: "parent"
    },
    {
        Id: 2,
        Name: "Anto Moreno",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 1
    },
    {
        Id: 3,
        Name: "Thomas Hardy",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 2
    },
    {
        Id: 4,
        Name: "Christina kaff",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 3
    },
    {
        Id: 5,
        Name: "Hanna Moos",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "true",
        RatingColor: "#D46E89",
        ReportingPerson: 4
    },
    {
        Id: 6,
        Name: "Peter Citeaux",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 5
    },
    {
        Id: 7,
        Name: "Martín Kloss",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 6
    },
    {
        Id: 8,
        Name: "Elizabeth Mary",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 6
    },
    {
        Id: 9,
        Name: "Victoria Ash",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 5
    },
    {
        Id: 10,
        Name: "Francisco Yang",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 3
    },
    {
        Id: 11,
        Name: "Yang Wang",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: "parent"
    },
    {
        Id: 12,
        Name: "Lino Rodri",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 11
    },
    {
        Id: 13,
        Name: "Philip Cramer",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 24
    },
    {
        Id: 14,
        Name: "Pedro Afonso",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Paul.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 15
    },
    {
        Id: 15,
        Name: "Elizabeth Roel",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Maria.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 13
    },
    {
        Id: 16,
        Name: "Janine Labrune",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 12
    },
    {
        Id: 17,
        Name: "Ann Devon",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 25
    },
    {
        Id: 18,
        Name: "Roland Mendel",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 17
    },
    {
        Id: 19,
        Name: "Aria Cruz",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 18
    },
    {
        Id: 20,
        Name: "Martine Rancé",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 18
    },
    {
        Id: 21,
        Name: "Maria Larsson",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "false",
        RatingColor: "#EBB92E",
        ReportingPerson: 19
    },
    {
        Id: 22,
        Name: "Diego Roel",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "false",
        RatingColor: "#D46E89",
        ReportingPerson: 21
    },
    {
        Id: 23,
        Name: "Peter Franken",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 21
    },
    {
        Id: 24,
        Name: "Howard Snyder",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 16
    },
    {
        Id: 25,
        Name: "Carine Schmitt",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: "parent"
    },
    {
        Id: 26,
        Name: "Paolo Accorti",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 36
    },
    {
        Id: 27,
        Name: "Eduardo Roel",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "true",
        RatingColor: "#93B85A",
        ReportingPerson: 26
    },
    {
        Id: 28,
        Name: "José Pedro ",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "true",
        RatingColor: "#D46E89",
        ReportingPerson: 27
    },
    {
        Id: 29,
        Name: "André Fonseca",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/John.png",
        IsExpand: "true",
        RatingColor: "#EBB92E",
        ReportingPerson: 28
    },
    {
        Id: 30,
        Name: "Howard Snyd",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 29
    },
    {
        Id: 31,
        Name: "Manu Pereira",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image56.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 29
    },
    {
        Id: 32,
        Name: "Mario Pontes",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 29
    },
    {
        Id: 33,
        Name: "Carlos Schmitt",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 29
    },
    {
        Id: 34,
        Name: "Yoshi Latimer",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/eric.png",
        IsExpand: "true",
        RatingColor: "#D46E89",
        ReportingPerson: 29
    },
    {
        Id: 35,
        Name: "Patricia Kenna",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Maria.png",
        IsExpand: "true",
        RatingColor: "#EBB92E",
        ReportingPerson: 29
    },
    {
        Id: 36,
        Name: "Helen Bennett",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 25
    },
    {
        Id: 37,
        Name: "Daniel Tonini",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "true",
        RatingColor: "#93B85A",
        ReportingPerson: "parent"
    },
    {
        Id: 38,
        Name: "Annette Roel",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 37
    },
    {
        Id: 39,
        Name: "Yoshi Wilson",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "false",
        RatingColor: "#EBB92E",
        ReportingPerson: 38
    },
    {
        Id: 40,
        Name: "John Steel",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Maria.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 38
    },
    {
        Id: 41,
        Name: "Renate Jose",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 40
    },
    {
        Id: 42,
        Name: "Jaime Yorres",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 41
    },
    {
        Id: 43,
        Name: "Carlos Nagy",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 42
    },
    {
        Id: 44,
        Name: "Felipe Kloss",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "false",
        RatingColor: "#EBB92E",
        ReportingPerson: 43
    },
    {
        Id: 45,
        Name: "Fran Wilson",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 43
    },
    {
        Id: 46,
        Name: "John Rovelli",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 43
    },
    {
        Id: 47,
        Name: "Catherine Kaff",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 43
    },
    {
        Id: 48,
        Name: "Jean Fresnière",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#D46E89",
        ReportingPerson: 43
    },
    {
        Id: 49,
        Name: "Alex Feuer",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 43
    },
    {
        Id: 50,
        Name: "Simon Roel",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 42
    },
    {
        Id: 51,
        Name: "Yvonne Wong",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 52
    },
    {
        Id: 52,
        Name: "Rene Phillips",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 39
    },
    {
        Id: 53,
        Name: "Yoshi Kenna",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "false",
        RatingColor: "#EBB92E",
        ReportingPerson: 52
    },
    {
        Id: 54,
        Name: "Helen Marie",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "true",
        RatingColor: "#EBB92E",
        ReportingPerson: 52
    },
    {
        Id: 55,
        Name: "Joseph Kaff",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 52
    },
    {
        Id: 56,
        Name: "Georg Pipps",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 57
    },
    {
        Id: 57,
        Name: "Nardo Batista",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Maria.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 12
    },
    {
        Id: 58,
        Name: "Lúcia Carvalho",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 57
    },
    {
        Id: 59,
        Name: "Horst Kloss",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#68C2DE",
        ReportingPerson: 57
    },
    {
        Id: 60,
        Name: "Sergio roel",
        Designation: "CSR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 57
    },
    {
        Id: 61,
        Name: "Paula Wilson",
        Designation: "CSR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/eric.png",
        IsExpand: "None",
        RatingColor: "#68C2DE",
        ReportingPerson: 57
    },
    {
        Id: 62,
        Name: "Mauri Moroni",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 57
    },
    {
        Id: 63,
        Name: "Janete Limeira",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 57
    },
    {
        Id: 64,
        Name: "Michael Holz",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 57
    },
    {
        Id: 65,
        Name: "Alej Camino",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: "parent"
    },
    {
        Id: 66,
        Name: "Jonas Bergsen",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#68C2DE",
        ReportingPerson: 65
    },
    {
        Id: 67,
        Name: "Jose Pavarotti",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Maria.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 68
    },
    {
        Id: 68,
        Name: "Miguel Angel",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/eric.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 66
    },
    {
        Id: 69,
        Name: "Jytte Petersen",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "true",
        RatingColor: "#68C2DE",
        ReportingPerson: 68
    },
    {
        Id: 70,
        Name: "Kloss Perrier",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 72
    },
    {
        Id: 71,
        Name: "Art Nancy",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "true",
        RatingColor: "#D46E89",
        ReportingPerson: 27
    },
    {
        Id: 72,
        Name: "Pascal Cartrain",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/John.png",
        IsExpand: "true",
        RatingColor: "#EBB92E",
        ReportingPerson: 65
    },
    {
        Id: 73,
        Name: "Liz Nixon",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 68
    },
    {
        Id: 74,
        Name: "Liu Wong",
        Designation: "Project Manager",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: "parent"
    },
    {
        Id: 75,
        Name: "Karin Josephs",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 74
    },
    {
        Id: 76,
        Name: "Ruby Anabela ",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 75
    },
    {
        Id: 77,
        Name: "Helvetis Nagy",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 82
    },
    {
        Id: 78,
        Name: "Palle Ibsen",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image51.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 76
    },
    {
        Id: 79,
        Name: "Mary Saveley",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "false",
        RatingColor: "#93B85A",
        ReportingPerson: 82
    },
    {
        Id: 80,
        Name: "Paul Henriot",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "false",
        RatingColor: "#D46E89",
        ReportingPerson: 79
    },
    {
        Id: 81,
        Name: "Rita Müller",
        Designation: "SR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Paul.png",
        IsExpand: "None",
        RatingColor: "#68C2DE",
        ReportingPerson: 79
    },
    {
        Id: 82,
        Name: "Pirkko King",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 78
    },
    {
        Id: 83,
        Name: "Paula Parente",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/John.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 75
    },
    {
        Id: 84,
        Name: "Karl Jablonski",
        Designation: "S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 83
    },
    {
        Id: 34,
        Name: "Matti Kenna",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Jenny.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 84
    },
    {
        Id: 35,
        Name: "Zbyszek Yang",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 84
    },
    {
        Id: 85,
        Name: "Nancy",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image56.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 74
    },
    {
        Id: 86,
        Name: "Robert King",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "true",
        RatingColor: "#D46E89",
        ReportingPerson: 85
    },
    {
        Id: 87,
        Name: "Laura Callahan",
        Designation: "CSR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Robin.png",
        IsExpand: "false",
        RatingColor: "#D46E89",
        ReportingPerson: 88
    },
    {
        Id: 88,
        Name: "Anne",
        Designation: "CSR",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 86
    },
    {
        Id: 89,
        Name: "Georg Pipps",
        Designation: "Senior S/w Engg",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image53.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: "parent"
    },
    {
        Id: 30,
        Name: "Isabel Castro",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 89
    },
    {
        Id: 34,
        Name: "Nardo Batista",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image57.png",
        IsExpand: "None",
        RatingColor: "#EBB92E",
        ReportingPerson: 88
    },
    {
        Id: 90,
        Name: "Rene Phillips",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/image55.png",
        IsExpand: "false",
        RatingColor: "#68C2DE",
        ReportingPerson: 89
    },
    {
        Id: 91,
        Name: "Lúcia Carvalho",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Thomas.png",
        IsExpand: "None",
        RatingColor: "#93B85A",
        ReportingPerson: 89
    },
    {
        Id: 92,
        Name: "Horst Kloss",
        Designation: "Project Trainee",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Paul.png",
        IsExpand: "None",
        RatingColor: "#D46E89",
        ReportingPerson: 89
    },
    {
        Id: 93,
        Name: "Simon Roel",
        Designation: "Project Lead",
        ImageUrl: "https://ej2.syncfusion.com/vue/demos/src/diagram/employees/Clayton.png",
        IsExpand: "true",
        RatingColor: "#93B85A",
        ReportingPerson: 98
    }
];
exports.mindMap = [
    { id: 1, Label: "Creativity", fill: "red", branch: "Root" },
    { id: 3, Label: "Brainstorming", parentId: 1, branch: "Right", fill: "red" },
    { id: 4, Label: "Complementing", parentId: 1, branch: "Left", fill: "red" },
    { id: 22, Label: "Sessions", parentId: 3, branch: "subRight", fill: "red" },
    { id: 23, Label: "Generate", parentId: 3, branch: "subRight", fill: "red" },
    { id: 25, Label: "Local", parentId: 22, branch: "subRight" },
    { id: 26, Label: "Remote", parentId: 22, branch: "subRight" },
    { id: 27, Label: "Individual", parentId: 22, branch: "subRight" },
    { id: 28, Label: "Teams", parentId: 22, branch: "subRight" },
    { id: 29, Label: "Ideas", parentId: 23, branch: "subRight" },
    { id: 30, Label: "Engagement", parentId: 23, branch: "subRight" },
    { id: 31, Label: "Product", parentId: 29, branch: "subRight" },
    { id: 32, Label: "Service", parentId: 29, branch: "subRight" },
    { id: 33, Label: "Business Direction", parentId: 29, branch: "subRight" },
    { id: 34, Label: "Empowering", parentId: 30, branch: "subRight" },
    { id: 35, Label: "Ownership", parentId: 30, branch: "subRight" },
    { id: 50, Label: "Information", parentId: 4, branch: "subLeft" },
    { id: 51, Label: "Expectations", parentId: 4, branch: "subLeft" },
    { id: 53, Label: "Competetors", parentId: 50, branch: "subLeft" },
    { id: 54, Label: "Products", parentId: 50, branch: "subLeft" },
    { id: 55, Label: "Features", parentId: 50, branch: "subLeft" },
    { id: 56, Label: "Other Data", parentId: 50, branch: "subLeft" },
    { id: 59, Label: "Organization", parentId: 51, branch: "subLeft" },
    { id: 60, Label: "Customer", parentId: 51, branch: "subLeft" },
    { id: 61, Label: "Staff", parentId: 51, branch: "subLeft" },
    { id: 62, Label: "Stakeholders", parentId: 51, branch: "subLeft" }
];
exports.symmetricData = [
    {
        Id: "parent",
        Type: "Server"
    },
    {
        Id: 1,
        Source: "parent",
        Type: "Server"
    },
    {
        Id: 2,
        Source: "parent",
        Type: "Server"
    },
    {
        Id: 3,
        Source: "parent",
        Type: "Server"
    },
    {
        Id: 4,
        Source: "parent",
        Type: "Server"
    },
    {
        Id: 5,
        Source: "parent",
        Type: "Hub"
    },
    {
        Id: 6,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 7,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 8,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 9,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 10,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 11,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 12,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 13,
        Source: 1,
        Type: "Hub"
    },
    {
        Id: 14,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 15,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 16,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 17,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 18,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 19,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 20,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 21,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 22,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 23,
        Source: 2,
        Type: "Hub"
    },
    {
        Id: 24,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 25,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 26,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 27,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 28,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 29,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 30,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 31,
        Source: 3,
        Type: "Hub"
    },
    {
        Id: 32,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 33,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 34,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 35,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 36,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 37,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 38,
        Source: 4,
        Type: "Hub"
    },
    {
        Id: 39,
        Source: 4,
        Type: "Hub"
    }
];
exports.startDate1 = new Date('2017-05-31T12:30:00-06:00');
exports.endDate1 = new Date('2017-11-30T12:30:00-06:00');
exports.userInfo = {
    'FirstName': 'Nicholas',
    'FullName': 'Nicholas Delacruz',
    'Email': 'nicholas@gmail.com'
};
exports.categoryIncomeData = [
    { Class: 'category-icon Salary', Category: 'Salary', Id: 'Salary' },
    { Class: 'category-icon Interests', Category: 'Interests', Id: 'Interests' },
    { Class: 'category-icon Business', Category: 'Business', Id: 'Business' },
    { Class: 'category-icon Extra income', Category: 'Extra income', Id: 'Extra income' }
];
exports.categoryExpenseData = [
    { Class: 'category-icon Rent', Category: 'Rent', Id: 'Rent' },
    { Class: 'category-icon Food', Category: 'Food', Id: 'Food' },
    { Class: 'category-icon Bills', Category: 'Bills', Id: 'Bills' },
    { Class: 'category-icon Utilities', Category: 'Utilities', Id: 'Utilities' },
    { Class: 'category-icon Transportation', Category: 'Transportation', Id: 'Transportation' },
    { Class: 'category-icon Insurance', Category: 'Insurance', Id: 'Insurance' },
    { Class: 'category-icon Shopping', Category: 'Shopping', Id: 'Shopping' },
    { Class: 'category-icon Entertainment', Category: 'Entertainment', Id: 'Entertainment' },
    { Class: 'category-icon Health Care', Category: 'Health Care', Id: 'Health Care' },
    { Class: 'category-icon Housing', Category: 'Housing', Id: 'Housing' },
    { Class: 'category-icon Taxes', Category: 'Taxes', Id: 'Taxes' },
    { Class: 'category-icon Clothing', Category: 'Clothing', Id: 'Clothing' },
    { Class: 'category-icon Education', Category: 'Education', Id: 'Education' },
    { Class: 'category-icon Miscellaneous', Category: 'Miscellaneous', Id: 'Miscellaneous' },
    { Class: 'category-icon Personal Care', Category: 'Personal Care', Id: 'Personal Care' }
];
exports.expenseData = [{
    'UniqueId': 'T100001',
    'DateTime': new Date(1496288520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 09:12 AM'
}, {
    'UniqueId': 'T100002',
    'DateTime': new Date(1496308620000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 02:47 PM'
}, {
    'UniqueId': 'T100003',
    'DateTime': new Date(1496330580000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 08:53 PM'
}, {
    'UniqueId': 'T100004',
    'DateTime': new Date(1496294040000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 10:44 AM'
}, {
    'UniqueId': 'T100005',
    'DateTime': new Date(1496310900000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 03:25 PM'
}, {
    'UniqueId': 'T100006',
    'DateTime': new Date(1496310480000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '155',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 03:18 PM'
}, {
    'UniqueId': 'T100007',
    'DateTime': new Date(1496312340000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 03:49 PM'
}, {
    'UniqueId': 'T100008',
    'DateTime': new Date(1496311500000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '6000',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/01/2017 03:35 PM'
}, {
    'UniqueId': 'T100009',
    'DateTime': new Date(1496376540000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 09:39 AM'
}, {
    'UniqueId': 'T100010',
    'DateTime': new Date(1496394900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 02:45 PM'
}, {
    'UniqueId': 'T100011',
    'DateTime': new Date(1496414460000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 08:11 PM'
}, {
    'UniqueId': 'T100012',
    'DateTime': new Date(1496378460000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 10:11 AM'
}, {
    'UniqueId': 'T100013',
    'DateTime': new Date(1496397300000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 03:25 PM'
}, {
    'UniqueId': 'T100014',
    'DateTime': new Date(1496411340000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '150',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 07:19 PM'
}, {
    'UniqueId': 'T100015',
    'DateTime': new Date(1496411160000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '25',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/02/2017 07:16 PM'
}, {
    'UniqueId': 'T100016',
    'DateTime': new Date(1496461320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 09:12 AM'
}, {
    'UniqueId': 'T100017',
    'DateTime': new Date(1496480700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 02:35 PM'
}, {
    'UniqueId': 'T100018',
    'DateTime': new Date(1496502480000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 08:38 PM'
}, {
    'UniqueId': 'T100019',
    'DateTime': new Date(1496465520000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 10:22 AM'
}, {
    'UniqueId': 'T100020',
    'DateTime': new Date(1496483460000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 03:21 PM'
}, {
    'UniqueId': 'T100021',
    'DateTime': new Date(1496481300000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '350',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 02:45 PM'
}, {
    'UniqueId': 'T100022',
    'DateTime': new Date(1496480220000),
    'Category': 'Bills',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '220',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/03/2017 02:27 PM'
}, {
    'UniqueId': 'T100023',
    'DateTime': new Date(1496549160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 09:36 AM'
}, {
    'UniqueId': 'T100024',
    'DateTime': new Date(1496567580000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 02:43 PM'
}, {
    'UniqueId': 'T100025',
    'DateTime': new Date(1496588700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 08:35 PM'
}, {
    'UniqueId': 'T100026',
    'DateTime': new Date(1496552100000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 10:25 AM'
}, {
    'UniqueId': 'T100027',
    'DateTime': new Date(1496571900000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 03:55 PM'
}, {
    'UniqueId': 'T100028',
    'DateTime': new Date(1496551920000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '160',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 10:22 AM'
}, {
    'UniqueId': 'T100029',
    'DateTime': new Date(1496552700000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '20',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 10:35 AM'
}, {
    'UniqueId': 'T100030',
    'DateTime': new Date(1496554020000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from returns',
    'Amount': '120',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/04/2017 10:57 AM'
}, {
    'UniqueId': 'T100031',
    'DateTime': new Date(1496634120000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 09:12 AM'
}, {
    'UniqueId': 'T100032',
    'DateTime': new Date(1496653560000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 02:36 PM'
}, {
    'UniqueId': 'T100033',
    'DateTime': new Date(1496673960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 08:16 PM'
}, {
    'UniqueId': 'T100034',
    'DateTime': new Date(1496637660000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 10:11 AM'
}, {
    'UniqueId': 'T100035',
    'DateTime': new Date(1496657040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 03:34 PM'
}, {
    'UniqueId': 'T100036',
    'DateTime': new Date(1496671860000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '30',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 07:41 PM'
}, {
    'UniqueId': 'T100037',
    'DateTime': new Date(1496671620000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Tennis Court Rent',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/05/2017 07:37 PM'
}, {
    'UniqueId': 'T100038',
    'DateTime': new Date(1496720520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 09:12 AM'
}, {
    'UniqueId': 'T100039',
    'DateTime': new Date(1496739060000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 02:21 PM'
}, {
    'UniqueId': 'T100040',
    'DateTime': new Date(1496761140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 08:29 PM'
}, {
    'UniqueId': 'T100041',
    'DateTime': new Date(1496726040000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 10:44 AM'
}, {
    'UniqueId': 'T100042',
    'DateTime': new Date(1496744760000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 03:56 PM'
}, {
    'UniqueId': 'T100043',
    'DateTime': new Date(1496753340000),
    'Category': 'Health Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 06:19 PM'
}, {
    'UniqueId': 'T100044',
    'DateTime': new Date(1496752980000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from returns',
    'Amount': '120',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/06/2017 06:13 PM'
}, {
    'UniqueId': 'T100045',
    'DateTime': new Date(1496808120000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 09:32 AM'
}, {
    'UniqueId': 'T100046',
    'DateTime': new Date(1496826300000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 02:35 PM'
}, {
    'UniqueId': 'T100047',
    'DateTime': new Date(1496849100000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 08:55 PM'
}, {
    'UniqueId': 'T100048',
    'DateTime': new Date(1496811840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 10:34 AM'
}, {
    'UniqueId': 'T100049',
    'DateTime': new Date(1496828700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 03:15 PM'
}, {
    'UniqueId': 'T100050',
    'DateTime': new Date(1496849340000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Internet use',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/07/2017 08:59 PM'
}, {
    'UniqueId': 'T100051',
    'DateTime': new Date(1496893320000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 09:12 AM'
}, {
    'UniqueId': 'T100052',
    'DateTime': new Date(1496911560000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 02:16 PM'
}, {
    'UniqueId': 'T100053',
    'DateTime': new Date(1496933700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 08:25 PM'
}, {
    'UniqueId': 'T100054',
    'DateTime': new Date(1496898660000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 10:41 AM'
}, {
    'UniqueId': 'T100055',
    'DateTime': new Date(1496915520000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 03:22 PM'
}, {
    'UniqueId': 'T100056',
    'DateTime': new Date(1496901540000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 11:29 AM'
}, {
    'UniqueId': 'T100057',
    'DateTime': new Date(1496900940000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '120',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/08/2017 11:19 AM'
}, {
    'UniqueId': 'T100058',
    'DateTime': new Date(1496980140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 09:19 AM'
}, {
    'UniqueId': 'T100059',
    'DateTime': new Date(1496999040000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 02:34 PM'
}, {
    'UniqueId': 'T100060',
    'DateTime': new Date(1497021540000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 08:49 PM'
}, {
    'UniqueId': 'T100061',
    'DateTime': new Date(1496985300000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 10:45 AM'
}, {
    'UniqueId': 'T100062',
    'DateTime': new Date(1497002760000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 03:36 PM'
}, {
    'UniqueId': 'T100063',
    'DateTime': new Date(1496980860000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '40',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 09:31 AM'
}, {
    'UniqueId': 'T100064',
    'DateTime': new Date(1496979840000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/09/2017 09:14 AM'
}, {
    'UniqueId': 'T100065',
    'DateTime': new Date(1497066120000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 09:12 AM'
}, {
    'UniqueId': 'T100066',
    'DateTime': new Date(1497084480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 02:18 PM'
}, {
    'UniqueId': 'T100067',
    'DateTime': new Date(1497108540000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 08:59 PM'
}, {
    'UniqueId': 'T100068',
    'DateTime': new Date(1497070140000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 10:19 AM'
}, {
    'UniqueId': 'T100069',
    'DateTime': new Date(1497087900000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 03:15 PM'
}, {
    'UniqueId': 'T100070',
    'DateTime': new Date(1497090000000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 03:50 PM'
}, {
    'UniqueId': 'T100071',
    'DateTime': new Date(1497088620000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Internet use',
    'Amount': '5',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/10/2017 03:27 PM'
}, {
    'UniqueId': 'T100072',
    'DateTime': new Date(1497154860000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 09:51 AM'
}, {
    'UniqueId': 'T100073',
    'DateTime': new Date(1497172500000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 02:45 PM'
}, {
    'UniqueId': 'T100074',
    'DateTime': new Date(1497192120000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 08:12 PM'
}, {
    'UniqueId': 'T100075',
    'DateTime': new Date(1497158400000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 10:50 AM'
}, {
    'UniqueId': 'T100076',
    'DateTime': new Date(1497175200000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 03:30 PM'
}, {
    'UniqueId': 'T100077',
    'DateTime': new Date(1497175260000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '65',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 03:31 PM'
}, {
    'UniqueId': 'T100078',
    'DateTime': new Date(1497174540000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 03:19 PM'
}, {
    'UniqueId': 'T100079',
    'DateTime': new Date(1497174120000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '100',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/11/2017 03:12 PM'
}, {
    'UniqueId': 'T100080',
    'DateTime': new Date(1497239280000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 09:18 AM'
}, {
    'UniqueId': 'T100081',
    'DateTime': new Date(1497258780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 02:43 PM'
}, {
    'UniqueId': 'T100082',
    'DateTime': new Date(1497280500000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 08:45 PM'
}, {
    'UniqueId': 'T100083',
    'DateTime': new Date(1497243540000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 10:29 AM'
}, {
    'UniqueId': 'T100084',
    'DateTime': new Date(1497263100000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 03:55 PM'
}, {
    'UniqueId': 'T100085',
    'DateTime': new Date(1497256920000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '20',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 02:12 PM'
}, {
    'UniqueId': 'T100086',
    'DateTime': new Date(1497257640000),
    'Category': 'Insurance',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '250',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/12/2017 02:24 PM'
}, {
    'UniqueId': 'T100087',
    'DateTime': new Date(1497327180000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 09:43 AM'
}, {
    'UniqueId': 'T100088',
    'DateTime': new Date(1497345720000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 02:52 PM'
}, {
    'UniqueId': 'T100089',
    'DateTime': new Date(1497367740000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 08:59 PM'
}, {
    'UniqueId': 'T100090',
    'DateTime': new Date(1497330780000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 10:43 AM'
}, {
    'UniqueId': 'T100091',
    'DateTime': new Date(1497346980000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 03:13 PM'
}, {
    'UniqueId': 'T100092',
    'DateTime': new Date(1497354420000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '280',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 05:17 PM'
}, {
    'UniqueId': 'T100093',
    'DateTime': new Date(1497355380000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Taxi Start (Normal Tariff)',
    'Amount': '3',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 05:33 PM'
}, {
    'UniqueId': 'T100094',
    'DateTime': new Date(1497354720000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '120',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/13/2017 05:22 PM'
}, {
    'UniqueId': 'T100095',
    'DateTime': new Date(1497411900000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 09:15 AM'
}, {
    'UniqueId': 'T100096',
    'DateTime': new Date(1497432420000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 02:57 PM'
}, {
    'UniqueId': 'T100097',
    'DateTime': new Date(1497452400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 08:30 PM'
}, {
    'UniqueId': 'T100098',
    'DateTime': new Date(1497417540000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 10:49 AM'
}, {
    'UniqueId': 'T100099',
    'DateTime': new Date(1497435300000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 03:45 PM'
}, {
    'UniqueId': 'T100100',
    'DateTime': new Date(1497427860000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '220',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/14/2017 01:41 PM'
}, {
    'UniqueId': 'T100101',
    'DateTime': new Date(1497498840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 09:24 AM'
}, {
    'UniqueId': 'T100102',
    'DateTime': new Date(1497517380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 02:33 PM'
}, {
    'UniqueId': 'T100103',
    'DateTime': new Date(1497540300000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 08:55 PM'
}, {
    'UniqueId': 'T100104',
    'DateTime': new Date(1497502800000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 10:30 AM'
}, {
    'UniqueId': 'T100105',
    'DateTime': new Date(1497519900000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 03:15 PM'
}, {
    'UniqueId': 'T100106',
    'DateTime': new Date(1497537840000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 08:14 PM'
}, {
    'UniqueId': 'T100107',
    'DateTime': new Date(1497539820000),
    'Category': 'Bills',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Internet bills',
    'Amount': '380',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 08:47 PM'
}, {
    'UniqueId': 'T100108',
    'DateTime': new Date(1497538920000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '110',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/15/2017 08:32 PM'
}, {
    'UniqueId': 'T100109',
    'DateTime': new Date(1497585480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 09:28 AM'
}, {
    'UniqueId': 'T100110',
    'DateTime': new Date(1497603960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 02:36 PM'
}, {
    'UniqueId': 'T100111',
    'DateTime': new Date(1497624360000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 08:16 PM'
}, {
    'UniqueId': 'T100112',
    'DateTime': new Date(1497590340000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 10:49 AM'
}, {
    'UniqueId': 'T100113',
    'DateTime': new Date(1497608580000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 03:53 PM'
}, {
    'UniqueId': 'T100114',
    'DateTime': new Date(1497606960000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '135',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 03:26 PM'
}, {
    'UniqueId': 'T100115',
    'DateTime': new Date(1497607860000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance, repairs',
    'Amount': '15',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 03:41 PM'
}, {
    'UniqueId': 'T100116',
    'DateTime': new Date(1497606540000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema',
    'Amount': '4',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/16/2017 03:19 PM'
}, {
    'UniqueId': 'T100117',
    'DateTime': new Date(1497671700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 09:25 AM'
}, {
    'UniqueId': 'T100118',
    'DateTime': new Date(1497689760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 02:26 PM'
}, {
    'UniqueId': 'T100119',
    'DateTime': new Date(1497711900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 08:35 PM'
}, {
    'UniqueId': 'T100120',
    'DateTime': new Date(1497675420000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 10:27 AM'
}, {
    'UniqueId': 'T100121',
    'DateTime': new Date(1497695160000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 03:56 PM'
}, {
    'UniqueId': 'T100122',
    'DateTime': new Date(1497692640000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '350',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/17/2017 03:14 PM'
}, {
    'UniqueId': 'T100123',
    'DateTime': new Date(1497758640000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 09:34 AM'
}, {
    'UniqueId': 'T100124',
    'DateTime': new Date(1497776700000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 02:35 PM'
}, {
    'UniqueId': 'T100125',
    'DateTime': new Date(1497796980000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 08:13 PM'
}, {
    'UniqueId': 'T100126',
    'DateTime': new Date(1497760860000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 10:11 AM'
}, {
    'UniqueId': 'T100127',
    'DateTime': new Date(1497781500000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 03:55 PM'
}, {
    'UniqueId': 'T100128',
    'DateTime': new Date(1497767280000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '65',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 11:58 AM'
}, {
    'UniqueId': 'T100129',
    'DateTime': new Date(1497765420000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Deodorant, roll-on',
    'Amount': '15',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/18/2017 11:27 AM'
}, {
    'UniqueId': 'T100130',
    'DateTime': new Date(1497845700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 09:45 AM'
}, {
    'UniqueId': 'T100131',
    'DateTime': new Date(1497862860000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 02:31 PM'
}, {
    'UniqueId': 'T100132',
    'DateTime': new Date(1497885660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 08:51 PM'
}, {
    'UniqueId': 'T100133',
    'DateTime': new Date(1497848460000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 10:31 AM'
}, {
    'UniqueId': 'T100134',
    'DateTime': new Date(1497866700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 03:35 PM'
}, {
    'UniqueId': 'T100135',
    'DateTime': new Date(1497880200000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '30',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 07:20 PM'
}, {
    'UniqueId': 'T100136',
    'DateTime': new Date(1497881280000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Debt repayment',
    'Amount': '3',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 07:38 PM'
}, {
    'UniqueId': 'T100137',
    'DateTime': new Date(1497880860000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '80',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/19/2017 07:31 PM'
}, {
    'UniqueId': 'T100138',
    'DateTime': new Date(1497931500000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 09:35 AM'
}, {
    'UniqueId': 'T100139',
    'DateTime': new Date(1497950700000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 02:55 PM'
}, {
    'UniqueId': 'T100140',
    'DateTime': new Date(1497971100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 08:35 PM'
}, {
    'UniqueId': 'T100141',
    'DateTime': new Date(1497935820000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 10:47 AM'
}, {
    'UniqueId': 'T100142',
    'DateTime': new Date(1497952680000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 03:28 PM'
}, {
    'UniqueId': 'T100143',
    'DateTime': new Date(1497957360000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/20/2017 04:46 PM'
}, {
    'UniqueId': 'T100144',
    'DateTime': new Date(1498018140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/21/2017 09:39 AM'
}, {
    'UniqueId': 'T100145',
    'DateTime': new Date(1498036500000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/21/2017 02:45 PM'
}, {
    'UniqueId': 'T100146',
    'DateTime': new Date(1498056480000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/21/2017 08:18 PM'
}, {
    'UniqueId': 'T100147',
    'DateTime': new Date(1498022640000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/21/2017 10:54 AM'
}, {
    'UniqueId': 'T100148',
    'DateTime': new Date(1498040940000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/21/2017 03:59 PM'
}, {
    'UniqueId': 'T100149',
    'DateTime': new Date(1498103220000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 09:17 AM'
}, {
    'UniqueId': 'T100150',
    'DateTime': new Date(1498122720000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 02:42 PM'
}, {
    'UniqueId': 'T100151',
    'DateTime': new Date(1498143060000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 08:21 PM'
}, {
    'UniqueId': 'T100152',
    'DateTime': new Date(1498108680000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 10:48 AM'
}, {
    'UniqueId': 'T100153',
    'DateTime': new Date(1498125540000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 03:29 PM'
}, {
    'UniqueId': 'T100154',
    'DateTime': new Date(1498112160000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '60',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 11:46 AM'
}, {
    'UniqueId': 'T100155',
    'DateTime': new Date(1498110360000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from lottery',
    'Amount': '80',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/22/2017 11:16 AM'
}, {
    'UniqueId': 'T100156',
    'DateTime': new Date(1498189380000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 09:13 AM'
}, {
    'UniqueId': 'T100157',
    'DateTime': new Date(1498208400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 02:30 PM'
}, {
    'UniqueId': 'T100158',
    'DateTime': new Date(1498229580000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 08:23 PM'
}, {
    'UniqueId': 'T100159',
    'DateTime': new Date(1498194360000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 10:36 AM'
}, {
    'UniqueId': 'T100160',
    'DateTime': new Date(1498211160000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 03:16 PM'
}, {
    'UniqueId': 'T100161',
    'DateTime': new Date(1498202280000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '50',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 12:48 PM'
}, {
    'UniqueId': 'T100162',
    'DateTime': new Date(1498200120000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 12:12 PM'
}, {
    'UniqueId': 'T100163',
    'DateTime': new Date(1498202340000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Internet use',
    'Amount': '3',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/23/2017 12:49 PM'
}, {
    'UniqueId': 'T100164',
    'DateTime': new Date(1498277340000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 09:39 AM'
}, {
    'UniqueId': 'T100165',
    'DateTime': new Date(1498296360000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 02:56 PM'
}, {
    'UniqueId': 'T100166',
    'DateTime': new Date(1498315440000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 08:14 PM'
}, {
    'UniqueId': 'T100167',
    'DateTime': new Date(1498279980000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 10:23 AM'
}, {
    'UniqueId': 'T100168',
    'DateTime': new Date(1498299900000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 03:55 PM'
}, {
    'UniqueId': 'T100169',
    'DateTime': new Date(1498315920000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 08:22 PM'
}, {
    'UniqueId': 'T100170',
    'DateTime': new Date(1498316460000),
    'Category': 'Insurance',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal insurance',
    'Amount': '230',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/24/2017 08:31 PM'
}, {
    'UniqueId': 'T100171',
    'DateTime': new Date(1498362240000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 09:14 AM'
}, {
    'UniqueId': 'T100172',
    'DateTime': new Date(1498381140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 02:29 PM'
}, {
    'UniqueId': 'T100173',
    'DateTime': new Date(1498404360000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 08:56 PM'
}, {
    'UniqueId': 'T100174',
    'DateTime': new Date(1498368360000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 10:56 AM'
}, {
    'UniqueId': 'T100175',
    'DateTime': new Date(1498386180000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 03:53 PM'
}, {
    'UniqueId': 'T100176',
    'DateTime': new Date(1498379160000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 01:56 PM'
}, {
    'UniqueId': 'T100177',
    'DateTime': new Date(1498376520000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cold medicine',
    'Amount': '15',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 01:12 PM'
}, {
    'UniqueId': 'T100178',
    'DateTime': new Date(1498379100000),
    'Category': 'Tax',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Income tax',
    'Amount': '180',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/25/2017 01:55 PM'
}, {
    'UniqueId': 'T100179',
    'DateTime': new Date(1498450680000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 09:48 AM'
}, {
    'UniqueId': 'T100180',
    'DateTime': new Date(1498466400000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 02:10 PM'
}, {
    'UniqueId': 'T100181',
    'DateTime': new Date(1498490160000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 08:46 PM'
}, {
    'UniqueId': 'T100182',
    'DateTime': new Date(1498453440000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 10:34 AM'
}, {
    'UniqueId': 'T100183',
    'DateTime': new Date(1498472040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 03:44 PM'
}, {
    'UniqueId': 'T100184',
    'DateTime': new Date(1498485060000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '30',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 07:21 PM'
}, {
    'UniqueId': 'T100185',
    'DateTime': new Date(1498486380000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from returns',
    'Amount': '120',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/26/2017 07:43 PM'
}, {
    'UniqueId': 'T100186',
    'DateTime': new Date(1498536120000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 09:32 AM'
}, {
    'UniqueId': 'T100187',
    'DateTime': new Date(1498553400000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 02:20 PM'
}, {
    'UniqueId': 'T100188',
    'DateTime': new Date(1498574580000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '12',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 08:13 PM'
}, {
    'UniqueId': 'T100189',
    'DateTime': new Date(1498540080000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 10:38 AM'
}, {
    'UniqueId': 'T100190',
    'DateTime': new Date(1498556640000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 03:14 PM'
}, {
    'UniqueId': 'T100191',
    'DateTime': new Date(1498552140000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/27/2017 01:59 PM'
}, {
    'UniqueId': 'T100192',
    'DateTime': new Date(1498623540000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '8',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 09:49 AM'
}, {
    'UniqueId': 'T100193',
    'DateTime': new Date(1498641780000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 02:53 PM'
}, {
    'UniqueId': 'T100194',
    'DateTime': new Date(1498661580000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 08:23 PM'
}, {
    'UniqueId': 'T100195',
    'DateTime': new Date(1498624860000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 10:11 AM'
}, {
    'UniqueId': 'T100196',
    'DateTime': new Date(1498643940000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 03:29 PM'
}, {
    'UniqueId': 'T100197',
    'DateTime': new Date(1498639860000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Telephone services',
    'Amount': '200',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 02:21 PM'
}, {
    'UniqueId': 'T100198',
    'DateTime': new Date(1498641840000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from investments',
    'Amount': '220',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/28/2017 02:54 PM'
}, {
    'UniqueId': 'T100199',
    'DateTime': new Date(1498707660000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 09:11 AM'
}, {
    'UniqueId': 'T100200',
    'DateTime': new Date(1498726260000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 02:21 PM'
}, {
    'UniqueId': 'T100201',
    'DateTime': new Date(1498748460000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 08:31 PM'
}, {
    'UniqueId': 'T100202',
    'DateTime': new Date(1498714080000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 10:58 AM'
}, {
    'UniqueId': 'T100203',
    'DateTime': new Date(1498731180000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 03:43 PM'
}, {
    'UniqueId': 'T100204',
    'DateTime': new Date(1498742820000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '155',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 06:57 PM'
}, {
    'UniqueId': 'T100205',
    'DateTime': new Date(1498741800000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline (1 liter)',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/29/2017 06:40 PM'
}, {
    'UniqueId': 'T100206',
    'DateTime': new Date(1498796880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 09:58 AM'
}, {
    'UniqueId': 'T100207',
    'DateTime': new Date(1498812420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 02:17 PM'
}, {
    'UniqueId': 'T100208',
    'DateTime': new Date(1498835580000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 08:43 PM'
}, {
    'UniqueId': 'T100209',
    'DateTime': new Date(1498798920000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 10:32 AM'
}, {
    'UniqueId': 'T100210',
    'DateTime': new Date(1498817040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 03:34 PM'
}, {
    'UniqueId': 'T100211',
    'DateTime': new Date(1498803720000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '145',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 11:52 AM'
}, {
    'UniqueId': 'T100212',
    'DateTime': new Date(1498802700000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '20',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 11:35 AM'
}, {
    'UniqueId': 'T100213',
    'DateTime': new Date(1498801560000),
    'Category': 'Education',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 11:16 AM'
}, {
    'UniqueId': 'T100214',
    'DateTime': new Date(1498803720000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '80',
    'MonthShort': 'Jun',
    'MonthFull': 'June, 2017',
    'FormattedDate': '06/30/2017 11:52 AM'
}, {
    'UniqueId': 'T100215',
    'DateTime': new Date(1498880400000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 09:10 AM'
}, {
    'UniqueId': 'T100216',
    'DateTime': new Date(1498901160000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 02:56 PM'
}, {
    'UniqueId': 'T100217',
    'DateTime': new Date(1498920780000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 08:23 PM'
}, {
    'UniqueId': 'T100218',
    'DateTime': new Date(1498885320000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 10:32 AM'
}, {
    'UniqueId': 'T100219',
    'DateTime': new Date(1498903320000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 03:32 PM'
}, {
    'UniqueId': 'T100220',
    'DateTime': new Date(1498921860000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '60',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 08:41 PM'
}, {
    'UniqueId': 'T100221',
    'DateTime': new Date(1498921500000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 08:35 PM'
}, {
    'UniqueId': 'T100222',
    'DateTime': new Date(1498920420000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '5500',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/01/2017 08:17 PM'
}, {
    'UniqueId': 'T100223',
    'DateTime': new Date(1498967400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 09:20 AM'
}, {
    'UniqueId': 'T100224',
    'DateTime': new Date(1498987500000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 02:55 PM'
}, {
    'UniqueId': 'T100225',
    'DateTime': new Date(1499008560000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 08:46 PM'
}, {
    'UniqueId': 'T100226',
    'DateTime': new Date(1498971480000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 10:28 AM'
}, {
    'UniqueId': 'T100227',
    'DateTime': new Date(1498991280000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 03:58 PM'
}, {
    'UniqueId': 'T100228',
    'DateTime': new Date(1498985100000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '40',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 02:15 PM'
}, {
    'UniqueId': 'T100229',
    'DateTime': new Date(1498987320000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/02/2017 02:52 PM'
}, {
    'UniqueId': 'T100230',
    'DateTime': new Date(1499054220000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 09:27 AM'
}, {
    'UniqueId': 'T100231',
    'DateTime': new Date(1499071440000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 02:14 PM'
}, {
    'UniqueId': 'T100232',
    'DateTime': new Date(1499093040000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 08:14 PM'
}, {
    'UniqueId': 'T100233',
    'DateTime': new Date(1499057460000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 10:21 AM'
}, {
    'UniqueId': 'T100234',
    'DateTime': new Date(1499075520000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 03:22 PM'
}, {
    'UniqueId': 'T100235',
    'DateTime': new Date(1499064660000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 12:21 PM'
}, {
    'UniqueId': 'T100236',
    'DateTime': new Date(1499064420000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Electricity bill',
    'Amount': '280',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/03/2017 12:17 PM'
}, {
    'UniqueId': 'T100237',
    'DateTime': new Date(1499142540000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 09:59 AM'
}, {
    'UniqueId': 'T100238',
    'DateTime': new Date(1499159880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 02:48 PM'
}, {
    'UniqueId': 'T100239',
    'DateTime': new Date(1499181180000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 08:43 PM'
}, {
    'UniqueId': 'T100240',
    'DateTime': new Date(1499143980000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 10:23 AM'
}, {
    'UniqueId': 'T100241',
    'DateTime': new Date(1499161980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 03:23 PM'
}, {
    'UniqueId': 'T100242',
    'DateTime': new Date(1499177520000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '50',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 07:42 PM'
}, {
    'UniqueId': 'T100243',
    'DateTime': new Date(1499178240000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cold medicine',
    'Amount': '15',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 07:54 PM'
}, {
    'UniqueId': 'T100244',
    'DateTime': new Date(1499176500000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from casino',
    'Amount': '90',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/04/2017 07:25 PM'
}, {
    'UniqueId': 'T100245',
    'DateTime': new Date(1499227500000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 09:35 AM'
}, {
    'UniqueId': 'T100246',
    'DateTime': new Date(1499246760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 02:56 PM'
}, {
    'UniqueId': 'T100247',
    'DateTime': new Date(1499267820000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 08:47 PM'
}, {
    'UniqueId': 'T100248',
    'DateTime': new Date(1499230260000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 10:21 AM'
}, {
    'UniqueId': 'T100249',
    'DateTime': new Date(1499248200000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 03:20 PM'
}, {
    'UniqueId': 'T100250',
    'DateTime': new Date(1499259240000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 06:24 PM'
}, {
    'UniqueId': 'T100251',
    'DateTime': new Date(1499260020000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline (1 liter)',
    'Amount': '3',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/05/2017 06:37 PM'
}, {
    'UniqueId': 'T100252',
    'DateTime': new Date(1499312760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 09:16 AM'
}, {
    'UniqueId': 'T100253',
    'DateTime': new Date(1499332200000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 02:40 PM'
}, {
    'UniqueId': 'T100254',
    'DateTime': new Date(1499353680000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 08:38 PM'
}, {
    'UniqueId': 'T100255',
    'DateTime': new Date(1499316600000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 10:20 AM'
}, {
    'UniqueId': 'T100256',
    'DateTime': new Date(1499335080000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 03:28 PM'
}, {
    'UniqueId': 'T100257',
    'DateTime': new Date(1499323980000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 12:23 PM'
}, {
    'UniqueId': 'T100258',
    'DateTime': new Date(1499325540000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '90',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/06/2017 12:49 PM'
}, {
    'UniqueId': 'T100259',
    'DateTime': new Date(1499401020000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 09:47 AM'
}, {
    'UniqueId': 'T100260',
    'DateTime': new Date(1499417340000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 02:19 PM'
}, {
    'UniqueId': 'T100261',
    'DateTime': new Date(1499440260000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 08:41 PM'
}, {
    'UniqueId': 'T100262',
    'DateTime': new Date(1499403360000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 10:26 AM'
}, {
    'UniqueId': 'T100263',
    'DateTime': new Date(1499422380000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 03:43 PM'
}, {
    'UniqueId': 'T100264',
    'DateTime': new Date(1499413680000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly Pass (Regular Price)',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/07/2017 01:18 PM'
}, {
    'UniqueId': 'T100265',
    'DateTime': new Date(1499487000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 09:40 AM'
}, {
    'UniqueId': 'T100266',
    'DateTime': new Date(1499504880000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 02:38 PM'
}, {
    'UniqueId': 'T100267',
    'DateTime': new Date(1499527500000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 08:55 PM'
}, {
    'UniqueId': 'T100268',
    'DateTime': new Date(1499490900000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 10:45 AM'
}, {
    'UniqueId': 'T100269',
    'DateTime': new Date(1499509560000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 03:56 PM'
}, {
    'UniqueId': 'T100270',
    'DateTime': new Date(1499499960000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '55',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 01:16 PM'
}, {
    'UniqueId': 'T100271',
    'DateTime': new Date(1499502480000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '90',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/08/2017 01:58 PM'
}, {
    'UniqueId': 'T100272',
    'DateTime': new Date(1499573880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 09:48 AM'
}, {
    'UniqueId': 'T100273',
    'DateTime': new Date(1499591760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 02:46 PM'
}, {
    'UniqueId': 'T100274',
    'DateTime': new Date(1499613900000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 08:55 PM'
}, {
    'UniqueId': 'T100275',
    'DateTime': new Date(1499576640000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 10:34 AM'
}, {
    'UniqueId': 'T100276',
    'DateTime': new Date(1499594100000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 03:25 PM'
}, {
    'UniqueId': 'T100277',
    'DateTime': new Date(1499601180000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '40',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 05:23 PM'
}, {
    'UniqueId': 'T100278',
    'DateTime': new Date(1499602920000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/09/2017 05:52 PM'
}, {
    'UniqueId': 'T100279',
    'DateTime': new Date(1499660640000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 09:54 AM'
}, {
    'UniqueId': 'T100280',
    'DateTime': new Date(1499676480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 02:18 PM'
}, {
    'UniqueId': 'T100281',
    'DateTime': new Date(1499698680000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 08:28 PM'
}, {
    'UniqueId': 'T100282',
    'DateTime': new Date(1499663040000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 10:34 AM'
}, {
    'UniqueId': 'T100283',
    'DateTime': new Date(1499679720000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 03:12 PM'
}, {
    'UniqueId': 'T100284',
    'DateTime': new Date(1499663880000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '360',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 10:48 AM'
}, {
    'UniqueId': 'T100285',
    'DateTime': new Date(1499664240000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Internet use',
    'Amount': '3',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/10/2017 10:54 AM'
}, {
    'UniqueId': 'T100286',
    'DateTime': new Date(1499745420000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 09:27 AM'
}, {
    'UniqueId': 'T100287',
    'DateTime': new Date(1499763720000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 02:32 PM'
}, {
    'UniqueId': 'T100288',
    'DateTime': new Date(1499785860000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 08:41 PM'
}, {
    'UniqueId': 'T100289',
    'DateTime': new Date(1499750940000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 10:59 AM'
}, {
    'UniqueId': 'T100290',
    'DateTime': new Date(1499766840000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 03:24 PM'
}, {
    'UniqueId': 'T100291',
    'DateTime': new Date(1499774340000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '65',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 05:29 PM'
}, {
    'UniqueId': 'T100292',
    'DateTime': new Date(1499775960000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Standard haircut',
    'Amount': '15',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 05:56 PM'
}, {
    'UniqueId': 'T100293',
    'DateTime': new Date(1499773800000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '120',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/11/2017 05:20 PM'
}, {
    'UniqueId': 'T100294',
    'DateTime': new Date(1499832420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 09:37 AM'
}, {
    'UniqueId': 'T100295',
    'DateTime': new Date(1499851020000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 02:47 PM'
}, {
    'UniqueId': 'T100296',
    'DateTime': new Date(1499872800000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 08:50 PM'
}, {
    'UniqueId': 'T100297',
    'DateTime': new Date(1499835240000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 10:24 AM'
}, {
    'UniqueId': 'T100298',
    'DateTime': new Date(1499855040000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 03:54 PM'
}, {
    'UniqueId': 'T100299',
    'DateTime': new Date(1499863380000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 06:13 PM'
}, {
    'UniqueId': 'T100300',
    'DateTime': new Date(1499863260000),
    'Category': 'Insurance',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Life and other personal insurance',
    'Amount': '230',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/12/2017 06:11 PM'
}, {
    'UniqueId': 'T100301',
    'DateTime': new Date(1499919480000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 09:48 AM'
}, {
    'UniqueId': 'T100302',
    'DateTime': new Date(1499935560000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 02:16 PM'
}, {
    'UniqueId': 'T100303',
    'DateTime': new Date(1499959740000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 08:59 PM'
}, {
    'UniqueId': 'T100304',
    'DateTime': new Date(1499921220000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 10:17 AM'
}, {
    'UniqueId': 'T100305',
    'DateTime': new Date(1499941560000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 03:56 PM'
}, {
    'UniqueId': 'T100306',
    'DateTime': new Date(1499919180000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '60',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 09:43 AM'
}, {
    'UniqueId': 'T100307',
    'DateTime': new Date(1499918820000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gym payment',
    'Amount': '5',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 09:37 AM'
}, {
    'UniqueId': 'T100308',
    'DateTime': new Date(1499918580000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '80',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/13/2017 09:33 AM'
}, {
    'UniqueId': 'T100309',
    'DateTime': new Date(1500003900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 09:15 AM'
}, {
    'UniqueId': 'T100310',
    'DateTime': new Date(1500021600000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 02:10 PM'
}, {
    'UniqueId': 'T100311',
    'DateTime': new Date(1500043740000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 08:19 PM'
}, {
    'UniqueId': 'T100312',
    'DateTime': new Date(1500007260000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 10:11 AM'
}, {
    'UniqueId': 'T100313',
    'DateTime': new Date(1500025200000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 03:10 PM'
}, {
    'UniqueId': 'T100314',
    'DateTime': new Date(1500004800000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from investments',
    'Amount': '180',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/14/2017 09:30 AM'
}, {
    'UniqueId': 'T100315',
    'DateTime': new Date(1500092580000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 09:53 AM'
}, {
    'UniqueId': 'T100316',
    'DateTime': new Date(1500110760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 02:56 PM'
}, {
    'UniqueId': 'T100317',
    'DateTime': new Date(1500131760000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 08:46 PM'
}, {
    'UniqueId': 'T100318',
    'DateTime': new Date(1500094680000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 10:28 AM'
}, {
    'UniqueId': 'T100319',
    'DateTime': new Date(1500111960000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 03:16 PM'
}, {
    'UniqueId': 'T100320',
    'DateTime': new Date(1500115200000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '55',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 04:10 PM'
}, {
    'UniqueId': 'T100321',
    'DateTime': new Date(1500115440000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Internet bills',
    'Amount': '320',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 04:14 PM'
}, {
    'UniqueId': 'T100322',
    'DateTime': new Date(1500117660000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '100',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/15/2017 04:51 PM'
}, {
    'UniqueId': 'T100323',
    'DateTime': new Date(1500178140000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 09:39 AM'
}, {
    'UniqueId': 'T100324',
    'DateTime': new Date(1500195660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 02:31 PM'
}, {
    'UniqueId': 'T100325',
    'DateTime': new Date(1500216360000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 08:16 PM'
}, {
    'UniqueId': 'T100326',
    'DateTime': new Date(1500182640000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 10:54 AM'
}, {
    'UniqueId': 'T100327',
    'DateTime': new Date(1500199980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 03:43 PM'
}, {
    'UniqueId': 'T100328',
    'DateTime': new Date(1500182580000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '35',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 10:53 AM'
}, {
    'UniqueId': 'T100329',
    'DateTime': new Date(1500182340000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 10:49 AM'
}, {
    'UniqueId': 'T100330',
    'DateTime': new Date(1500181920000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '5',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/16/2017 10:42 AM'
}, {
    'UniqueId': 'T100331',
    'DateTime': new Date(1500264540000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 09:39 AM'
}, {
    'UniqueId': 'T100332',
    'DateTime': new Date(1500282180000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 02:33 PM'
}, {
    'UniqueId': 'T100333',
    'DateTime': new Date(1500305100000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 08:55 PM'
}, {
    'UniqueId': 'T100334',
    'DateTime': new Date(1500268320000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 10:42 AM'
}, {
    'UniqueId': 'T100335',
    'DateTime': new Date(1500285840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 03:34 PM'
}, {
    'UniqueId': 'T100336',
    'DateTime': new Date(1500284460000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '130',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/17/2017 03:11 PM'
}, {
    'UniqueId': 'T100337',
    'DateTime': new Date(1500351360000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 09:46 AM'
}, {
    'UniqueId': 'T100338',
    'DateTime': new Date(1500369720000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 02:52 PM'
}, {
    'UniqueId': 'T100339',
    'DateTime': new Date(1500391500000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 08:55 PM'
}, {
    'UniqueId': 'T100340',
    'DateTime': new Date(1500355680000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 10:58 AM'
}, {
    'UniqueId': 'T100341',
    'DateTime': new Date(1500372840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 03:44 PM'
}, {
    'UniqueId': 'T100342',
    'DateTime': new Date(1500368340000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '55',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 02:29 PM'
}, {
    'UniqueId': 'T100343',
    'DateTime': new Date(1500370080000),
    'Category': 'Personal Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/18/2017 02:58 PM'
}, {
    'UniqueId': 'T100344',
    'DateTime': new Date(1500438120000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 09:52 AM'
}, {
    'UniqueId': 'T100345',
    'DateTime': new Date(1500455700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 02:45 PM'
}, {
    'UniqueId': 'T100346',
    'DateTime': new Date(1500477120000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 08:42 PM'
}, {
    'UniqueId': 'T100347',
    'DateTime': new Date(1500441000000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 10:40 AM'
}, {
    'UniqueId': 'T100348',
    'DateTime': new Date(1500457380000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 03:13 PM'
}, {
    'UniqueId': 'T100349',
    'DateTime': new Date(1500454620000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '20',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 02:27 PM'
}, {
    'UniqueId': 'T100350',
    'DateTime': new Date(1500453780000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Tennis Court Rent',
    'Amount': '3',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 02:13 PM'
}, {
    'UniqueId': 'T100351',
    'DateTime': new Date(1500456360000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from casino',
    'Amount': '120',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/19/2017 02:56 PM'
}, {
    'UniqueId': 'T100352',
    'DateTime': new Date(1500524940000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 09:59 AM'
}, {
    'UniqueId': 'T100353',
    'DateTime': new Date(1500540600000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 02:20 PM'
}, {
    'UniqueId': 'T100354',
    'DateTime': new Date(1500563460000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 08:41 PM'
}, {
    'UniqueId': 'T100355',
    'DateTime': new Date(1500527700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 10:45 AM'
}, {
    'UniqueId': 'T100356',
    'DateTime': new Date(1500545940000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 03:49 PM'
}, {
    'UniqueId': 'T100357',
    'DateTime': new Date(1500543720000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '260',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/20/2017 03:12 PM'
}, {
    'UniqueId': 'T100358',
    'DateTime': new Date(1500610500000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/21/2017 09:45 AM'
}, {
    'UniqueId': 'T100359',
    'DateTime': new Date(1500626520000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/21/2017 02:12 PM'
}, {
    'UniqueId': 'T100360',
    'DateTime': new Date(1500650340000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/21/2017 08:49 PM'
}, {
    'UniqueId': 'T100361',
    'DateTime': new Date(1500613800000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/21/2017 10:40 AM'
}, {
    'UniqueId': 'T100362',
    'DateTime': new Date(1500632460000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/21/2017 03:51 PM'
}, {
    'UniqueId': 'T100363',
    'DateTime': new Date(1500695040000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 09:14 AM'
}, {
    'UniqueId': 'T100364',
    'DateTime': new Date(1500715380000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 02:53 PM'
}, {
    'UniqueId': 'T100365',
    'DateTime': new Date(1500735720000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 08:32 PM'
}, {
    'UniqueId': 'T100366',
    'DateTime': new Date(1500699480000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 10:28 AM'
}, {
    'UniqueId': 'T100367',
    'DateTime': new Date(1500716880000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 03:18 PM'
}, {
    'UniqueId': 'T100368',
    'DateTime': new Date(1500706020000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 12:17 PM'
}, {
    'UniqueId': 'T100369',
    'DateTime': new Date(1500708060000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from casino',
    'Amount': '100',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/22/2017 12:51 PM'
}, {
    'UniqueId': 'T100370',
    'DateTime': new Date(1500782820000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 09:37 AM'
}, {
    'UniqueId': 'T100371',
    'DateTime': new Date(1500801240000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 02:44 PM'
}, {
    'UniqueId': 'T100372',
    'DateTime': new Date(1500821340000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 08:19 PM'
}, {
    'UniqueId': 'T100373',
    'DateTime': new Date(1500784980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 10:13 AM'
}, {
    'UniqueId': 'T100374',
    'DateTime': new Date(1500804660000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 03:41 PM'
}, {
    'UniqueId': 'T100375',
    'DateTime': new Date(1500783120000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '50',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 09:42 AM'
}, {
    'UniqueId': 'T100376',
    'DateTime': new Date(1500781680000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '15',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 09:18 AM'
}, {
    'UniqueId': 'T100377',
    'DateTime': new Date(1500781500000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline (1 liter)',
    'Amount': '4',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/23/2017 09:15 AM'
}, {
    'UniqueId': 'T100378',
    'DateTime': new Date(1500869520000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 09:42 AM'
}, {
    'UniqueId': 'T100379',
    'DateTime': new Date(1500886020000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 02:17 PM'
}, {
    'UniqueId': 'T100380',
    'DateTime': new Date(1500908160000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 08:26 PM'
}, {
    'UniqueId': 'T100381',
    'DateTime': new Date(1500871860000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 10:21 AM'
}, {
    'UniqueId': 'T100382',
    'DateTime': new Date(1500891360000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 03:46 PM'
}, {
    'UniqueId': 'T100383',
    'DateTime': new Date(1500906000000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 07:50 PM'
}, {
    'UniqueId': 'T100384',
    'DateTime': new Date(1500904080000),
    'Category': 'Insurance',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal insurance',
    'Amount': '230',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/24/2017 07:18 PM'
}, {
    'UniqueId': 'T100385',
    'DateTime': new Date(1500956220000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 09:47 AM'
}, {
    'UniqueId': 'T100386',
    'DateTime': new Date(1500973500000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 02:35 PM'
}, {
    'UniqueId': 'T100387',
    'DateTime': new Date(1500996000000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 08:50 PM'
}, {
    'UniqueId': 'T100388',
    'DateTime': new Date(1500958620000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 10:27 AM'
}, {
    'UniqueId': 'T100389',
    'DateTime': new Date(1500977940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 03:49 PM'
}, {
    'UniqueId': 'T100390',
    'DateTime': new Date(1500987120000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '55',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 06:22 PM'
}, {
    'UniqueId': 'T100391',
    'DateTime': new Date(1500988740000),
    'Category': 'Personal Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Deodorant, roll-on',
    'Amount': '15',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 06:49 PM'
}, {
    'UniqueId': 'T100392',
    'DateTime': new Date(1500989040000),
    'Category': 'Tax',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Property tax',
    'Amount': '180',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/25/2017 06:54 PM'
}, {
    'UniqueId': 'T100393',
    'DateTime': new Date(1501041540000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 09:29 AM'
}, {
    'UniqueId': 'T100394',
    'DateTime': new Date(1501060200000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 02:40 PM'
}, {
    'UniqueId': 'T100395',
    'DateTime': new Date(1501082160000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 08:46 PM'
}, {
    'UniqueId': 'T100396',
    'DateTime': new Date(1501046520000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 10:52 AM'
}, {
    'UniqueId': 'T100397',
    'DateTime': new Date(1501063140000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 03:29 PM'
}, {
    'UniqueId': 'T100398',
    'DateTime': new Date(1501062900000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 03:25 PM'
}, {
    'UniqueId': 'T100399',
    'DateTime': new Date(1501064880000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '110',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/26/2017 03:58 PM'
}, {
    'UniqueId': 'T100400',
    'DateTime': new Date(1501127460000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 09:21 AM'
}, {
    'UniqueId': 'T100401',
    'DateTime': new Date(1501147140000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 02:49 PM'
}, {
    'UniqueId': 'T100402',
    'DateTime': new Date(1501166700000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 08:15 PM'
}, {
    'UniqueId': 'T100403',
    'DateTime': new Date(1501131540000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 10:29 AM'
}, {
    'UniqueId': 'T100404',
    'DateTime': new Date(1501148700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 03:15 PM'
}, {
    'UniqueId': 'T100405',
    'DateTime': new Date(1501159980000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/27/2017 06:23 PM'
}, {
    'UniqueId': 'T100406',
    'DateTime': new Date(1501216020000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 09:57 AM'
}, {
    'UniqueId': 'T100407',
    'DateTime': new Date(1501232640000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 02:34 PM'
}, {
    'UniqueId': 'T100408',
    'DateTime': new Date(1501253760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 08:26 PM'
}, {
    'UniqueId': 'T100409',
    'DateTime': new Date(1501218360000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 10:36 AM'
}, {
    'UniqueId': 'T100410',
    'DateTime': new Date(1501237740000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 03:59 PM'
}, {
    'UniqueId': 'T100411',
    'DateTime': new Date(1501215600000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Telephone services',
    'Amount': '180',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 09:50 AM'
}, {
    'UniqueId': 'T100412',
    'DateTime': new Date(1501213200000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '180',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/28/2017 09:10 AM'
}, {
    'UniqueId': 'T100413',
    'DateTime': new Date(1501301340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 09:39 AM'
}, {
    'UniqueId': 'T100414',
    'DateTime': new Date(1501319880000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 02:48 PM'
}, {
    'UniqueId': 'T100415',
    'DateTime': new Date(1501340580000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 08:33 PM'
}, {
    'UniqueId': 'T100416',
    'DateTime': new Date(1501304220000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 10:27 AM'
}, {
    'UniqueId': 'T100417',
    'DateTime': new Date(1501321980000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 03:23 PM'
}, {
    'UniqueId': 'T100418',
    'DateTime': new Date(1501322220000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 03:27 PM'
}, {
    'UniqueId': 'T100419',
    'DateTime': new Date(1501322220000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '4',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/29/2017 03:27 PM'
}, {
    'UniqueId': 'T100420',
    'DateTime': new Date(1501387380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 09:33 AM'
}, {
    'UniqueId': 'T100421',
    'DateTime': new Date(1501405680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '11',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 02:38 PM'
}, {
    'UniqueId': 'T100422',
    'DateTime': new Date(1501427760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '7',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 08:46 PM'
}, {
    'UniqueId': 'T100423',
    'DateTime': new Date(1501391340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 10:39 AM'
}, {
    'UniqueId': 'T100424',
    'DateTime': new Date(1501409640000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 03:44 PM'
}, {
    'UniqueId': 'T100425',
    'DateTime': new Date(1501388820000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '35',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 09:57 AM'
}, {
    'UniqueId': 'T100426',
    'DateTime': new Date(1501386420000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '30',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 09:17 AM'
}, {
    'UniqueId': 'T100427',
    'DateTime': new Date(1501386960000),
    'Category': 'Education',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 09:26 AM'
}, {
    'UniqueId': 'T100428',
    'DateTime': new Date(1501386060000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '80',
    'MonthShort': 'Jul',
    'MonthFull': 'July, 2017',
    'FormattedDate': '07/30/2017 09:11 AM'
}, {
    'UniqueId': 'T100429',
    'DateTime': new Date(1501559400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 09:20 AM'
}, {
    'UniqueId': 'T100430',
    'DateTime': new Date(1501579680000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 02:58 PM'
}, {
    'UniqueId': 'T100431',
    'DateTime': new Date(1501599840000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 08:34 PM'
}, {
    'UniqueId': 'T100432',
    'DateTime': new Date(1501563840000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 10:34 AM'
}, {
    'UniqueId': 'T100433',
    'DateTime': new Date(1501582680000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 03:48 PM'
}, {
    'UniqueId': 'T100434',
    'DateTime': new Date(1501576140000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '60',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 01:59 PM'
}, {
    'UniqueId': 'T100435',
    'DateTime': new Date(1501573560000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 01:16 PM'
}, {
    'UniqueId': 'T100436',
    'DateTime': new Date(1501573860000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '5000',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/01/2017 01:21 PM'
}, {
    'UniqueId': 'T100437',
    'DateTime': new Date(1501645620000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 09:17 AM'
}, {
    'UniqueId': 'T100438',
    'DateTime': new Date(1501665600000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 02:50 PM'
}, {
    'UniqueId': 'T100439',
    'DateTime': new Date(1501685760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 08:26 PM'
}, {
    'UniqueId': 'T100440',
    'DateTime': new Date(1501650120000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 10:32 AM'
}, {
    'UniqueId': 'T100441',
    'DateTime': new Date(1501669680000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 03:58 PM'
}, {
    'UniqueId': 'T100442',
    'DateTime': new Date(1501651380000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '35',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 10:53 AM'
}, {
    'UniqueId': 'T100443',
    'DateTime': new Date(1501649160000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/02/2017 10:16 AM'
}, {
    'UniqueId': 'T100444',
    'DateTime': new Date(1501732320000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 09:22 AM'
}, {
    'UniqueId': 'T100445',
    'DateTime': new Date(1501749900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 02:15 PM'
}, {
    'UniqueId': 'T100446',
    'DateTime': new Date(1501772760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 08:36 PM'
}, {
    'UniqueId': 'T100447',
    'DateTime': new Date(1501737240000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 10:44 AM'
}, {
    'UniqueId': 'T100448',
    'DateTime': new Date(1501753440000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 03:14 PM'
}, {
    'UniqueId': 'T100449',
    'DateTime': new Date(1501755420000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 03:47 PM'
}, {
    'UniqueId': 'T100450',
    'DateTime': new Date(1501756080000),
    'Category': 'Bills',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Electricity bill',
    'Amount': '200',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/03/2017 03:58 PM'
}, {
    'UniqueId': 'T100451',
    'DateTime': new Date(1501820100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 09:45 AM'
}, {
    'UniqueId': 'T100452',
    'DateTime': new Date(1501836060000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 02:11 PM'
}, {
    'UniqueId': 'T100453',
    'DateTime': new Date(1501858260000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 08:21 PM'
}, {
    'UniqueId': 'T100454',
    'DateTime': new Date(1501821840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 10:14 AM'
}, {
    'UniqueId': 'T100455',
    'DateTime': new Date(1501839720000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 03:12 PM'
}, {
    'UniqueId': 'T100456',
    'DateTime': new Date(1501860360000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '60',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 08:56 PM'
}, {
    'UniqueId': 'T100457',
    'DateTime': new Date(1501857840000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 08:14 PM'
}, {
    'UniqueId': 'T100458',
    'DateTime': new Date(1501858560000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from casino',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/04/2017 08:26 PM'
}, {
    'UniqueId': 'T100459',
    'DateTime': new Date(1501906200000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 09:40 AM'
}, {
    'UniqueId': 'T100460',
    'DateTime': new Date(1501924560000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 02:46 PM'
}, {
    'UniqueId': 'T100461',
    'DateTime': new Date(1501946460000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 08:51 PM'
}, {
    'UniqueId': 'T100462',
    'DateTime': new Date(1501908420000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 10:17 AM'
}, {
    'UniqueId': 'T100463',
    'DateTime': new Date(1501926780000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 03:23 PM'
}, {
    'UniqueId': 'T100464',
    'DateTime': new Date(1501908540000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance, repairs',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 10:19 AM'
}, {
    'UniqueId': 'T100465',
    'DateTime': new Date(1501908780000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '2',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/05/2017 10:23 AM'
}, {
    'UniqueId': 'T100466',
    'DateTime': new Date(1501993380000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 09:53 AM'
}, {
    'UniqueId': 'T100467',
    'DateTime': new Date(1502010180000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 02:33 PM'
}, {
    'UniqueId': 'T100468',
    'DateTime': new Date(1502030940000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 08:19 PM'
}, {
    'UniqueId': 'T100469',
    'DateTime': new Date(1501995900000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 10:35 AM'
}, {
    'UniqueId': 'T100470',
    'DateTime': new Date(1502014500000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 03:45 PM'
}, {
    'UniqueId': 'T100471',
    'DateTime': new Date(1502002680000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '60',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 12:28 PM'
}, {
    'UniqueId': 'T100472',
    'DateTime': new Date(1502002140000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '120',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/06/2017 12:19 PM'
}, {
    'UniqueId': 'T100473',
    'DateTime': new Date(1502078640000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 09:34 AM'
}, {
    'UniqueId': 'T100474',
    'DateTime': new Date(1502097720000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 02:52 PM'
}, {
    'UniqueId': 'T100475',
    'DateTime': new Date(1502116920000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 08:12 PM'
}, {
    'UniqueId': 'T100476',
    'DateTime': new Date(1502082000000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 10:30 AM'
}, {
    'UniqueId': 'T100477',
    'DateTime': new Date(1502098980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 03:13 PM'
}, {
    'UniqueId': 'T100478',
    'DateTime': new Date(1502101500000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cappuccino (regular)',
    'Amount': '5',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/07/2017 03:55 PM'
}, {
    'UniqueId': 'T100479',
    'DateTime': new Date(1502165400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 09:40 AM'
}, {
    'UniqueId': 'T100480',
    'DateTime': new Date(1502181900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 02:15 PM'
}, {
    'UniqueId': 'T100481',
    'DateTime': new Date(1502204580000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 08:33 PM'
}, {
    'UniqueId': 'T100482',
    'DateTime': new Date(1502169360000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 10:46 AM'
}, {
    'UniqueId': 'T100483',
    'DateTime': new Date(1502185380000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 03:13 PM'
}, {
    'UniqueId': 'T100484',
    'DateTime': new Date(1502204340000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '60',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 08:29 PM'
}, {
    'UniqueId': 'T100485',
    'DateTime': new Date(1502205840000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '100',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/08/2017 08:54 PM'
}, {
    'UniqueId': 'T100486',
    'DateTime': new Date(1502250900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 09:25 AM'
}, {
    'UniqueId': 'T100487',
    'DateTime': new Date(1502270100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 02:45 PM'
}, {
    'UniqueId': 'T100488',
    'DateTime': new Date(1502291040000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 08:34 PM'
}, {
    'UniqueId': 'T100489',
    'DateTime': new Date(1502253720000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 10:12 AM'
}, {
    'UniqueId': 'T100490',
    'DateTime': new Date(1502274420000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 03:57 PM'
}, {
    'UniqueId': 'T100491',
    'DateTime': new Date(1502292120000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '45',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 08:52 PM'
}, {
    'UniqueId': 'T100492',
    'DateTime': new Date(1502290140000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '30',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/09/2017 08:19 PM'
}, {
    'UniqueId': 'T100493',
    'DateTime': new Date(1502336580000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 09:13 AM'
}, {
    'UniqueId': 'T100494',
    'DateTime': new Date(1502356620000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 02:47 PM'
}, {
    'UniqueId': 'T100495',
    'DateTime': new Date(1502376360000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 08:16 PM'
}, {
    'UniqueId': 'T100496',
    'DateTime': new Date(1502340180000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 10:13 AM'
}, {
    'UniqueId': 'T100497',
    'DateTime': new Date(1502360640000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 03:54 PM'
}, {
    'UniqueId': 'T100498',
    'DateTime': new Date(1502349360000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 12:46 PM'
}, {
    'UniqueId': 'T100499',
    'DateTime': new Date(1502348940000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '4',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/10/2017 12:39 PM'
}, {
    'UniqueId': 'T100500',
    'DateTime': new Date(1502425680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 09:58 AM'
}, {
    'UniqueId': 'T100501',
    'DateTime': new Date(1502443620000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 02:57 PM'
}, {
    'UniqueId': 'T100502',
    'DateTime': new Date(1502464140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 08:39 PM'
}, {
    'UniqueId': 'T100503',
    'DateTime': new Date(1502427420000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 10:27 AM'
}, {
    'UniqueId': 'T100504',
    'DateTime': new Date(1502444940000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 03:19 PM'
}, {
    'UniqueId': 'T100505',
    'DateTime': new Date(1502442480000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 02:38 PM'
}, {
    'UniqueId': 'T100506',
    'DateTime': new Date(1502441100000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Deodorant, roll-on',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 02:15 PM'
}, {
    'UniqueId': 'T100507',
    'DateTime': new Date(1502441400000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '100',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/11/2017 02:20 PM'
}, {
    'UniqueId': 'T100508',
    'DateTime': new Date(1502510520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 09:32 AM'
}, {
    'UniqueId': 'T100509',
    'DateTime': new Date(1502527440000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 02:14 PM'
}, {
    'UniqueId': 'T100510',
    'DateTime': new Date(1502550120000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 08:32 PM'
}, {
    'UniqueId': 'T100511',
    'DateTime': new Date(1502512860000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 10:11 AM'
}, {
    'UniqueId': 'T100512',
    'DateTime': new Date(1502532840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 03:44 PM'
}, {
    'UniqueId': 'T100513',
    'DateTime': new Date(1502525520000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 01:42 PM'
}, {
    'UniqueId': 'T100514',
    'DateTime': new Date(1502524260000),
    'Category': 'Insurance',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '230',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/12/2017 01:21 PM'
}, {
    'UniqueId': 'T100515',
    'DateTime': new Date(1502596560000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 09:26 AM'
}, {
    'UniqueId': 'T100516',
    'DateTime': new Date(1502616180000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 02:53 PM'
}, {
    'UniqueId': 'T100517',
    'DateTime': new Date(1502636700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 08:35 PM'
}, {
    'UniqueId': 'T100518',
    'DateTime': new Date(1502599500000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 10:15 AM'
}, {
    'UniqueId': 'T100519',
    'DateTime': new Date(1502619600000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 03:50 PM'
}, {
    'UniqueId': 'T100520',
    'DateTime': new Date(1502598180000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 09:53 AM'
}, {
    'UniqueId': 'T100521',
    'DateTime': new Date(1502596260000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Internet use',
    'Amount': '2',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 09:21 AM'
}, {
    'UniqueId': 'T100522',
    'DateTime': new Date(1502596140000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '120',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/13/2017 09:19 AM'
}, {
    'UniqueId': 'T100523',
    'DateTime': new Date(1502682600000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 09:20 AM'
}, {
    'UniqueId': 'T100524',
    'DateTime': new Date(1502701680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 02:38 PM'
}, {
    'UniqueId': 'T100525',
    'DateTime': new Date(1502723700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 08:45 PM'
}, {
    'UniqueId': 'T100526',
    'DateTime': new Date(1502687160000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 10:36 AM'
}, {
    'UniqueId': 'T100527',
    'DateTime': new Date(1502705820000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 03:47 PM'
}, {
    'UniqueId': 'T100528',
    'DateTime': new Date(1502724540000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '20',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/14/2017 08:59 PM'
}, {
    'UniqueId': 'T100529',
    'DateTime': new Date(1502771100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 09:55 AM'
}, {
    'UniqueId': 'T100530',
    'DateTime': new Date(1502787660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 02:31 PM'
}, {
    'UniqueId': 'T100531',
    'DateTime': new Date(1502809620000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 08:37 PM'
}, {
    'UniqueId': 'T100532',
    'DateTime': new Date(1502774580000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 10:53 AM'
}, {
    'UniqueId': 'T100533',
    'DateTime': new Date(1502792820000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 03:57 PM'
}, {
    'UniqueId': 'T100534',
    'DateTime': new Date(1502777520000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '65',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 11:42 AM'
}, {
    'UniqueId': 'T100535',
    'DateTime': new Date(1502776920000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Internet bills',
    'Amount': '200',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 11:32 AM'
}, {
    'UniqueId': 'T100536',
    'DateTime': new Date(1502776260000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '100',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/15/2017 11:21 AM'
}, {
    'UniqueId': 'T100537',
    'DateTime': new Date(1502856960000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 09:46 AM'
}, {
    'UniqueId': 'T100538',
    'DateTime': new Date(1502873520000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 02:22 PM'
}, {
    'UniqueId': 'T100539',
    'DateTime': new Date(1502896980000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 08:53 PM'
}, {
    'UniqueId': 'T100540',
    'DateTime': new Date(1502859840000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 10:34 AM'
}, {
    'UniqueId': 'T100541',
    'DateTime': new Date(1502879160000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 03:56 PM'
}, {
    'UniqueId': 'T100542',
    'DateTime': new Date(1502856420000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '35',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 09:37 AM'
}, {
    'UniqueId': 'T100543',
    'DateTime': new Date(1502856900000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '25',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 09:45 AM'
}, {
    'UniqueId': 'T100544',
    'DateTime': new Date(1502857140000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cinema',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/16/2017 09:49 AM'
}, {
    'UniqueId': 'T100545',
    'DateTime': new Date(1502943780000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 09:53 AM'
}, {
    'UniqueId': 'T100546',
    'DateTime': new Date(1502959200000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 02:10 PM'
}, {
    'UniqueId': 'T100547',
    'DateTime': new Date(1502982300000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 08:35 PM'
}, {
    'UniqueId': 'T100548',
    'DateTime': new Date(1502947740000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 10:59 AM'
}, {
    'UniqueId': 'T100549',
    'DateTime': new Date(1502963400000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 03:20 PM'
}, {
    'UniqueId': 'T100550',
    'DateTime': new Date(1502958240000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '130',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/17/2017 01:54 PM'
}, {
    'UniqueId': 'T100551',
    'DateTime': new Date(1503029100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 09:35 AM'
}, {
    'UniqueId': 'T100552',
    'DateTime': new Date(1503048300000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 02:55 PM'
}, {
    'UniqueId': 'T100553',
    'DateTime': new Date(1503067440000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 08:14 PM'
}, {
    'UniqueId': 'T100554',
    'DateTime': new Date(1503031920000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 10:22 AM'
}, {
    'UniqueId': 'T100555',
    'DateTime': new Date(1503049980000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 03:23 PM'
}, {
    'UniqueId': 'T100556',
    'DateTime': new Date(1503047520000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '55',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 02:42 PM'
}, {
    'UniqueId': 'T100557',
    'DateTime': new Date(1503047460000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': '1 box of antibiotics (12 doses)',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/18/2017 02:41 PM'
}, {
    'UniqueId': 'T100558',
    'DateTime': new Date(1503114840000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 09:24 AM'
}, {
    'UniqueId': 'T100559',
    'DateTime': new Date(1503132480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 02:18 PM'
}, {
    'UniqueId': 'T100560',
    'DateTime': new Date(1503156300000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 08:55 PM'
}, {
    'UniqueId': 'T100561',
    'DateTime': new Date(1503118020000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 10:17 AM'
}, {
    'UniqueId': 'T100562',
    'DateTime': new Date(1503137940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 03:49 PM'
}, {
    'UniqueId': 'T100563',
    'DateTime': new Date(1503147840000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '20',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 06:34 PM'
}, {
    'UniqueId': 'T100564',
    'DateTime': new Date(1503146520000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Taxi 1hour Waiting',
    'Amount': '5',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 06:12 PM'
}, {
    'UniqueId': 'T100565',
    'DateTime': new Date(1503147360000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from casino',
    'Amount': '120',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/19/2017 06:26 PM'
}, {
    'UniqueId': 'T100566',
    'DateTime': new Date(1503203280000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 09:58 AM'
}, {
    'UniqueId': 'T100567',
    'DateTime': new Date(1503218760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 02:16 PM'
}, {
    'UniqueId': 'T100568',
    'DateTime': new Date(1503242640000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 08:54 PM'
}, {
    'UniqueId': 'T100569',
    'DateTime': new Date(1503204120000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 10:12 AM'
}, {
    'UniqueId': 'T100570',
    'DateTime': new Date(1503224040000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 03:44 PM'
}, {
    'UniqueId': 'T100571',
    'DateTime': new Date(1503234780000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/20/2017 06:43 PM'
}, {
    'UniqueId': 'T100572',
    'DateTime': new Date(1503287280000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/21/2017 09:18 AM'
}, {
    'UniqueId': 'T100573',
    'DateTime': new Date(1503306840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/21/2017 02:44 PM'
}, {
    'UniqueId': 'T100574',
    'DateTime': new Date(1503329100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/21/2017 08:55 PM'
}, {
    'UniqueId': 'T100575',
    'DateTime': new Date(1503290640000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/21/2017 10:14 AM'
}, {
    'UniqueId': 'T100576',
    'DateTime': new Date(1503309360000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/21/2017 03:26 PM'
}, {
    'UniqueId': 'T100577',
    'DateTime': new Date(1503376020000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 09:57 AM'
}, {
    'UniqueId': 'T100578',
    'DateTime': new Date(1503392880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 02:38 PM'
}, {
    'UniqueId': 'T100579',
    'DateTime': new Date(1503415680000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 08:58 PM'
}, {
    'UniqueId': 'T100580',
    'DateTime': new Date(1503378720000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 10:42 AM'
}, {
    'UniqueId': 'T100581',
    'DateTime': new Date(1503395040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 03:14 PM'
}, {
    'UniqueId': 'T100582',
    'DateTime': new Date(1503398640000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '55',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 04:14 PM'
}, {
    'UniqueId': 'T100583',
    'DateTime': new Date(1503398520000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '110',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/22/2017 04:12 PM'
}, {
    'UniqueId': 'T100584',
    'DateTime': new Date(1503461820000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 09:47 AM'
}, {
    'UniqueId': 'T100585',
    'DateTime': new Date(1503478620000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 02:27 PM'
}, {
    'UniqueId': 'T100586',
    'DateTime': new Date(1503500880000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 08:38 PM'
}, {
    'UniqueId': 'T100587',
    'DateTime': new Date(1503464160000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 10:26 AM'
}, {
    'UniqueId': 'T100588',
    'DateTime': new Date(1503483960000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 03:56 PM'
}, {
    'UniqueId': 'T100589',
    'DateTime': new Date(1503477960000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '40',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 02:16 PM'
}, {
    'UniqueId': 'T100590',
    'DateTime': new Date(1503478560000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '25',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 02:26 PM'
}, {
    'UniqueId': 'T100591',
    'DateTime': new Date(1503477840000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '4',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/23/2017 02:14 PM'
}, {
    'UniqueId': 'T100592',
    'DateTime': new Date(1503546780000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 09:23 AM'
}, {
    'UniqueId': 'T100593',
    'DateTime': new Date(1503566100000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 02:45 PM'
}, {
    'UniqueId': 'T100594',
    'DateTime': new Date(1503587520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 08:42 PM'
}, {
    'UniqueId': 'T100595',
    'DateTime': new Date(1503552240000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 10:54 AM'
}, {
    'UniqueId': 'T100596',
    'DateTime': new Date(1503568440000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 03:24 PM'
}, {
    'UniqueId': 'T100597',
    'DateTime': new Date(1503571680000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 04:18 PM'
}, {
    'UniqueId': 'T100598',
    'DateTime': new Date(1503571920000),
    'Category': 'Insurance',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Life and other personal insurance',
    'Amount': '250',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/24/2017 04:22 PM'
}, {
    'UniqueId': 'T100599',
    'DateTime': new Date(1503634680000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 09:48 AM'
}, {
    'UniqueId': 'T100600',
    'DateTime': new Date(1503651000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 02:20 PM'
}, {
    'UniqueId': 'T100601',
    'DateTime': new Date(1503672180000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 08:13 PM'
}, {
    'UniqueId': 'T100602',
    'DateTime': new Date(1503638880000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 10:58 AM'
}, {
    'UniqueId': 'T100603',
    'DateTime': new Date(1503656160000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 03:46 PM'
}, {
    'UniqueId': 'T100604',
    'DateTime': new Date(1503669960000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '65',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 07:36 PM'
}, {
    'UniqueId': 'T100605',
    'DateTime': new Date(1503669360000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '20',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 07:26 PM'
}, {
    'UniqueId': 'T100606',
    'DateTime': new Date(1503668760000),
    'Category': 'Tax',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Licenses and occupational taxes',
    'Amount': '180',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/25/2017 07:16 PM'
}, {
    'UniqueId': 'T100607',
    'DateTime': new Date(1503719040000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 09:14 AM'
}, {
    'UniqueId': 'T100608',
    'DateTime': new Date(1503737880000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 02:28 PM'
}, {
    'UniqueId': 'T100609',
    'DateTime': new Date(1503758400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 08:10 PM'
}, {
    'UniqueId': 'T100610',
    'DateTime': new Date(1503723480000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 10:28 AM'
}, {
    'UniqueId': 'T100611',
    'DateTime': new Date(1503742440000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 03:44 PM'
}, {
    'UniqueId': 'T100612',
    'DateTime': new Date(1503756540000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '20',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 07:39 PM'
}, {
    'UniqueId': 'T100613',
    'DateTime': new Date(1503756720000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '90',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/26/2017 07:42 PM'
}, {
    'UniqueId': 'T100614',
    'DateTime': new Date(1503805920000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 09:22 AM'
}, {
    'UniqueId': 'T100615',
    'DateTime': new Date(1503824280000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 02:28 PM'
}, {
    'UniqueId': 'T100616',
    'DateTime': new Date(1503845940000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '12',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 08:29 PM'
}, {
    'UniqueId': 'T100617',
    'DateTime': new Date(1503810840000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 10:44 AM'
}, {
    'UniqueId': 'T100618',
    'DateTime': new Date(1503828900000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 03:45 PM'
}, {
    'UniqueId': 'T100619',
    'DateTime': new Date(1503836400000),
    'Category': 'Health Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/27/2017 05:50 PM'
}, {
    'UniqueId': 'T100620',
    'DateTime': new Date(1503891660000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 09:11 AM'
}, {
    'UniqueId': 'T100621',
    'DateTime': new Date(1503911160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 02:36 PM'
}, {
    'UniqueId': 'T100622',
    'DateTime': new Date(1503933720000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 08:52 PM'
}, {
    'UniqueId': 'T100623',
    'DateTime': new Date(1503896280000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 10:28 AM'
}, {
    'UniqueId': 'T100624',
    'DateTime': new Date(1503915120000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 03:42 PM'
}, {
    'UniqueId': 'T100625',
    'DateTime': new Date(1503898140000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '220',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 10:59 AM'
}, {
    'UniqueId': 'T100626',
    'DateTime': new Date(1503896580000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '110',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/28/2017 10:33 AM'
}, {
    'UniqueId': 'T100627',
    'DateTime': new Date(1503979440000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '10',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 09:34 AM'
}, {
    'UniqueId': 'T100628',
    'DateTime': new Date(1503997860000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 02:41 PM'
}, {
    'UniqueId': 'T100629',
    'DateTime': new Date(1504019280000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 08:38 PM'
}, {
    'UniqueId': 'T100630',
    'DateTime': new Date(1503981600000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 10:10 AM'
}, {
    'UniqueId': 'T100631',
    'DateTime': new Date(1504000320000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 03:22 PM'
}, {
    'UniqueId': 'T100632',
    'DateTime': new Date(1504003260000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 04:11 PM'
}, {
    'UniqueId': 'T100633',
    'DateTime': new Date(1504003680000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '3',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/29/2017 04:18 PM'
}, {
    'UniqueId': 'T100634',
    'DateTime': new Date(1504067160000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 09:56 AM'
}, {
    'UniqueId': 'T100635',
    'DateTime': new Date(1504084680000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 02:48 PM'
}, {
    'UniqueId': 'T100636',
    'DateTime': new Date(1504106280000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 08:48 PM'
}, {
    'UniqueId': 'T100637',
    'DateTime': new Date(1504070700000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 10:55 AM'
}, {
    'UniqueId': 'T100638',
    'DateTime': new Date(1504086540000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 03:19 PM'
}, {
    'UniqueId': 'T100639',
    'DateTime': new Date(1504093740000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '40',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 05:19 PM'
}, {
    'UniqueId': 'T100640',
    'DateTime': new Date(1504095540000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '15',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 05:49 PM'
}, {
    'UniqueId': 'T100641',
    'DateTime': new Date(1504095540000),
    'Category': 'Education',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 05:49 PM'
}, {
    'UniqueId': 'T100642',
    'DateTime': new Date(1504095780000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from lottery',
    'Amount': '80',
    'MonthShort': 'Aug',
    'MonthFull': 'August, 2017',
    'FormattedDate': '08/30/2017 05:53 PM'
}, {
    'UniqueId': 'T100643',
    'DateTime': new Date(1504239060000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 09:41 AM'
}, {
    'UniqueId': 'T100644',
    'DateTime': new Date(1504255620000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 02:17 PM'
}, {
    'UniqueId': 'T100645',
    'DateTime': new Date(1504277340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 08:19 PM'
}, {
    'UniqueId': 'T100646',
    'DateTime': new Date(1504242720000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 10:42 AM'
}, {
    'UniqueId': 'T100647',
    'DateTime': new Date(1504259340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 03:19 PM'
}, {
    'UniqueId': 'T100648',
    'DateTime': new Date(1504261200000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 03:50 PM'
}, {
    'UniqueId': 'T100649',
    'DateTime': new Date(1504259640000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 03:24 PM'
}, {
    'UniqueId': 'T100650',
    'DateTime': new Date(1504259700000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '6000',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/01/2017 03:25 PM'
}, {
    'UniqueId': 'T100651',
    'DateTime': new Date(1504326180000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 09:53 AM'
}, {
    'UniqueId': 'T100652',
    'DateTime': new Date(1504341840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 02:14 PM'
}, {
    'UniqueId': 'T100653',
    'DateTime': new Date(1504365300000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 08:45 PM'
}, {
    'UniqueId': 'T100654',
    'DateTime': new Date(1504328460000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 10:31 AM'
}, {
    'UniqueId': 'T100655',
    'DateTime': new Date(1504347540000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 03:49 PM'
}, {
    'UniqueId': 'T100656',
    'DateTime': new Date(1504356060000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '40',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 06:11 PM'
}, {
    'UniqueId': 'T100657',
    'DateTime': new Date(1504357860000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/02/2017 06:41 PM'
}, {
    'UniqueId': 'T100658',
    'DateTime': new Date(1504410240000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 09:14 AM'
}, {
    'UniqueId': 'T100659',
    'DateTime': new Date(1504430100000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 02:45 PM'
}, {
    'UniqueId': 'T100660',
    'DateTime': new Date(1504450980000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 08:33 PM'
}, {
    'UniqueId': 'T100661',
    'DateTime': new Date(1504414500000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 10:25 AM'
}, {
    'UniqueId': 'T100662',
    'DateTime': new Date(1504433340000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 03:39 PM'
}, {
    'UniqueId': 'T100663',
    'DateTime': new Date(1504433700000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '190',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 03:45 PM'
}, {
    'UniqueId': 'T100664',
    'DateTime': new Date(1504433760000),
    'Category': 'Bills',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Telephone services',
    'Amount': '220',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/03/2017 03:46 PM'
}, {
    'UniqueId': 'T100665',
    'DateTime': new Date(1504496880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 09:18 AM'
}, {
    'UniqueId': 'T100666',
    'DateTime': new Date(1504515060000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 02:21 PM'
}, {
    'UniqueId': 'T100667',
    'DateTime': new Date(1504537740000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 08:39 PM'
}, {
    'UniqueId': 'T100668',
    'DateTime': new Date(1504500780000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 10:23 AM'
}, {
    'UniqueId': 'T100669',
    'DateTime': new Date(1504519320000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 03:32 PM'
}, {
    'UniqueId': 'T100670',
    'DateTime': new Date(1504537200000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 08:30 PM'
}, {
    'UniqueId': 'T100671',
    'DateTime': new Date(1504538280000),
    'Category': 'Personal Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Standard haircut',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 08:48 PM'
}, {
    'UniqueId': 'T100672',
    'DateTime': new Date(1504538400000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/04/2017 08:50 PM'
}, {
    'UniqueId': 'T100673',
    'DateTime': new Date(1504583340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 09:19 AM'
}, {
    'UniqueId': 'T100674',
    'DateTime': new Date(1504601220000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 02:17 PM'
}, {
    'UniqueId': 'T100675',
    'DateTime': new Date(1504624320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 08:42 PM'
}, {
    'UniqueId': 'T100676',
    'DateTime': new Date(1504588680000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 10:48 AM'
}, {
    'UniqueId': 'T100677',
    'DateTime': new Date(1504607040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 03:54 PM'
}, {
    'UniqueId': 'T100678',
    'DateTime': new Date(1504584060000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 09:31 AM'
}, {
    'UniqueId': 'T100679',
    'DateTime': new Date(1504582980000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/05/2017 09:13 AM'
}, {
    'UniqueId': 'T100680',
    'DateTime': new Date(1504672140000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 09:59 AM'
}, {
    'UniqueId': 'T100681',
    'DateTime': new Date(1504689720000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 02:52 PM'
}, {
    'UniqueId': 'T100682',
    'DateTime': new Date(1504710600000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 08:40 PM'
}, {
    'UniqueId': 'T100683',
    'DateTime': new Date(1504674720000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 10:42 AM'
}, {
    'UniqueId': 'T100684',
    'DateTime': new Date(1504692840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 03:44 PM'
}, {
    'UniqueId': 'T100685',
    'DateTime': new Date(1504689240000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 02:44 PM'
}, {
    'UniqueId': 'T100686',
    'DateTime': new Date(1504687440000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '100',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/06/2017 02:14 PM'
}, {
    'UniqueId': 'T100687',
    'DateTime': new Date(1504758000000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 09:50 AM'
}, {
    'UniqueId': 'T100688',
    'DateTime': new Date(1504773960000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 02:16 PM'
}, {
    'UniqueId': 'T100689',
    'DateTime': new Date(1504796760000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 08:36 PM'
}, {
    'UniqueId': 'T100690',
    'DateTime': new Date(1504759380000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 10:13 AM'
}, {
    'UniqueId': 'T100691',
    'DateTime': new Date(1504779720000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 03:52 PM'
}, {
    'UniqueId': 'T100692',
    'DateTime': new Date(1504797900000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Tennis Court Rent',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/07/2017 08:55 PM'
}, {
    'UniqueId': 'T100693',
    'DateTime': new Date(1504843980000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 09:43 AM'
}, {
    'UniqueId': 'T100694',
    'DateTime': new Date(1504860240000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 02:14 PM'
}, {
    'UniqueId': 'T100695',
    'DateTime': new Date(1504883640000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 08:44 PM'
}, {
    'UniqueId': 'T100696',
    'DateTime': new Date(1504847880000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 10:48 AM'
}, {
    'UniqueId': 'T100697',
    'DateTime': new Date(1504864740000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 03:29 PM'
}, {
    'UniqueId': 'T100698',
    'DateTime': new Date(1504862520000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 02:52 PM'
}, {
    'UniqueId': 'T100699',
    'DateTime': new Date(1504862220000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '560',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/08/2017 02:47 PM'
}, {
    'UniqueId': 'T100700',
    'DateTime': new Date(1504931340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 09:59 AM'
}, {
    'UniqueId': 'T100701',
    'DateTime': new Date(1504947360000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 02:26 PM'
}, {
    'UniqueId': 'T100702',
    'DateTime': new Date(1504970520000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 08:52 PM'
}, {
    'UniqueId': 'T100703',
    'DateTime': new Date(1504932420000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 10:17 AM'
}, {
    'UniqueId': 'T100704',
    'DateTime': new Date(1504951080000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 03:28 PM'
}, {
    'UniqueId': 'T100705',
    'DateTime': new Date(1504943400000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '35',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 01:20 PM'
}, {
    'UniqueId': 'T100706',
    'DateTime': new Date(1504944960000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance, repairs',
    'Amount': '15',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/09/2017 01:46 PM'
}, {
    'UniqueId': 'T100707',
    'DateTime': new Date(1505017620000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 09:57 AM'
}, {
    'UniqueId': 'T100708',
    'DateTime': new Date(1505034060000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 02:31 PM'
}, {
    'UniqueId': 'T100709',
    'DateTime': new Date(1505056680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 08:48 PM'
}, {
    'UniqueId': 'T100710',
    'DateTime': new Date(1505020620000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 10:47 AM'
}, {
    'UniqueId': 'T100711',
    'DateTime': new Date(1505038560000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 03:46 PM'
}, {
    'UniqueId': 'T100712',
    'DateTime': new Date(1505056200000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 08:40 PM'
}, {
    'UniqueId': 'T100713',
    'DateTime': new Date(1505056380000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '205',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/10/2017 08:43 PM'
}, {
    'UniqueId': 'T100714',
    'DateTime': new Date(1505102220000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 09:27 AM'
}, {
    'UniqueId': 'T100715',
    'DateTime': new Date(1505121480000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 02:48 PM'
}, {
    'UniqueId': 'T100716',
    'DateTime': new Date(1505140980000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 08:13 PM'
}, {
    'UniqueId': 'T100717',
    'DateTime': new Date(1505107680000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 10:58 AM'
}, {
    'UniqueId': 'T100718',
    'DateTime': new Date(1505123940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 03:29 PM'
}, {
    'UniqueId': 'T100719',
    'DateTime': new Date(1505101260000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 09:11 AM'
}, {
    'UniqueId': 'T100720',
    'DateTime': new Date(1505101800000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': '1 box of antibiotics (12 doses)',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 09:20 AM'
}, {
    'UniqueId': 'T100721',
    'DateTime': new Date(1505102460000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '180',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/11/2017 09:31 AM'
}, {
    'UniqueId': 'T100722',
    'DateTime': new Date(1505188080000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 09:18 AM'
}, {
    'UniqueId': 'T100723',
    'DateTime': new Date(1505207760000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 02:46 PM'
}, {
    'UniqueId': 'T100724',
    'DateTime': new Date(1505228520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 08:32 PM'
}, {
    'UniqueId': 'T100725',
    'DateTime': new Date(1505191320000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 10:12 AM'
}, {
    'UniqueId': 'T100726',
    'DateTime': new Date(1505210040000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 03:24 PM'
}, {
    'UniqueId': 'T100727',
    'DateTime': new Date(1505200500000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '25',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 12:45 PM'
}, {
    'UniqueId': 'T100728',
    'DateTime': new Date(1505198880000),
    'Category': 'Insurance',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal insurance',
    'Amount': '260',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/12/2017 12:18 PM'
}, {
    'UniqueId': 'T100729',
    'DateTime': new Date(1505275860000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 09:41 AM'
}, {
    'UniqueId': 'T100730',
    'DateTime': new Date(1505293200000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 02:30 PM'
}, {
    'UniqueId': 'T100731',
    'DateTime': new Date(1505315940000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 08:49 PM'
}, {
    'UniqueId': 'T100732',
    'DateTime': new Date(1505279580000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 10:43 AM'
}, {
    'UniqueId': 'T100733',
    'DateTime': new Date(1505296320000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 03:22 PM'
}, {
    'UniqueId': 'T100734',
    'DateTime': new Date(1505285580000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 12:23 PM'
}, {
    'UniqueId': 'T100735',
    'DateTime': new Date(1505287440000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly Pass (Regular Price)',
    'Amount': '3',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 12:54 PM'
}, {
    'UniqueId': 'T100736',
    'DateTime': new Date(1505286060000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from lottery',
    'Amount': '180',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/13/2017 12:31 PM'
}, {
    'UniqueId': 'T100737',
    'DateTime': new Date(1505361000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 09:20 AM'
}, {
    'UniqueId': 'T100738',
    'DateTime': new Date(1505380080000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 02:38 PM'
}, {
    'UniqueId': 'T100739',
    'DateTime': new Date(1505402760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 08:56 PM'
}, {
    'UniqueId': 'T100740',
    'DateTime': new Date(1505366940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 10:59 AM'
}, {
    'UniqueId': 'T100741',
    'DateTime': new Date(1505384700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 03:55 PM'
}, {
    'UniqueId': 'T100742',
    'DateTime': new Date(1505364240000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '200',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/14/2017 10:14 AM'
}, {
    'UniqueId': 'T100743',
    'DateTime': new Date(1505448120000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 09:32 AM'
}, {
    'UniqueId': 'T100744',
    'DateTime': new Date(1505465400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 02:20 PM'
}, {
    'UniqueId': 'T100745',
    'DateTime': new Date(1505486880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 08:18 PM'
}, {
    'UniqueId': 'T100746',
    'DateTime': new Date(1505453340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 10:59 AM'
}, {
    'UniqueId': 'T100747',
    'DateTime': new Date(1505469240000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 03:24 PM'
}, {
    'UniqueId': 'T100748',
    'DateTime': new Date(1505466780000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '65',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 02:43 PM'
}, {
    'UniqueId': 'T100749',
    'DateTime': new Date(1505467320000),
    'Category': 'Bills',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Telephone services',
    'Amount': '180',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 02:52 PM'
}, {
    'UniqueId': 'T100750',
    'DateTime': new Date(1505467740000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/15/2017 02:59 PM'
}, {
    'UniqueId': 'T100751',
    'DateTime': new Date(1505533680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 09:18 AM'
}, {
    'UniqueId': 'T100752',
    'DateTime': new Date(1505552760000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 02:36 PM'
}, {
    'UniqueId': 'T100753',
    'DateTime': new Date(1505574900000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 08:45 PM'
}, {
    'UniqueId': 'T100754',
    'DateTime': new Date(1505538600000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 10:40 AM'
}, {
    'UniqueId': 'T100755',
    'DateTime': new Date(1505555820000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 03:27 PM'
}, {
    'UniqueId': 'T100756',
    'DateTime': new Date(1505534100000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '40',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 09:25 AM'
}, {
    'UniqueId': 'T100757',
    'DateTime': new Date(1505535060000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 09:41 AM'
}, {
    'UniqueId': 'T100758',
    'DateTime': new Date(1505533680000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gym payment',
    'Amount': '2',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/16/2017 09:18 AM'
}, {
    'UniqueId': 'T100759',
    'DateTime': new Date(1505622360000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 09:56 AM'
}, {
    'UniqueId': 'T100760',
    'DateTime': new Date(1505638740000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 02:29 PM'
}, {
    'UniqueId': 'T100761',
    'DateTime': new Date(1505660220000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 08:27 PM'
}, {
    'UniqueId': 'T100762',
    'DateTime': new Date(1505624940000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 10:39 AM'
}, {
    'UniqueId': 'T100763',
    'DateTime': new Date(1505642700000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 03:35 PM'
}, {
    'UniqueId': 'T100764',
    'DateTime': new Date(1505656020000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '160',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/17/2017 07:17 PM'
}, {
    'UniqueId': 'T100765',
    'DateTime': new Date(1505707620000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 09:37 AM'
}, {
    'UniqueId': 'T100766',
    'DateTime': new Date(1505725260000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 02:31 PM'
}, {
    'UniqueId': 'T100767',
    'DateTime': new Date(1505745780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 08:13 PM'
}, {
    'UniqueId': 'T100768',
    'DateTime': new Date(1505709600000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 10:10 AM'
}, {
    'UniqueId': 'T100769',
    'DateTime': new Date(1505727600000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 03:10 PM'
}, {
    'UniqueId': 'T100770',
    'DateTime': new Date(1505745900000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '65',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 08:15 PM'
}, {
    'UniqueId': 'T100771',
    'DateTime': new Date(1505748120000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Standard haircut',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/18/2017 08:52 PM'
}, {
    'UniqueId': 'T100772',
    'DateTime': new Date(1505794500000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 09:45 AM'
}, {
    'UniqueId': 'T100773',
    'DateTime': new Date(1505811240000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 02:24 PM'
}, {
    'UniqueId': 'T100774',
    'DateTime': new Date(1505833200000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 08:30 PM'
}, {
    'UniqueId': 'T100775',
    'DateTime': new Date(1505798220000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 10:47 AM'
}, {
    'UniqueId': 'T100776',
    'DateTime': new Date(1505814600000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 03:20 PM'
}, {
    'UniqueId': 'T100777',
    'DateTime': new Date(1505833260000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance, repairs',
    'Amount': '30',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 08:31 PM'
}, {
    'UniqueId': 'T100778',
    'DateTime': new Date(1505832300000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 08:15 PM'
}, {
    'UniqueId': 'T100779',
    'DateTime': new Date(1505832480000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '110',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/19/2017 08:18 PM'
}, {
    'UniqueId': 'T100780',
    'DateTime': new Date(1505880780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 09:43 AM'
}, {
    'UniqueId': 'T100781',
    'DateTime': new Date(1505899620000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 02:57 PM'
}, {
    'UniqueId': 'T100782',
    'DateTime': new Date(1505920440000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 08:44 PM'
}, {
    'UniqueId': 'T100783',
    'DateTime': new Date(1505884320000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 10:42 AM'
}, {
    'UniqueId': 'T100784',
    'DateTime': new Date(1505903160000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 03:56 PM'
}, {
    'UniqueId': 'T100785',
    'DateTime': new Date(1505886660000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '90',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/20/2017 11:21 AM'
}, {
    'UniqueId': 'T100786',
    'DateTime': new Date(1505965320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/21/2017 09:12 AM'
}, {
    'UniqueId': 'T100787',
    'DateTime': new Date(1505985420000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/21/2017 02:47 PM'
}, {
    'UniqueId': 'T100788',
    'DateTime': new Date(1506006240000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/21/2017 08:34 PM'
}, {
    'UniqueId': 'T100789',
    'DateTime': new Date(1505971680000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/21/2017 10:58 AM'
}, {
    'UniqueId': 'T100790',
    'DateTime': new Date(1505988300000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/21/2017 03:35 PM'
}, {
    'UniqueId': 'T100791',
    'DateTime': new Date(1506054540000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 09:59 AM'
}, {
    'UniqueId': 'T100792',
    'DateTime': new Date(1506071880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 02:48 PM'
}, {
    'UniqueId': 'T100793',
    'DateTime': new Date(1506093960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 08:56 PM'
}, {
    'UniqueId': 'T100794',
    'DateTime': new Date(1506055260000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 10:11 AM'
}, {
    'UniqueId': 'T100795',
    'DateTime': new Date(1506075600000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 03:50 PM'
}, {
    'UniqueId': 'T100796',
    'DateTime': new Date(1506075540000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 03:49 PM'
}, {
    'UniqueId': 'T100797',
    'DateTime': new Date(1506075960000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '110',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/22/2017 03:56 PM'
}, {
    'UniqueId': 'T100798',
    'DateTime': new Date(1506139140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 09:29 AM'
}, {
    'UniqueId': 'T100799',
    'DateTime': new Date(1506156780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 02:23 PM'
}, {
    'UniqueId': 'T100800',
    'DateTime': new Date(1506180360000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 08:56 PM'
}, {
    'UniqueId': 'T100801',
    'DateTime': new Date(1506144300000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 10:55 AM'
}, {
    'UniqueId': 'T100802',
    'DateTime': new Date(1506161940000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 03:49 PM'
}, {
    'UniqueId': 'T100803',
    'DateTime': new Date(1506169020000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '40',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 05:47 PM'
}, {
    'UniqueId': 'T100804',
    'DateTime': new Date(1506168120000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance, repairs',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 05:32 PM'
}, {
    'UniqueId': 'T100805',
    'DateTime': new Date(1506167220000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cappuccino (regular)',
    'Amount': '5',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/23/2017 05:17 PM'
}, {
    'UniqueId': 'T100806',
    'DateTime': new Date(1506227340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 09:59 AM'
}, {
    'UniqueId': 'T100807',
    'DateTime': new Date(1506243480000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '6',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 02:28 PM'
}, {
    'UniqueId': 'T100808',
    'DateTime': new Date(1506264120000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 08:12 PM'
}, {
    'UniqueId': 'T100809',
    'DateTime': new Date(1506229440000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 10:34 AM'
}, {
    'UniqueId': 'T100810',
    'DateTime': new Date(1506248760000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 03:56 PM'
}, {
    'UniqueId': 'T100811',
    'DateTime': new Date(1506251400000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 04:40 PM'
}, {
    'UniqueId': 'T100812',
    'DateTime': new Date(1506251880000),
    'Category': 'Insurance',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '250',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/24/2017 04:48 PM'
}, {
    'UniqueId': 'T100813',
    'DateTime': new Date(1506311160000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 09:16 AM'
}, {
    'UniqueId': 'T100814',
    'DateTime': new Date(1506330180000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 02:33 PM'
}, {
    'UniqueId': 'T100815',
    'DateTime': new Date(1506350760000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 08:16 PM'
}, {
    'UniqueId': 'T100816',
    'DateTime': new Date(1506314520000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 10:12 AM'
}, {
    'UniqueId': 'T100817',
    'DateTime': new Date(1506334080000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 03:38 PM'
}, {
    'UniqueId': 'T100818',
    'DateTime': new Date(1506323880000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 12:48 PM'
}, {
    'UniqueId': 'T100819',
    'DateTime': new Date(1506322080000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': '1 box of antibiotics (12 doses)',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 12:18 PM'
}, {
    'UniqueId': 'T100820',
    'DateTime': new Date(1506321780000),
    'Category': 'Tax',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Estate and gift taxes',
    'Amount': '1180',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/25/2017 12:13 PM'
}, {
    'UniqueId': 'T100821',
    'DateTime': new Date(1506398640000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 09:34 AM'
}, {
    'UniqueId': 'T100822',
    'DateTime': new Date(1506416340000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 02:29 PM'
}, {
    'UniqueId': 'T100823',
    'DateTime': new Date(1506436980000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 08:13 PM'
}, {
    'UniqueId': 'T100824',
    'DateTime': new Date(1506402180000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 10:33 AM'
}, {
    'UniqueId': 'T100825',
    'DateTime': new Date(1506421200000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 03:50 PM'
}, {
    'UniqueId': 'T100826',
    'DateTime': new Date(1506420780000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '30',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 03:43 PM'
}, {
    'UniqueId': 'T100827',
    'DateTime': new Date(1506420300000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/26/2017 03:35 PM'
}, {
    'UniqueId': 'T100828',
    'DateTime': new Date(1506485700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 09:45 AM'
}, {
    'UniqueId': 'T100829',
    'DateTime': new Date(1506504420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 02:57 PM'
}, {
    'UniqueId': 'T100830',
    'DateTime': new Date(1506525660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 08:51 PM'
}, {
    'UniqueId': 'T100831',
    'DateTime': new Date(1506489660000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 10:51 AM'
}, {
    'UniqueId': 'T100832',
    'DateTime': new Date(1506507600000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 03:50 PM'
}, {
    'UniqueId': 'T100833',
    'DateTime': new Date(1506485760000),
    'Category': 'Health Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/27/2017 09:46 AM'
}, {
    'UniqueId': 'T100834',
    'DateTime': new Date(1506571920000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 09:42 AM'
}, {
    'UniqueId': 'T100835',
    'DateTime': new Date(1506589920000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 02:42 PM'
}, {
    'UniqueId': 'T100836',
    'DateTime': new Date(1506611040000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 08:34 PM'
}, {
    'UniqueId': 'T100837',
    'DateTime': new Date(1506574620000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 10:27 AM'
}, {
    'UniqueId': 'T100838',
    'DateTime': new Date(1506593880000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 03:48 PM'
}, {
    'UniqueId': 'T100839',
    'DateTime': new Date(1506585840000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Electricity bill',
    'Amount': '200',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 01:34 PM'
}, {
    'UniqueId': 'T100840',
    'DateTime': new Date(1506585480000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from investments',
    'Amount': '390',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/28/2017 01:28 PM'
}, {
    'UniqueId': 'T100841',
    'DateTime': new Date(1506656460000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 09:11 AM'
}, {
    'UniqueId': 'T100842',
    'DateTime': new Date(1506676260000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 02:41 PM'
}, {
    'UniqueId': 'T100843',
    'DateTime': new Date(1506698700000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 08:55 PM'
}, {
    'UniqueId': 'T100844',
    'DateTime': new Date(1506661200000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 10:30 AM'
}, {
    'UniqueId': 'T100845',
    'DateTime': new Date(1506680700000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 03:55 PM'
}, {
    'UniqueId': 'T100846',
    'DateTime': new Date(1506698820000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '55',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 08:57 PM'
}, {
    'UniqueId': 'T100847',
    'DateTime': new Date(1506696900000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '206',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/29/2017 08:25 PM'
}, {
    'UniqueId': 'T100848',
    'DateTime': new Date(1506745440000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 09:54 AM'
}, {
    'UniqueId': 'T100849',
    'DateTime': new Date(1506763200000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 02:50 PM'
}, {
    'UniqueId': 'T100850',
    'DateTime': new Date(1506783000000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 08:20 PM'
}, {
    'UniqueId': 'T100851',
    'DateTime': new Date(1506748740000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 10:49 AM'
}, {
    'UniqueId': 'T100852',
    'DateTime': new Date(1506766080000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 03:38 PM'
}, {
    'UniqueId': 'T100853',
    'DateTime': new Date(1506784560000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '45',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 08:46 PM'
}, {
    'UniqueId': 'T100854',
    'DateTime': new Date(1506784920000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '20',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 08:52 PM'
}, {
    'UniqueId': 'T100855',
    'DateTime': new Date(1506782760000),
    'Category': 'Education',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 08:16 PM'
}, {
    'UniqueId': 'T100856',
    'DateTime': new Date(1506782460000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '120',
    'MonthShort': 'Sep',
    'MonthFull': 'September, 2017',
    'FormattedDate': '09/30/2017 08:11 PM'
}, {
    'UniqueId': 'T100857',
    'DateTime': new Date(1506830940000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 09:39 AM'
}, {
    'UniqueId': 'T100858',
    'DateTime': new Date(1506848460000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 02:31 PM'
}, {
    'UniqueId': 'T100859',
    'DateTime': new Date(1506870900000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 08:45 PM'
}, {
    'UniqueId': 'T100860',
    'DateTime': new Date(1506833220000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 10:17 AM'
}, {
    'UniqueId': 'T100861',
    'DateTime': new Date(1506852600000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 03:40 PM'
}, {
    'UniqueId': 'T100862',
    'DateTime': new Date(1506865500000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 07:15 PM'
}, {
    'UniqueId': 'T100863',
    'DateTime': new Date(1506867000000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 07:40 PM'
}, {
    'UniqueId': 'T100864',
    'DateTime': new Date(1506865860000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '6000',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/01/2017 07:21 PM'
}, {
    'UniqueId': 'T100865',
    'DateTime': new Date(1506916620000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 09:27 AM'
}, {
    'UniqueId': 'T100866',
    'DateTime': new Date(1506936060000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 02:51 PM'
}, {
    'UniqueId': 'T100867',
    'DateTime': new Date(1506956880000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 08:38 PM'
}, {
    'UniqueId': 'T100868',
    'DateTime': new Date(1506921240000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 10:44 AM'
}, {
    'UniqueId': 'T100869',
    'DateTime': new Date(1506937800000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 03:20 PM'
}, {
    'UniqueId': 'T100870',
    'DateTime': new Date(1506944640000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '150',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 05:14 PM'
}, {
    'UniqueId': 'T100871',
    'DateTime': new Date(1506944880000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '15',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/02/2017 05:18 PM'
}, {
    'UniqueId': 'T100872',
    'DateTime': new Date(1507002420000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 09:17 AM'
}, {
    'UniqueId': 'T100873',
    'DateTime': new Date(1507020180000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 02:13 PM'
}, {
    'UniqueId': 'T100874',
    'DateTime': new Date(1507043160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 08:36 PM'
}, {
    'UniqueId': 'T100875',
    'DateTime': new Date(1507006140000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 10:19 AM'
}, {
    'UniqueId': 'T100876',
    'DateTime': new Date(1507024980000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 03:33 PM'
}, {
    'UniqueId': 'T100877',
    'DateTime': new Date(1507014300000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '160',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 12:35 PM'
}, {
    'UniqueId': 'T100878',
    'DateTime': new Date(1507013760000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '180',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/03/2017 12:26 PM'
}, {
    'UniqueId': 'T100879',
    'DateTime': new Date(1507089420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 09:27 AM'
}, {
    'UniqueId': 'T100880',
    'DateTime': new Date(1507107360000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 02:26 PM'
}, {
    'UniqueId': 'T100881',
    'DateTime': new Date(1507129680000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 08:38 PM'
}, {
    'UniqueId': 'T100882',
    'DateTime': new Date(1507094760000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 10:56 AM'
}, {
    'UniqueId': 'T100883',
    'DateTime': new Date(1507110840000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 03:24 PM'
}, {
    'UniqueId': 'T100884',
    'DateTime': new Date(1507107120000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '65',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 02:22 PM'
}, {
    'UniqueId': 'T100885',
    'DateTime': new Date(1507109040000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Short visit to private Doctor',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 02:54 PM'
}, {
    'UniqueId': 'T100886',
    'DateTime': new Date(1507107540000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/04/2017 02:29 PM'
}, {
    'UniqueId': 'T100887',
    'DateTime': new Date(1507176000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 09:30 AM'
}, {
    'UniqueId': 'T100888',
    'DateTime': new Date(1507193340000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 02:19 PM'
}, {
    'UniqueId': 'T100889',
    'DateTime': new Date(1507216260000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 08:41 PM'
}, {
    'UniqueId': 'T100890',
    'DateTime': new Date(1507179060000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 10:21 AM'
}, {
    'UniqueId': 'T100891',
    'DateTime': new Date(1507199340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 03:59 PM'
}, {
    'UniqueId': 'T100892',
    'DateTime': new Date(1507179960000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '30',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 10:36 AM'
}, {
    'UniqueId': 'T100893',
    'DateTime': new Date(1507181040000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Monthly Pass (Regular Price)',
    'Amount': '3',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/05/2017 10:54 AM'
}, {
    'UniqueId': 'T100894',
    'DateTime': new Date(1507263420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 09:47 AM'
}, {
    'UniqueId': 'T100895',
    'DateTime': new Date(1507281300000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 02:45 PM'
}, {
    'UniqueId': 'T100896',
    'DateTime': new Date(1507302780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 08:43 PM'
}, {
    'UniqueId': 'T100897',
    'DateTime': new Date(1507266600000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 10:40 AM'
}, {
    'UniqueId': 'T100898',
    'DateTime': new Date(1507283940000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 03:29 PM'
}, {
    'UniqueId': 'T100899',
    'DateTime': new Date(1507291500000),
    'Category': 'Health Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 05:35 PM'
}, {
    'UniqueId': 'T100900',
    'DateTime': new Date(1507291500000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/06/2017 05:35 PM'
}, {
    'UniqueId': 'T100901',
    'DateTime': new Date(1507347660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 09:11 AM'
}, {
    'UniqueId': 'T100902',
    'DateTime': new Date(1507368540000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 02:59 PM'
}, {
    'UniqueId': 'T100903',
    'DateTime': new Date(1507387320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 08:12 PM'
}, {
    'UniqueId': 'T100904',
    'DateTime': new Date(1507352220000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 10:27 AM'
}, {
    'UniqueId': 'T100905',
    'DateTime': new Date(1507370640000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 03:34 PM'
}, {
    'UniqueId': 'T100906',
    'DateTime': new Date(1507376460000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '105',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/07/2017 05:11 PM'
}, {
    'UniqueId': 'T100907',
    'DateTime': new Date(1507434960000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 09:26 AM'
}, {
    'UniqueId': 'T100908',
    'DateTime': new Date(1507453380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 02:33 PM'
}, {
    'UniqueId': 'T100909',
    'DateTime': new Date(1507475400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 08:40 PM'
}, {
    'UniqueId': 'T100910',
    'DateTime': new Date(1507440300000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 10:55 AM'
}, {
    'UniqueId': 'T100911',
    'DateTime': new Date(1507457400000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 03:40 PM'
}, {
    'UniqueId': 'T100912',
    'DateTime': new Date(1507434600000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 09:20 AM'
}, {
    'UniqueId': 'T100913',
    'DateTime': new Date(1507436880000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '90',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/08/2017 09:58 AM'
}, {
    'UniqueId': 'T100914',
    'DateTime': new Date(1507521720000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 09:32 AM'
}, {
    'UniqueId': 'T100915',
    'DateTime': new Date(1507539300000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 02:25 PM'
}, {
    'UniqueId': 'T100916',
    'DateTime': new Date(1507561320000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 08:32 PM'
}, {
    'UniqueId': 'T100917',
    'DateTime': new Date(1507526280000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 10:48 AM'
}, {
    'UniqueId': 'T100918',
    'DateTime': new Date(1507544340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 03:49 PM'
}, {
    'UniqueId': 'T100919',
    'DateTime': new Date(1507532460000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '145',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 12:31 PM'
}, {
    'UniqueId': 'T100920',
    'DateTime': new Date(1507531740000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '15',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/09/2017 12:19 PM'
}, {
    'UniqueId': 'T100921',
    'DateTime': new Date(1507608600000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 09:40 AM'
}, {
    'UniqueId': 'T100922',
    'DateTime': new Date(1507626600000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 02:40 PM'
}, {
    'UniqueId': 'T100923',
    'DateTime': new Date(1507647780000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 08:33 PM'
}, {
    'UniqueId': 'T100924',
    'DateTime': new Date(1507613220000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 10:57 AM'
}, {
    'UniqueId': 'T100925',
    'DateTime': new Date(1507628940000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 03:19 PM'
}, {
    'UniqueId': 'T100926',
    'DateTime': new Date(1507632360000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 04:16 PM'
}, {
    'UniqueId': 'T100927',
    'DateTime': new Date(1507634040000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cinema',
    'Amount': '4',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/10/2017 04:44 PM'
}, {
    'UniqueId': 'T100928',
    'DateTime': new Date(1507695060000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 09:41 AM'
}, {
    'UniqueId': 'T100929',
    'DateTime': new Date(1507712760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 02:36 PM'
}, {
    'UniqueId': 'T100930',
    'DateTime': new Date(1507733880000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 08:28 PM'
}, {
    'UniqueId': 'T100931',
    'DateTime': new Date(1507698960000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 10:46 AM'
}, {
    'UniqueId': 'T100932',
    'DateTime': new Date(1507716660000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 03:41 PM'
}, {
    'UniqueId': 'T100933',
    'DateTime': new Date(1507726260000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '50',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 06:21 PM'
}, {
    'UniqueId': 'T100934',
    'DateTime': new Date(1507728360000),
    'Category': 'Personal Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': '1 box of antibiotics (12 doses)',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 06:56 PM'
}, {
    'UniqueId': 'T100935',
    'DateTime': new Date(1507727700000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '120',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/11/2017 06:45 PM'
}, {
    'UniqueId': 'T100936',
    'DateTime': new Date(1507780980000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 09:33 AM'
}, {
    'UniqueId': 'T100937',
    'DateTime': new Date(1507799880000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 02:48 PM'
}, {
    'UniqueId': 'T100938',
    'DateTime': new Date(1507821660000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 08:51 PM'
}, {
    'UniqueId': 'T100939',
    'DateTime': new Date(1507783980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 10:23 AM'
}, {
    'UniqueId': 'T100940',
    'DateTime': new Date(1507804080000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 03:58 PM'
}, {
    'UniqueId': 'T100941',
    'DateTime': new Date(1507810680000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 05:48 PM'
}, {
    'UniqueId': 'T100942',
    'DateTime': new Date(1507810560000),
    'Category': 'Insurance',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '250',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/12/2017 05:46 PM'
}, {
    'UniqueId': 'T100943',
    'DateTime': new Date(1507866780000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 09:23 AM'
}, {
    'UniqueId': 'T100944',
    'DateTime': new Date(1507884900000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 02:25 PM'
}, {
    'UniqueId': 'T100945',
    'DateTime': new Date(1507905960000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 08:16 PM'
}, {
    'UniqueId': 'T100946',
    'DateTime': new Date(1507870680000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 10:28 AM'
}, {
    'UniqueId': 'T100947',
    'DateTime': new Date(1507889580000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 03:43 PM'
}, {
    'UniqueId': 'T100948',
    'DateTime': new Date(1507875720000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '60',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 11:52 AM'
}, {
    'UniqueId': 'T100949',
    'DateTime': new Date(1507875960000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly Pass (Regular Price)',
    'Amount': '2',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 11:56 AM'
}, {
    'UniqueId': 'T100950',
    'DateTime': new Date(1507875600000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/13/2017 11:50 AM'
}, {
    'UniqueId': 'T100951',
    'DateTime': new Date(1507955340000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 09:59 AM'
}, {
    'UniqueId': 'T100952',
    'DateTime': new Date(1507971420000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 02:27 PM'
}, {
    'UniqueId': 'T100953',
    'DateTime': new Date(1507992540000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 08:19 PM'
}, {
    'UniqueId': 'T100954',
    'DateTime': new Date(1507956720000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 10:22 AM'
}, {
    'UniqueId': 'T100955',
    'DateTime': new Date(1507976700000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 03:55 PM'
}, {
    'UniqueId': 'T100956',
    'DateTime': new Date(1507953840000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '190',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/14/2017 09:34 AM'
}, {
    'UniqueId': 'T100957',
    'DateTime': new Date(1508038860000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 09:11 AM'
}, {
    'UniqueId': 'T100958',
    'DateTime': new Date(1508057280000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 02:18 PM'
}, {
    'UniqueId': 'T100959',
    'DateTime': new Date(1508078940000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 08:19 PM'
}, {
    'UniqueId': 'T100960',
    'DateTime': new Date(1508042460000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 10:11 AM'
}, {
    'UniqueId': 'T100961',
    'DateTime': new Date(1508061180000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 03:23 PM'
}, {
    'UniqueId': 'T100962',
    'DateTime': new Date(1508065500000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '65',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 04:35 PM'
}, {
    'UniqueId': 'T100963',
    'DateTime': new Date(1508065380000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '180',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 04:33 PM'
}, {
    'UniqueId': 'T100964',
    'DateTime': new Date(1508064360000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '120',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/15/2017 04:16 PM'
}, {
    'UniqueId': 'T100965',
    'DateTime': new Date(1508126280000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 09:28 AM'
}, {
    'UniqueId': 'T100966',
    'DateTime': new Date(1508144040000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 02:24 PM'
}, {
    'UniqueId': 'T100967',
    'DateTime': new Date(1508167260000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 08:51 PM'
}, {
    'UniqueId': 'T100968',
    'DateTime': new Date(1508130120000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 10:32 AM'
}, {
    'UniqueId': 'T100969',
    'DateTime': new Date(1508147520000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 03:22 PM'
}, {
    'UniqueId': 'T100970',
    'DateTime': new Date(1508148420000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '150',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 03:37 PM'
}, {
    'UniqueId': 'T100971',
    'DateTime': new Date(1508148780000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '15',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 03:43 PM'
}, {
    'UniqueId': 'T100972',
    'DateTime': new Date(1508149560000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '104',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/16/2017 03:56 PM'
}, {
    'UniqueId': 'T100973',
    'DateTime': new Date(1508211900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 09:15 AM'
}, {
    'UniqueId': 'T100974',
    'DateTime': new Date(1508229600000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 02:10 PM'
}, {
    'UniqueId': 'T100975',
    'DateTime': new Date(1508251920000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 08:22 PM'
}, {
    'UniqueId': 'T100976',
    'DateTime': new Date(1508216640000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 10:34 AM'
}, {
    'UniqueId': 'T100977',
    'DateTime': new Date(1508234820000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 03:37 PM'
}, {
    'UniqueId': 'T100978',
    'DateTime': new Date(1508242140000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/17/2017 05:39 PM'
}, {
    'UniqueId': 'T100979',
    'DateTime': new Date(1508299980000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 09:43 AM'
}, {
    'UniqueId': 'T100980',
    'DateTime': new Date(1508317920000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 02:42 PM'
}, {
    'UniqueId': 'T100981',
    'DateTime': new Date(1508339820000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 08:47 PM'
}, {
    'UniqueId': 'T100982',
    'DateTime': new Date(1508302200000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 10:20 AM'
}, {
    'UniqueId': 'T100983',
    'DateTime': new Date(1508319600000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 03:10 PM'
}, {
    'UniqueId': 'T100984',
    'DateTime': new Date(1508316540000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '65',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 02:19 PM'
}, {
    'UniqueId': 'T100985',
    'DateTime': new Date(1508316000000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Standard haircut',
    'Amount': '15',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/18/2017 02:10 PM'
}, {
    'UniqueId': 'T100986',
    'DateTime': new Date(1508384880000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 09:18 AM'
}, {
    'UniqueId': 'T100987',
    'DateTime': new Date(1508404860000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 02:51 PM'
}, {
    'UniqueId': 'T100988',
    'DateTime': new Date(1508426280000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 08:48 PM'
}, {
    'UniqueId': 'T100989',
    'DateTime': new Date(1508389500000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 10:35 AM'
}, {
    'UniqueId': 'T100990',
    'DateTime': new Date(1508408400000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 03:50 PM'
}, {
    'UniqueId': 'T100991',
    'DateTime': new Date(1508424000000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other household products',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 08:10 PM'
}, {
    'UniqueId': 'T100992',
    'DateTime': new Date(1508425560000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '106',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 08:36 PM'
}, {
    'UniqueId': 'T100993',
    'DateTime': new Date(1508424840000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/19/2017 08:24 PM'
}, {
    'UniqueId': 'T100994',
    'DateTime': new Date(1508473140000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 09:49 AM'
}, {
    'UniqueId': 'T100995',
    'DateTime': new Date(1508491500000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 02:55 PM'
}, {
    'UniqueId': 'T100996',
    'DateTime': new Date(1508512620000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 08:47 PM'
}, {
    'UniqueId': 'T100997',
    'DateTime': new Date(1508475540000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 10:29 AM'
}, {
    'UniqueId': 'T100998',
    'DateTime': new Date(1508493060000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 03:21 PM'
}, {
    'UniqueId': 'T100999',
    'DateTime': new Date(1508488080000),
    'Category': 'Health Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/20/2017 01:58 PM'
}, {
    'UniqueId': 'T101000',
    'DateTime': new Date(1508559240000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/21/2017 09:44 AM'
}, {
    'UniqueId': 'T101001',
    'DateTime': new Date(1508576100000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/21/2017 02:25 PM'
}, {
    'UniqueId': 'T101002',
    'DateTime': new Date(1508597220000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/21/2017 08:17 PM'
}, {
    'UniqueId': 'T101003',
    'DateTime': new Date(1508563620000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/21/2017 10:57 AM'
}, {
    'UniqueId': 'T101004',
    'DateTime': new Date(1508579820000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/21/2017 03:27 PM'
}, {
    'UniqueId': 'T101005',
    'DateTime': new Date(1508644440000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 09:24 AM'
}, {
    'UniqueId': 'T101006',
    'DateTime': new Date(1508661660000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 02:11 PM'
}, {
    'UniqueId': 'T101007',
    'DateTime': new Date(1508684700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 08:35 PM'
}, {
    'UniqueId': 'T101008',
    'DateTime': new Date(1508649480000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 10:48 AM'
}, {
    'UniqueId': 'T101009',
    'DateTime': new Date(1508667360000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 03:46 PM'
}, {
    'UniqueId': 'T101010',
    'DateTime': new Date(1508654580000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 12:13 PM'
}, {
    'UniqueId': 'T101011',
    'DateTime': new Date(1508656320000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from returns',
    'Amount': '80',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/22/2017 12:42 PM'
}, {
    'UniqueId': 'T101012',
    'DateTime': new Date(1508730900000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 09:25 AM'
}, {
    'UniqueId': 'T101013',
    'DateTime': new Date(1508749020000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 02:27 PM'
}, {
    'UniqueId': 'T101014',
    'DateTime': new Date(1508772480000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 08:58 PM'
}, {
    'UniqueId': 'T101015',
    'DateTime': new Date(1508736240000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 10:54 AM'
}, {
    'UniqueId': 'T101016',
    'DateTime': new Date(1508754180000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 03:53 PM'
}, {
    'UniqueId': 'T101017',
    'DateTime': new Date(1508769600000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '140',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 08:10 PM'
}, {
    'UniqueId': 'T101018',
    'DateTime': new Date(1508772000000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Housekeeping supplies',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 08:50 PM'
}, {
    'UniqueId': 'T101019',
    'DateTime': new Date(1508772360000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cappuccino (regular)',
    'Amount': '4',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/23/2017 08:56 PM'
}, {
    'UniqueId': 'T101020',
    'DateTime': new Date(1508817840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 09:34 AM'
}, {
    'UniqueId': 'T101021',
    'DateTime': new Date(1508836740000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 02:49 PM'
}, {
    'UniqueId': 'T101022',
    'DateTime': new Date(1508856060000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 08:11 PM'
}, {
    'UniqueId': 'T101023',
    'DateTime': new Date(1508821860000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 10:41 AM'
}, {
    'UniqueId': 'T101024',
    'DateTime': new Date(1508838480000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 03:18 PM'
}, {
    'UniqueId': 'T101025',
    'DateTime': new Date(1508846340000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '140',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 05:29 PM'
}, {
    'UniqueId': 'T101026',
    'DateTime': new Date(1508845860000),
    'Category': 'Insurance',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Health insurance',
    'Amount': '230',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/24/2017 05:21 PM'
}, {
    'UniqueId': 'T101027',
    'DateTime': new Date(1508903400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 09:20 AM'
}, {
    'UniqueId': 'T101028',
    'DateTime': new Date(1508921220000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 02:17 PM'
}, {
    'UniqueId': 'T101029',
    'DateTime': new Date(1508943060000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 08:21 PM'
}, {
    'UniqueId': 'T101030',
    'DateTime': new Date(1508908560000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 10:46 AM'
}, {
    'UniqueId': 'T101031',
    'DateTime': new Date(1508927220000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 03:57 PM'
}, {
    'UniqueId': 'T101032',
    'DateTime': new Date(1508915100000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '55',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 12:35 PM'
}, {
    'UniqueId': 'T101033',
    'DateTime': new Date(1508915580000),
    'Category': 'Personal Care',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Deodorant, roll-on',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 12:43 PM'
}, {
    'UniqueId': 'T101034',
    'DateTime': new Date(1508913600000),
    'Category': 'Tax',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Sales and use tax',
    'Amount': '180',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/25/2017 12:10 PM'
}, {
    'UniqueId': 'T101035',
    'DateTime': new Date(1508989980000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 09:23 AM'
}, {
    'UniqueId': 'T101036',
    'DateTime': new Date(1509008760000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 02:36 PM'
}, {
    'UniqueId': 'T101037',
    'DateTime': new Date(1509029160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 08:16 PM'
}, {
    'UniqueId': 'T101038',
    'DateTime': new Date(1508995140000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 10:49 AM'
}, {
    'UniqueId': 'T101039',
    'DateTime': new Date(1509012000000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 03:30 PM'
}, {
    'UniqueId': 'T101040',
    'DateTime': new Date(1509022860000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '20',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 06:31 PM'
}, {
    'UniqueId': 'T101041',
    'DateTime': new Date(1509021960000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '90',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/26/2017 06:16 PM'
}, {
    'UniqueId': 'T101042',
    'DateTime': new Date(1509078240000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 09:54 AM'
}, {
    'UniqueId': 'T101043',
    'DateTime': new Date(1509094380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 02:23 PM'
}, {
    'UniqueId': 'T101044',
    'DateTime': new Date(1509117120000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '8',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 08:42 PM'
}, {
    'UniqueId': 'T101045',
    'DateTime': new Date(1509081120000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 10:42 AM'
}, {
    'UniqueId': 'T101046',
    'DateTime': new Date(1509098940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 03:39 PM'
}, {
    'UniqueId': 'T101047',
    'DateTime': new Date(1509090600000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/27/2017 01:20 PM'
}, {
    'UniqueId': 'T101048',
    'DateTime': new Date(1509164100000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 09:45 AM'
}, {
    'UniqueId': 'T101049',
    'DateTime': new Date(1509182160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 02:46 PM'
}, {
    'UniqueId': 'T101050',
    'DateTime': new Date(1509203460000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 08:41 PM'
}, {
    'UniqueId': 'T101051',
    'DateTime': new Date(1509166020000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 10:17 AM'
}, {
    'UniqueId': 'T101052',
    'DateTime': new Date(1509184620000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 03:27 PM'
}, {
    'UniqueId': 'T101053',
    'DateTime': new Date(1509187620000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '180',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 04:17 PM'
}, {
    'UniqueId': 'T101054',
    'DateTime': new Date(1509187200000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from investments',
    'Amount': '220',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/28/2017 04:10 PM'
}, {
    'UniqueId': 'T101055',
    'DateTime': new Date(1509250140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 09:39 AM'
}, {
    'UniqueId': 'T101056',
    'DateTime': new Date(1509268800000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 02:50 PM'
}, {
    'UniqueId': 'T101057',
    'DateTime': new Date(1509289080000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 08:28 PM'
}, {
    'UniqueId': 'T101058',
    'DateTime': new Date(1509254580000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 10:53 AM'
}, {
    'UniqueId': 'T101059',
    'DateTime': new Date(1509272340000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 03:49 PM'
}, {
    'UniqueId': 'T101060',
    'DateTime': new Date(1509272100000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '60',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 03:45 PM'
}, {
    'UniqueId': 'T101061',
    'DateTime': new Date(1509272460000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Debt repayment',
    'Amount': '2',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/29/2017 03:51 PM'
}, {
    'UniqueId': 'T101062',
    'DateTime': new Date(1509337380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 09:53 AM'
}, {
    'UniqueId': 'T101063',
    'DateTime': new Date(1509354240000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '12',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 02:34 PM'
}, {
    'UniqueId': 'T101064',
    'DateTime': new Date(1509376140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '6',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 08:39 PM'
}, {
    'UniqueId': 'T101065',
    'DateTime': new Date(1509339120000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 10:22 AM'
}, {
    'UniqueId': 'T101066',
    'DateTime': new Date(1509358140000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 03:39 PM'
}, {
    'UniqueId': 'T101067',
    'DateTime': new Date(1509355260000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Summer Dress in Store',
    'Amount': '150',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 02:51 PM'
}, {
    'UniqueId': 'T101068',
    'DateTime': new Date(1509355380000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '25',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 02:53 PM'
}, {
    'UniqueId': 'T101069',
    'DateTime': new Date(1509355380000),
    'Category': 'Education',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 02:53 PM'
}, {
    'UniqueId': 'T101070',
    'DateTime': new Date(1509354900000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '90',
    'MonthShort': 'Oct',
    'MonthFull': 'October, 2017',
    'FormattedDate': '10/30/2017 02:45 PM'
}, {
    'UniqueId': 'T101071',
    'DateTime': new Date(1509508980000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 09:33 AM'
}, {
    'UniqueId': 'T101072',
    'DateTime': new Date(1509525660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 02:11 PM'
}, {
    'UniqueId': 'T101073',
    'DateTime': new Date(1509547980000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 08:23 PM'
}, {
    'UniqueId': 'T101074',
    'DateTime': new Date(1509512040000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 10:24 AM'
}, {
    'UniqueId': 'T101075',
    'DateTime': new Date(1509530760000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 03:36 PM'
}, {
    'UniqueId': 'T101076',
    'DateTime': new Date(1509512520000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '50',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 10:32 AM'
}, {
    'UniqueId': 'T101077',
    'DateTime': new Date(1509512820000),
    'Category': 'Mortgage / Rent',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Monthly rent',
    'Amount': '1000',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 10:37 AM'
}, {
    'UniqueId': 'T101078',
    'DateTime': new Date(1509511800000),
    'Category': 'Salary',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Monthly Net Salary',
    'Amount': '6000',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/01/2017 10:20 AM'
}, {
    'UniqueId': 'T101079',
    'DateTime': new Date(1509596940000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 09:59 AM'
}, {
    'UniqueId': 'T101080',
    'DateTime': new Date(1509613500000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 02:35 PM'
}, {
    'UniqueId': 'T101081',
    'DateTime': new Date(1509636240000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 08:54 PM'
}, {
    'UniqueId': 'T101082',
    'DateTime': new Date(1509598860000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 10:31 AM'
}, {
    'UniqueId': 'T101083',
    'DateTime': new Date(1509616260000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 03:21 PM'
}, {
    'UniqueId': 'T101084',
    'DateTime': new Date(1509624360000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '40',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 05:36 PM'
}, {
    'UniqueId': 'T101085',
    'DateTime': new Date(1509624840000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '20',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/02/2017 05:44 PM'
}, {
    'UniqueId': 'T101086',
    'DateTime': new Date(1509681000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 09:20 AM'
}, {
    'UniqueId': 'T101087',
    'DateTime': new Date(1509699420000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 02:27 PM'
}, {
    'UniqueId': 'T101088',
    'DateTime': new Date(1509721380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 08:33 PM'
}, {
    'UniqueId': 'T101089',
    'DateTime': new Date(1509685320000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 10:32 AM'
}, {
    'UniqueId': 'T101090',
    'DateTime': new Date(1509702060000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 03:11 PM'
}, {
    'UniqueId': 'T101091',
    'DateTime': new Date(1509688800000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '150',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 11:30 AM'
}, {
    'UniqueId': 'T101092',
    'DateTime': new Date(1509689220000),
    'Category': 'Bills',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Electricity bill',
    'Amount': '220',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/03/2017 11:37 AM'
}, {
    'UniqueId': 'T101093',
    'DateTime': new Date(1509769320000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 09:52 AM'
}, {
    'UniqueId': 'T101094',
    'DateTime': new Date(1509785340000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 02:19 PM'
}, {
    'UniqueId': 'T101095',
    'DateTime': new Date(1509809040000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 08:54 PM'
}, {
    'UniqueId': 'T101096',
    'DateTime': new Date(1509770700000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 10:15 AM'
}, {
    'UniqueId': 'T101097',
    'DateTime': new Date(1509788820000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 03:17 PM'
}, {
    'UniqueId': 'T101098',
    'DateTime': new Date(1509767100000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '60',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 09:15 AM'
}, {
    'UniqueId': 'T101099',
    'DateTime': new Date(1509768420000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Standard haircut',
    'Amount': '15',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 09:37 AM'
}, {
    'UniqueId': 'T101100',
    'DateTime': new Date(1509767880000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '120',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/04/2017 09:28 AM'
}, {
    'UniqueId': 'T101101',
    'DateTime': new Date(1509854880000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 09:38 AM'
}, {
    'UniqueId': 'T101102',
    'DateTime': new Date(1509872760000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 02:36 PM'
}, {
    'UniqueId': 'T101103',
    'DateTime': new Date(1509895680000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 08:58 PM'
}, {
    'UniqueId': 'T101104',
    'DateTime': new Date(1509858000000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 10:30 AM'
}, {
    'UniqueId': 'T101105',
    'DateTime': new Date(1509877140000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 03:49 PM'
}, {
    'UniqueId': 'T101106',
    'DateTime': new Date(1509887280000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '25',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 06:38 PM'
}, {
    'UniqueId': 'T101107',
    'DateTime': new Date(1509886020000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fitness Club',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/05/2017 06:17 PM'
}, {
    'UniqueId': 'T101108',
    'DateTime': new Date(1509939780000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 09:13 AM'
}, {
    'UniqueId': 'T101109',
    'DateTime': new Date(1509959400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 02:40 PM'
}, {
    'UniqueId': 'T101110',
    'DateTime': new Date(1509980700000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 08:35 PM'
}, {
    'UniqueId': 'T101111',
    'DateTime': new Date(1509945660000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 10:51 AM'
}, {
    'UniqueId': 'T101112',
    'DateTime': new Date(1509962340000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 03:29 PM'
}, {
    'UniqueId': 'T101113',
    'DateTime': new Date(1509970620000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '180',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 05:47 PM'
}, {
    'UniqueId': 'T101114',
    'DateTime': new Date(1509969780000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Funds',
    'Amount': '110',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/06/2017 05:33 PM'
}, {
    'UniqueId': 'T101115',
    'DateTime': new Date(1510026420000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 09:17 AM'
}, {
    'UniqueId': 'T101116',
    'DateTime': new Date(1510044840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 02:24 PM'
}, {
    'UniqueId': 'T101117',
    'DateTime': new Date(1510065840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 08:14 PM'
}, {
    'UniqueId': 'T101118',
    'DateTime': new Date(1510032060000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 10:51 AM'
}, {
    'UniqueId': 'T101119',
    'DateTime': new Date(1510047600000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 03:10 PM'
}, {
    'UniqueId': 'T101120',
    'DateTime': new Date(1510055880000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Taxi Start (Normal Tariff)',
    'Amount': '5',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/07/2017 05:28 PM'
}, {
    'UniqueId': 'T101121',
    'DateTime': new Date(1510112460000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 09:11 AM'
}, {
    'UniqueId': 'T101122',
    'DateTime': new Date(1510132440000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 02:44 PM'
}, {
    'UniqueId': 'T101123',
    'DateTime': new Date(1510154520000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 08:52 PM'
}, {
    'UniqueId': 'T101124',
    'DateTime': new Date(1510117500000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 10:35 AM'
}, {
    'UniqueId': 'T101125',
    'DateTime': new Date(1510134480000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 03:18 PM'
}, {
    'UniqueId': 'T101126',
    'DateTime': new Date(1510124700000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '50',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 12:35 PM'
}, {
    'UniqueId': 'T101127',
    'DateTime': new Date(1510125780000),
    'Category': 'Interests',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Interests',
    'Amount': '90',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/08/2017 12:53 PM'
}, {
    'UniqueId': 'T101128',
    'DateTime': new Date(1510199640000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 09:24 AM'
}, {
    'UniqueId': 'T101129',
    'DateTime': new Date(1510219080000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 02:48 PM'
}, {
    'UniqueId': 'T101130',
    'DateTime': new Date(1510239780000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 08:33 PM'
}, {
    'UniqueId': 'T101131',
    'DateTime': new Date(1510202580000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 10:13 AM'
}, {
    'UniqueId': 'T101132',
    'DateTime': new Date(1510221000000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 03:20 PM'
}, {
    'UniqueId': 'T101133',
    'DateTime': new Date(1510217160000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '45',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 02:16 PM'
}, {
    'UniqueId': 'T101134',
    'DateTime': new Date(1510219020000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household textiles',
    'Amount': '15',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/09/2017 02:47 PM'
}, {
    'UniqueId': 'T101135',
    'DateTime': new Date(1510286100000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 09:25 AM'
}, {
    'UniqueId': 'T101136',
    'DateTime': new Date(1510305720000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 02:52 PM'
}, {
    'UniqueId': 'T101137',
    'DateTime': new Date(1510325580000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 08:23 PM'
}, {
    'UniqueId': 'T101138',
    'DateTime': new Date(1510290540000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 10:39 AM'
}, {
    'UniqueId': 'T101139',
    'DateTime': new Date(1510307520000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 03:22 PM'
}, {
    'UniqueId': 'T101140',
    'DateTime': new Date(1510298640000),
    'Category': 'Utilities',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '160',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 12:54 PM'
}, {
    'UniqueId': 'T101141',
    'DateTime': new Date(1510298160000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Movie Outing',
    'Amount': '5',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/10/2017 12:46 PM'
}, {
    'UniqueId': 'T101142',
    'DateTime': new Date(1510374000000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 09:50 AM'
}, {
    'UniqueId': 'T101143',
    'DateTime': new Date(1510390320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 02:22 PM'
}, {
    'UniqueId': 'T101144',
    'DateTime': new Date(1510411260000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 08:11 PM'
}, {
    'UniqueId': 'T101145',
    'DateTime': new Date(1510375980000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 10:23 AM'
}, {
    'UniqueId': 'T101146',
    'DateTime': new Date(1510395540000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 03:49 PM'
}, {
    'UniqueId': 'T101147',
    'DateTime': new Date(1510406880000),
    'Category': 'Shopping',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '65',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 06:58 PM'
}, {
    'UniqueId': 'T101148',
    'DateTime': new Date(1510405500000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Deodorant, roll-on',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 06:35 PM'
}, {
    'UniqueId': 'T101149',
    'DateTime': new Date(1510405980000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '120',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/11/2017 06:43 PM'
}, {
    'UniqueId': 'T101150',
    'DateTime': new Date(1510459080000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 09:28 AM'
}, {
    'UniqueId': 'T101151',
    'DateTime': new Date(1510476960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 02:26 PM'
}, {
    'UniqueId': 'T101152',
    'DateTime': new Date(1510498560000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 08:26 PM'
}, {
    'UniqueId': 'T101153',
    'DateTime': new Date(1510464540000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 10:59 AM'
}, {
    'UniqueId': 'T101154',
    'DateTime': new Date(1510481760000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 03:46 PM'
}, {
    'UniqueId': 'T101155',
    'DateTime': new Date(1510499640000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '25',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 08:44 PM'
}, {
    'UniqueId': 'T101156',
    'DateTime': new Date(1510498020000),
    'Category': 'Insurance',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '230',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/12/2017 08:17 PM'
}, {
    'UniqueId': 'T101157',
    'DateTime': new Date(1510544400000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 09:10 AM'
}, {
    'UniqueId': 'T101158',
    'DateTime': new Date(1510562400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 02:10 PM'
}, {
    'UniqueId': 'T101159',
    'DateTime': new Date(1510585620000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 08:37 PM'
}, {
    'UniqueId': 'T101160',
    'DateTime': new Date(1510550940000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 10:59 AM'
}, {
    'UniqueId': 'T101161',
    'DateTime': new Date(1510566240000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 03:14 PM'
}, {
    'UniqueId': 'T101162',
    'DateTime': new Date(1510580640000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '180',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 07:14 PM'
}, {
    'UniqueId': 'T101163',
    'DateTime': new Date(1510582860000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Tennis Court Rent',
    'Amount': '2',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 07:51 PM'
}, {
    'UniqueId': 'T101164',
    'DateTime': new Date(1510581840000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '90',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/13/2017 07:34 PM'
}, {
    'UniqueId': 'T101165',
    'DateTime': new Date(1510632960000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 09:46 AM'
}, {
    'UniqueId': 'T101166',
    'DateTime': new Date(1510651740000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 02:59 PM'
}, {
    'UniqueId': 'T101167',
    'DateTime': new Date(1510671480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 08:28 PM'
}, {
    'UniqueId': 'T101168',
    'DateTime': new Date(1510636980000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 10:53 AM'
}, {
    'UniqueId': 'T101169',
    'DateTime': new Date(1510652520000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 03:12 PM'
}, {
    'UniqueId': 'T101170',
    'DateTime': new Date(1510642980000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Own Buisness',
    'Amount': '190',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/14/2017 12:33 PM'
}, {
    'UniqueId': 'T101171',
    'DateTime': new Date(1510719960000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 09:56 AM'
}, {
    'UniqueId': 'T101172',
    'DateTime': new Date(1510735980000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 02:23 PM'
}, {
    'UniqueId': 'T101173',
    'DateTime': new Date(1510757460000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 08:21 PM'
}, {
    'UniqueId': 'T101174',
    'DateTime': new Date(1510723320000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 10:52 AM'
}, {
    'UniqueId': 'T101175',
    'DateTime': new Date(1510738980000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 03:13 PM'
}, {
    'UniqueId': 'T101176',
    'DateTime': new Date(1510719060000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Personal things',
    'Amount': '65',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 09:41 AM'
}, {
    'UniqueId': 'T101177',
    'DateTime': new Date(1510718820000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cellular phone service',
    'Amount': '220',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 09:37 AM'
}, {
    'UniqueId': 'T101178',
    'DateTime': new Date(1510719600000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Interest from Deposit',
    'Amount': '100',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/15/2017 09:50 AM'
}, {
    'UniqueId': 'T101179',
    'DateTime': new Date(1510804920000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 09:32 AM'
}, {
    'UniqueId': 'T101180',
    'DateTime': new Date(1510823340000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 02:39 PM'
}, {
    'UniqueId': 'T101181',
    'DateTime': new Date(1510845660000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 08:51 PM'
}, {
    'UniqueId': 'T101182',
    'DateTime': new Date(1510807920000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 10:22 AM'
}, {
    'UniqueId': 'T101183',
    'DateTime': new Date(1510826940000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 03:39 PM'
}, {
    'UniqueId': 'T101184',
    'DateTime': new Date(1510816260000),
    'Category': 'Clothing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '135',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 12:41 PM'
}, {
    'UniqueId': 'T101185',
    'DateTime': new Date(1510816320000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Household furnishings',
    'Amount': '20',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 12:42 PM'
}, {
    'UniqueId': 'T101186',
    'DateTime': new Date(1510814640000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema',
    'Amount': '3',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/16/2017 12:14 PM'
}, {
    'UniqueId': 'T101187',
    'DateTime': new Date(1510891800000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 09:40 AM'
}, {
    'UniqueId': 'T101188',
    'DateTime': new Date(1510909320000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 02:32 PM'
}, {
    'UniqueId': 'T101189',
    'DateTime': new Date(1510931400000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 08:40 PM'
}, {
    'UniqueId': 'T101190',
    'DateTime': new Date(1510893960000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 10:16 AM'
}, {
    'UniqueId': 'T101191',
    'DateTime': new Date(1510913700000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 03:45 PM'
}, {
    'UniqueId': 'T101192',
    'DateTime': new Date(1510890420000),
    'Category': 'Utilities',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '160',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/17/2017 09:17 AM'
}, {
    'UniqueId': 'T101193',
    'DateTime': new Date(1510977480000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 09:28 AM'
}, {
    'UniqueId': 'T101194',
    'DateTime': new Date(1510994580000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 02:13 PM'
}, {
    'UniqueId': 'T101195',
    'DateTime': new Date(1511017740000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 08:39 PM'
}, {
    'UniqueId': 'T101196',
    'DateTime': new Date(1510981620000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 10:37 AM'
}, {
    'UniqueId': 'T101197',
    'DateTime': new Date(1510998960000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 03:26 PM'
}, {
    'UniqueId': 'T101198',
    'DateTime': new Date(1510993320000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '60',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 01:52 PM'
}, {
    'UniqueId': 'T101199',
    'DateTime': new Date(1510992960000),
    'Category': 'Personal Care',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': '1 box of antibiotics (12 doses)',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/18/2017 01:46 PM'
}, {
    'UniqueId': 'T101200',
    'DateTime': new Date(1511064780000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 09:43 AM'
}, {
    'UniqueId': 'T101201',
    'DateTime': new Date(1511082840000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 02:44 PM'
}, {
    'UniqueId': 'T101202',
    'DateTime': new Date(1511104500000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 08:45 PM'
}, {
    'UniqueId': 'T101203',
    'DateTime': new Date(1511066400000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 10:10 AM'
}, {
    'UniqueId': 'T101204',
    'DateTime': new Date(1511086260000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 03:41 PM'
}, {
    'UniqueId': 'T101205',
    'DateTime': new Date(1511095680000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '30',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 06:18 PM'
}, {
    'UniqueId': 'T101206',
    'DateTime': new Date(1511096820000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cappuccino (regular)',
    'Amount': '3',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 06:37 PM'
}, {
    'UniqueId': 'T101207',
    'DateTime': new Date(1511098140000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Gits',
    'Amount': '90',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/19/2017 06:59 PM'
}, {
    'UniqueId': 'T101208',
    'DateTime': new Date(1511151240000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Boiled peanuts',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 09:44 AM'
}, {
    'UniqueId': 'T101209',
    'DateTime': new Date(1511169600000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 02:50 PM'
}, {
    'UniqueId': 'T101210',
    'DateTime': new Date(1511190960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Creole cream cheese',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 08:46 PM'
}, {
    'UniqueId': 'T101211',
    'DateTime': new Date(1511152920000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 10:12 AM'
}, {
    'UniqueId': 'T101212',
    'DateTime': new Date(1511173680000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 03:58 PM'
}, {
    'UniqueId': 'T101213',
    'DateTime': new Date(1511171760000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '170',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/20/2017 03:26 PM'
}, {
    'UniqueId': 'T101214',
    'DateTime': new Date(1511238120000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/21/2017 09:52 AM'
}, {
    'UniqueId': 'T101215',
    'DateTime': new Date(1511253960000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Frito pie, Muscadine wine and juice',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/21/2017 02:16 PM'
}, {
    'UniqueId': 'T101216',
    'DateTime': new Date(1511276400000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/21/2017 08:30 PM'
}, {
    'UniqueId': 'T101217',
    'DateTime': new Date(1511241540000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/21/2017 10:49 AM'
}, {
    'UniqueId': 'T101218',
    'DateTime': new Date(1511259960000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Gasoline and motor oil',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/21/2017 03:56 PM'
}, {
    'UniqueId': 'T101219',
    'DateTime': new Date(1511324220000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 09:47 AM'
}, {
    'UniqueId': 'T101220',
    'DateTime': new Date(1511342520000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 02:52 PM'
}, {
    'UniqueId': 'T101221',
    'DateTime': new Date(1511361720000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 08:12 PM'
}, {
    'UniqueId': 'T101222',
    'DateTime': new Date(1511326020000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 10:17 AM'
}, {
    'UniqueId': 'T101223',
    'DateTime': new Date(1511345640000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 03:44 PM'
}, {
    'UniqueId': 'T101224',
    'DateTime': new Date(1511322780000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '50',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 09:23 AM'
}, {
    'UniqueId': 'T101225',
    'DateTime': new Date(1511322720000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '80',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/22/2017 09:22 AM'
}, {
    'UniqueId': 'T101226',
    'DateTime': new Date(1511408940000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 09:19 AM'
}, {
    'UniqueId': 'T101227',
    'DateTime': new Date(1511426640000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 02:14 PM'
}, {
    'UniqueId': 'T101228',
    'DateTime': new Date(1511448720000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 08:22 PM'
}, {
    'UniqueId': 'T101229',
    'DateTime': new Date(1511414520000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 10:52 AM'
}, {
    'UniqueId': 'T101230',
    'DateTime': new Date(1511430780000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 03:23 PM'
}, {
    'UniqueId': 'T101231',
    'DateTime': new Date(1511427480000),
    'Category': 'Clothing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Jeans',
    'Amount': '140',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 02:28 PM'
}, {
    'UniqueId': 'T101232',
    'DateTime': new Date(1511426880000),
    'Category': 'Housing',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Major appliances, housewares',
    'Amount': '30',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 02:18 PM'
}, {
    'UniqueId': 'T101233',
    'DateTime': new Date(1511427060000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Taxi Start (Normal Tariff)',
    'Amount': '4',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/23/2017 02:21 PM'
}, {
    'UniqueId': 'T101234',
    'DateTime': new Date(1511497140000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Chicken salad, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 09:49 AM'
}, {
    'UniqueId': 'T101235',
    'DateTime': new Date(1511514540000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Pimento cheese sandwich',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 02:39 PM'
}, {
    'UniqueId': 'T101236',
    'DateTime': new Date(1511534940000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Confederate cush',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 08:19 PM'
}, {
    'UniqueId': 'T101237',
    'DateTime': new Date(1511498460000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 10:11 AM'
}, {
    'UniqueId': 'T101238',
    'DateTime': new Date(1511517900000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 03:35 PM'
}, {
    'UniqueId': 'T101239',
    'DateTime': new Date(1511514060000),
    'Category': 'Utilities',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Expense for Utilities',
    'Amount': '130',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 02:31 PM'
}, {
    'UniqueId': 'T101240',
    'DateTime': new Date(1511515740000),
    'Category': 'Insurance',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle insurance',
    'Amount': '250',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/24/2017 02:59 PM'
}, {
    'UniqueId': 'T101241',
    'DateTime': new Date(1511582580000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vienna sausages, Mello Yello',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 09:33 AM'
}, {
    'UniqueId': 'T101242',
    'DateTime': new Date(1511602140000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 02:59 PM'
}, {
    'UniqueId': 'T101243',
    'DateTime': new Date(1511622240000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 08:34 PM'
}, {
    'UniqueId': 'T101244',
    'DateTime': new Date(1511586120000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 10:32 AM'
}, {
    'UniqueId': 'T101245',
    'DateTime': new Date(1511604720000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 03:42 PM'
}, {
    'UniqueId': 'T101246',
    'DateTime': new Date(1511608140000),
    'Category': 'Shopping',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Household things \u0026 Utilities',
    'Amount': '60',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 04:39 PM'
}, {
    'UniqueId': 'T101247',
    'DateTime': new Date(1511608560000),
    'Category': 'Personal Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Cold medicine',
    'Amount': '15',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 04:46 PM'
}, {
    'UniqueId': 'T101248',
    'DateTime': new Date(1511608620000),
    'Category': 'Tax',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Social Security and Medicare taxes',
    'Amount': '180',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/25/2017 04:47 PM'
}, {
    'UniqueId': 'T101249',
    'DateTime': new Date(1511668380000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 09:23 AM'
}, {
    'UniqueId': 'T101250',
    'DateTime': new Date(1511688360000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanut butter and banana sandwich',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 02:56 PM'
}, {
    'UniqueId': 'T101251',
    'DateTime': new Date(1511707800000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Beer cheese',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 08:20 PM'
}, {
    'UniqueId': 'T101252',
    'DateTime': new Date(1511673060000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 10:41 AM'
}, {
    'UniqueId': 'T101253',
    'DateTime': new Date(1511691600000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 03:50 PM'
}, {
    'UniqueId': 'T101254',
    'DateTime': new Date(1511673300000),
    'Category': 'Housing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '25',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 10:45 AM'
}, {
    'UniqueId': 'T101255',
    'DateTime': new Date(1511672400000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from refund',
    'Amount': '80',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/26/2017 10:30 AM'
}, {
    'UniqueId': 'T101256',
    'DateTime': new Date(1511754000000),
    'Category': 'Food',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Po\u0027 boy sandwich, RC Cola',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 09:10 AM'
}, {
    'UniqueId': 'T101257',
    'DateTime': new Date(1511772000000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 02:10 PM'
}, {
    'UniqueId': 'T101258',
    'DateTime': new Date(1511795280000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pickled pigs feet',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 08:38 PM'
}, {
    'UniqueId': 'T101259',
    'DateTime': new Date(1511758980000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 10:33 AM'
}, {
    'UniqueId': 'T101260',
    'DateTime': new Date(1511777220000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 03:37 PM'
}, {
    'UniqueId': 'T101261',
    'DateTime': new Date(1511779860000),
    'Category': 'Health Care',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Health Care',
    'Amount': '70',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/27/2017 04:21 PM'
}, {
    'UniqueId': 'T101262',
    'DateTime': new Date(1511843160000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Fatback or hog jowl',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 09:56 AM'
}, {
    'UniqueId': 'T101263',
    'DateTime': new Date(1511860740000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cheese straws, Red Rock Cola',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 02:49 PM'
}, {
    'UniqueId': 'T101264',
    'DateTime': new Date(1511880480000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 08:18 PM'
}, {
    'UniqueId': 'T101265',
    'DateTime': new Date(1511844420000),
    'Category': 'Transportation',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '9',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 10:17 AM'
}, {
    'UniqueId': 'T101266',
    'DateTime': new Date(1511862300000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Maintenance and repairs',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 03:15 PM'
}, {
    'UniqueId': 'T101267',
    'DateTime': new Date(1511853300000),
    'Category': 'Bills',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Electricity bill',
    'Amount': '180',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 12:45 PM'
}, {
    'UniqueId': 'T101268',
    'DateTime': new Date(1511851440000),
    'Category': 'Business',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from investments',
    'Amount': '200',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/28/2017 12:14 PM'
}, {
    'UniqueId': 'T101269',
    'DateTime': new Date(1511928300000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 09:35 AM'
}, {
    'UniqueId': 'T101270',
    'DateTime': new Date(1511946300000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Steen\u0027s cane syrup',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 02:35 PM'
}, {
    'UniqueId': 'T101271',
    'DateTime': new Date(1511968380000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Peanuts in Coke',
    'Amount': '8',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 08:43 PM'
}, {
    'UniqueId': 'T101272',
    'DateTime': new Date(1511932260000),
    'Category': 'Transportation',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Vehicle purchases',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 10:41 AM'
}, {
    'UniqueId': 'T101273',
    'DateTime': new Date(1511950860000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Public and other transportation',
    'Amount': '11',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 03:51 PM'
}, {
    'UniqueId': 'T101274',
    'DateTime': new Date(1511965200000),
    'Category': 'Shopping',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Beauty care things',
    'Amount': '65',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 07:50 PM'
}, {
    'UniqueId': 'T101275',
    'DateTime': new Date(1511963040000),
    'Category': 'Miscellaneous',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cinema, International Release',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/29/2017 07:14 PM'
}, {
    'UniqueId': 'T101276',
    'DateTime': new Date(1512015840000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '12',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 09:54 AM'
}, {
    'UniqueId': 'T101277',
    'DateTime': new Date(1512033060000),
    'Category': 'Food',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Muffuletta sandwich, Mint julep',
    'Amount': '10',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 02:41 PM'
}, {
    'UniqueId': 'T101278',
    'DateTime': new Date(1512042720000),
    'Category': 'Food',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Palmetto Cheese, Mint julep',
    'Amount': '6',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 08:22 PM'
}, {
    'UniqueId': 'T101279',
    'DateTime': new Date(1512018360000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Cars and trucks, used',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 10:36 AM'
}, {
    'UniqueId': 'T101280',
    'DateTime': new Date(1512036720000),
    'Category': 'Transportation',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Other vehicle expenses',
    'Amount': '7',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 03:42 PM'
}, {
    'UniqueId': 'T101281',
    'DateTime': new Date(1512033060000),
    'Category': 'Clothing',
    'PaymentMode': 'Debit Card',
    'TransactionType': 'Expense',
    'Description': 'Pair of Running Shoes',
    'Amount': '45',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 02:41 PM'
}, {
    'UniqueId': 'T101282',
    'DateTime': new Date(1512033720000),
    'Category': 'Housing',
    'PaymentMode': 'Credit Card',
    'TransactionType': 'Expense',
    'Description': 'Laundry and cleaning supplies',
    'Amount': '20',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 02:52 PM'
}, {
    'UniqueId': 'T101283',
    'DateTime': new Date(1512031320000),
    'Category': 'Education',
    'PaymentMode': 'Cash',
    'TransactionType': 'Expense',
    'Description': 'Expense for Education',
    'Amount': '50',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 02:12 PM'
}, {
    'UniqueId': 'T101284',
    'DateTime': new Date(1512033120000),
    'Category': 'Extra income',
    'PaymentMode': 'Cash',
    'TransactionType': 'Income',
    'Description': 'Income from Sale',
    'Amount': '110',
    'MonthShort': 'Nov',
    'MonthFull': 'November, 2017',
    'FormattedDate': '11/30/2017 02:42 PM'
}];
